/*
 * @license
 * Broadcast Theme (c) Invisible Themes
 *
 * This file is included for advanced development by
 * Shopify Agencies.  Modified versions of the theme
 * code are not supported by Shopify or Invisible Themes.
 *
 * In order to use this file you will need to change
 * theme.js to theme.dev.js in /layout/theme.liquid
 *
 */ !(function (t, e, i) {
  "use strict";
  function s() {
    if (document.querySelector("cart-items")) return;
    let t = document.createElement("cart-items");
    document.body.appendChild(t);
  }
  function r(t) {
    let e = t.querySelectorAll(".form-field");
    e.forEach((t) => {
      let e = t.querySelector("label"),
        i = t.querySelector("input, textarea");
      e &&
        i &&
        (i.addEventListener("keyup", (t) => {
          "" !== t.target.value
            ? e.classList.add("label--float")
            : e.classList.remove("label--float");
        }),
        i.value && i.value.length && e.classList.add("label--float"));
    });
  }
  !(function () {
    let t = { NODE_ENV: "production" };
    try {
      if (process) {
        (process.env = Object.assign({}, process.env)),
          Object.assign(process.env, t);
        return;
      }
    } catch (e) {}
    globalThis.process = { env: t };
  })(),
    (window.theme = window.theme || {}),
    (window.theme.sizes = {
      mobile: 480,
      small: 750,
      large: 990,
      widescreen: 1400,
    }),
    (window.theme.focusable =
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
  let o = d();
  function a() {
    let t = {};
    return (
      (t.windowHeight = Math.min(window.screen.height, window.innerHeight)),
      (t.footerHeight = h('[data-section-type*="footer"]')),
      (t.headerHeight = h("[data-header-height]")),
      (t.stickyHeaderHeight = document.querySelector("[data-header-sticky]")
        ? t.headerHeight
        : 0),
      (t.collectionNavHeight = h("[data-collection-nav]")),
      (t.logoHeight = (function t() {
        let e = h("[data-footer-logo]");
        return e > 0 ? e + 20 : 0;
      })()),
      t
    );
  }
  function n() {
    document.addEventListener("theme:resize", c), l();
  }
  function l() {
    let {
      windowHeight: t,
      headerHeight: e,
      logoHeight: i,
      footerHeight: s,
      collectionNavHeight: r,
    } = a();
    document.documentElement.style.setProperty("--full-height", `${t}px`),
      document.documentElement.style.setProperty(
        "--three-quarters",
        `${t * (3 / 4)}px`
      ),
      document.documentElement.style.setProperty(
        "--two-thirds",
        `${t * (2 / 3)}px`
      ),
      document.documentElement.style.setProperty("--one-half", `${t / 2}px`),
      document.documentElement.style.setProperty("--one-third", `${t / 3}px`),
      document.documentElement.style.setProperty(
        "--collection-nav-height",
        `${r}px`
      ),
      document.documentElement.style.setProperty("--header-height", `${e}px`),
      document.documentElement.style.setProperty("--footer-height", `${s}px`),
      document.documentElement.style.setProperty(
        "--content-full",
        `${t - e - i / 2}px`
      ),
      document.documentElement.style.setProperty(
        "--content-min",
        `${t - e - s}px`
      );
  }
  function c() {
    let {
        windowHeight: t,
        headerHeight: e,
        logoHeight: i,
        footerHeight: s,
        collectionNavHeight: r,
      } = a(),
      n = d();
    (n !== o || window.innerWidth > window.theme.sizes.mobile) &&
      (document.documentElement.style.setProperty("--full-height", `${t}px`),
      document.documentElement.style.setProperty(
        "--three-quarters",
        `${t * (3 / 4)}px`
      ),
      document.documentElement.style.setProperty(
        "--two-thirds",
        `${t * (2 / 3)}px`
      ),
      document.documentElement.style.setProperty("--one-half", `${t / 2}px`),
      document.documentElement.style.setProperty("--one-third", `${t / 3}px`),
      (o = n)),
      document.documentElement.style.setProperty(
        "--collection-nav-height",
        `${r}px`
      ),
      document.documentElement.style.setProperty("--header-height", `${e}px`),
      document.documentElement.style.setProperty("--footer-height", `${s}px`),
      document.documentElement.style.setProperty(
        "--content-full",
        `${t - e - i / 2}px`
      ),
      document.documentElement.style.setProperty(
        "--content-min",
        `${t - e - s}px`
      );
  }
  function d() {
    return window.matchMedia("(orientation: portrait)").matches
      ? "portrait"
      : window.matchMedia("(orientation: landscape)").matches
      ? "landscape"
      : void 0;
  }
  function h(t) {
    let e = document.querySelector(t);
    return e ? e.offsetHeight : 0;
  }
  function u(t, e) {
    let i;
    return function () {
      if (t) {
        let s = () => t.apply(this, arguments);
        clearTimeout(i), (i = setTimeout(s, e));
      }
    };
  }
  function p() {
    return (
      document.documentElement.clientWidth ||
      document.body.clientWidth ||
      window.innerWidth
    );
  }
  function m() {
    return (
      document.documentElement.clientHeight ||
      document.body.clientHeight ||
      window.innerHeight
    );
  }
  function g() {
    return p() >= window.theme.sizes.small;
  }
  function b() {
    return p() < window.theme.sizes.small;
  }
  window.initialWindowHeight = Math.min(
    window.screen.height,
    window.innerHeight
  );
  let v = p(),
    f = m(),
    y = window.scrollY,
    S = null,
    w = null,
    L = null,
    E = null,
    k = 0;
  function A() {
    t.clearQueueScrollLocks(),
      t.enablePageScroll(),
      document.documentElement.removeAttribute("data-scroll-locked");
  }
  let C = (t, e = "", i) => {
    let s = i || document.createElement("div");
    return (
      s.classList.add(e), t.parentNode.insertBefore(s, t), s.appendChild(t)
    );
  };
  function q(t) {
    let e = t.querySelectorAll(".rte table");
    e.forEach((t) => {
      C(t, "rte__table-wrapper"),
        t.setAttribute("data-scroll-lock-scrollable", "");
    });
    let i = t.querySelectorAll(
      '.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"], .rte iframe#admin_bar_iframe'
    );
    i.forEach((t) => {
      C(t, "rte__video-wrapper");
    });
  }
  function $(t) {
    let e = t.querySelectorAll("[data-aria-toggle]");
    e.length &&
      e.forEach((t) => {
        t.addEventListener("click", function (t) {
          t.preventDefault();
          let e = t.currentTarget;
          e.setAttribute(
            "aria-expanded",
            "false" == e.getAttribute("aria-expanded") ? "true" : "false"
          );
          let i = e.getAttribute("aria-controls"),
            s = document.querySelector(`#${i}`),
            r = () => {
              s.classList.remove("expanding"),
                s.removeEventListener("transitionend", r);
            },
            o = () => {
              s.classList.add("expanding"),
                s.removeEventListener("transitionstart", o);
            };
          s.addEventListener("transitionstart", o),
            s.addEventListener("transitionend", r),
            s.classList.toggle("expanded");
        });
      });
  }
  let T = { loading: "is-loading" },
    x = { img: "img.is-loading" };
  function P(t, e) {
    e = e || {};
    var i = t.tabIndex;
    function s(r) {
      r.target.removeEventListener(r.type, s),
        (t.tabIndex = i),
        delete t.dataset.tabIndex,
        void 0 !== e.className && t.classList.remove(e.className);
    }
    (t.tabIndex = -1),
      (t.dataset.tabIndex = i),
      t.focus(),
      void 0 !== e.className && t.classList.add(e.className),
      t.addEventListener("blur", s);
  }
  function I(t) {
    return Array.prototype.slice
      .call(
        t.querySelectorAll(
          "[tabindex],[draggable],a[href],area,button:enabled,input:not([type=hidden]):enabled,object,select:enabled,textarea:enabled"
        )
      )
      .filter(function (t) {
        var e, i;
        return !!(
          (t.offsetWidth || t.offsetHeight || t.getClientRects().length) &&
          ((e = t),
          "none" !== (i = window.getComputedStyle(e)).display &&
            "hidden" !== i.visibility)
        );
      });
  }
  var _ = {};
  function H(t, e) {
    e = e || {};
    var i = I(t),
      s = e.elementToFocus || t,
      r = i[0],
      o = i[i.length - 1];
    B(),
      (_.focusin = function (e) {
        t !== e.target &&
          !t.contains(e.target) &&
          r &&
          r === e.target &&
          r.focus(),
          (e.target === t || e.target === o || e.target === r) &&
            document.addEventListener("keydown", _.keydown);
      }),
      (_.focusout = function () {
        document.removeEventListener("keydown", _.keydown);
      }),
      (_.keydown = function (e) {
        "Tab" === e.code &&
          (e.target !== o || e.shiftKey || (e.preventDefault(), r.focus()),
          (e.target === t || e.target === r) &&
            e.shiftKey &&
            (e.preventDefault(), o.focus()));
      }),
      document.addEventListener("focusout", _.focusout),
      document.addEventListener("focusin", _.focusin),
      P(s, e);
  }
  function B() {
    document.removeEventListener("focusin", _.focusin),
      document.removeEventListener("focusout", _.focusout),
      document.removeEventListener("keydown", _.keydown);
  }
  function O() {
    window.a11y.lastElement &&
      document.body.classList.contains("is-focused") &&
      setTimeout(() => {
        window.a11y.lastElement?.focus();
      });
  }
  var M = Object.freeze({
    __proto__: null,
    forceFocus: P,
    focusHash: function t(e) {
      e = e || {};
      var i = window.location.hash,
        s = document.getElementById(i.slice(1));
      if (s && e.ignore && s.matches(e.ignore)) return !1;
      i && s && P(s, e);
    },
    bindInPageLinks: function t(e) {
      var i;
      return (
        (e = e || {}),
        Array.prototype.slice
          .call(document.querySelectorAll('a[href^="#"]'))
          .filter(function (t) {
            if (
              "#" === t.hash ||
              "" === t.hash ||
              (e.ignore && t.matches(e.ignore)) ||
              ((i = t.hash.substr(1)), null === document.getElementById(i))
            )
              return !1;
            var i,
              s = document.querySelector(t.hash);
            return (
              !!s &&
              (t.addEventListener("click", function () {
                P(s, e);
              }),
              !0)
            );
          })
      );
    },
    focusable: I,
    trapFocus: H,
    removeTrapFocus: B,
    autoFocusLastElement: O,
    accessibleLinks: function t(e, i) {
      if ("string" != typeof e) throw TypeError(e + " is not a String.");
      if (0 !== (e = document.querySelectorAll(e)).length) {
        (i = i || {}).messages = i.messages || {};
        var s,
          r,
          o,
          a = {
            newWindow: i.messages.newWindow || "Opens in a new window.",
            external: i.messages.external || "Opens external website.",
            newWindowExternal:
              i.messages.newWindowExternal ||
              "Opens external website in a new window.",
          },
          n = i.prefix || "a11y",
          l = {
            newWindow: n + "-new-window-message",
            external: n + "-external-message",
            newWindowExternal: n + "-new-window-external-message",
          };
        e.forEach(function (t) {
          var e,
            i = t.getAttribute("target"),
            s = t.getAttribute("rel"),
            r = (e = t).hostname !== window.location.hostname,
            o = "_blank" === i,
            a = null === s || -1 === s.indexOf("noopener");
          o &&
            a &&
            t.setAttribute("rel", null === s ? "noopener" : s + " noopener"),
            r && o
              ? t.setAttribute("aria-describedby", l.newWindowExternal)
              : r
              ? t.setAttribute("aria-describedby", l.external)
              : o && t.setAttribute("aria-describedby", l.newWindow);
        }),
          (s = a),
          (r = document.createElement("ul")),
          (o = Object.keys(s).reduce(function (t, e) {
            return t + ("<li id=" + l[e] + ">" + s[e]) + "</li>";
          }, "")),
          r.setAttribute("hidden", !0),
          (r.innerHTML = o),
          document.body.appendChild(r);
      }
    },
  });
  function D(t) {
    return new Promise((e) => {
      function i(s) {
        s.target == t && (t.removeEventListener("animationend", i), e());
      }
      t?.addEventListener("animationend", i);
    });
  }
  let F = {
      drawerInner: "[data-drawer-inner]",
      drawerClose: "[data-drawer-close]",
      drawerMenu: "[data-drawer-menu]",
      underlay: "[data-drawer-underlay]",
      stagger: "[data-stagger-animation]",
      wrapper: "[data-header-wrapper]",
      focusable:
        'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
    },
    N = {
      animated: "drawer--animated",
      open: "is-open",
      closing: "is-closing",
      isFocused: "is-focused",
      headerStuck: "js__header__stuck",
    };
  class W extends HTMLElement {
    constructor() {
      super(),
        (this.isAnimating = !1),
        (this.drawer = this),
        (this.drawerMenu = this.querySelector(F.drawerMenu)),
        (this.drawerInner = this.querySelector(F.drawerInner)),
        (this.underlay = this.querySelector(F.underlay)),
        (this.triggerButton = null),
        (this.staggers = this.querySelectorAll(F.stagger)),
        (this.showDrawer = this.showDrawer.bind(this)),
        (this.hideDrawer = this.hideDrawer.bind(this)),
        this.connectDrawer(),
        this.closers();
    }
    connectDrawer() {
      this.addEventListener("theme:drawer:toggle", (t) => {
        (this.triggerButton = t.detail?.button),
          this.classList.contains(N.open)
            ? this.dispatchEvent(
                new CustomEvent("theme:drawer:close", { bubbles: !0 })
              )
            : this.dispatchEvent(
                new CustomEvent("theme:drawer:open", { bubbles: !0 })
              );
      }),
        this.addEventListener("theme:drawer:close", this.hideDrawer),
        this.addEventListener("theme:drawer:open", this.showDrawer),
        document.addEventListener("theme:cart-drawer:open", this.hideDrawer);
    }
    closers() {
      this.querySelectorAll(F.drawerClose)?.forEach((t) => {
        t.addEventListener("click", () => {
          this.hideDrawer();
        });
      }),
        document.addEventListener("keyup", (t) => {
          "Escape" === t.code && this.hideDrawer();
        }),
        this.underlay.addEventListener("click", () => {
          this.hideDrawer();
        });
    }
    showDrawer() {
      !this.isAnimating &&
        ((this.isAnimating = !0),
        this.triggerButton?.setAttribute("aria-expanded", !0),
        this.classList.add(N.open, N.animated),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:lock", { bubbles: !0 })
        ),
        this.drawerInner &&
          (B(),
          D(this.drawerInner).then(() => {
            (this.isAnimating = !1),
              H(this.drawerInner, {
                elementToFocus: this.querySelector(F.focusable),
              });
          })));
    }
    hideDrawer() {
      !this.isAnimating &&
        this.classList.contains(N.open) &&
        ((this.isAnimating = !0),
        this.classList.add(N.closing),
        this.classList.remove(N.open),
        this.drawerMenu && (this.drawerMenu.style.height = "auto"),
        B(),
        this.triggerButton &&
          (this.triggerButton.setAttribute("aria-expanded", !1),
          document.body.classList.contains(N.isFocused) &&
            this.triggerButton.focus()),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
        ),
        D(this.drawerInner).then(() => {
          this.classList.remove(N.closing, N.animated),
            (this.isAnimating = !1),
            document.dispatchEvent(
              new CustomEvent("theme:sliderule:close", { bubbles: !1 })
            );
        }));
    }
    disconnectedCallback() {
      document.removeEventListener("theme:cart-drawer:open", this.hideDrawer);
    }
  }
  let R = {
      inputSearch: 'input[type="search"]',
      focusedElements: '[aria-selected="true"] a',
      resetButton: 'button[type="reset"]',
    },
    V = { hidden: "hidden" };
  class U extends HTMLElement {
    constructor() {
      super(),
        (this.input = this.querySelector(R.inputSearch)),
        (this.resetButton = this.querySelector(R.resetButton)),
        this.input &&
          (this.input.form.addEventListener(
            "reset",
            this.onFormReset.bind(this)
          ),
          this.input.addEventListener(
            "input",
            u((t) => {
              this.onChange(t);
            }, 300).bind(this)
          ));
    }
    toggleResetButton() {
      let t = this.resetButton.classList.contains(V.hidden);
      this.input.value.length > 0 && t
        ? this.resetButton.classList.remove(V.hidden)
        : 0 !== this.input.value.length ||
          t ||
          this.resetButton.classList.add(V.hidden);
    }
    onChange() {
      this.toggleResetButton();
    }
    shouldResetForm() {
      return !document.querySelector(R.focusedElements);
    }
    onFormReset(t) {
      t.preventDefault(),
        this.shouldResetForm() &&
          ((this.input.value = ""),
          this.toggleResetButton(),
          t.target.querySelector(R.inputSearch).focus());
    }
  }
  customElements.define("header-search-form", U);
  let z = {
      allVisibleElements: '[role="option"]',
      ariaSelected: '[aria-selected="true"]',
      popularSearches: "[data-popular-searches]",
      predictiveSearch: "predictive-search",
      predictiveSearchResults: "[data-predictive-search-results]",
      predictiveSearchStatus: "[data-predictive-search-status]",
      searchInput: 'input[type="search"]',
      searchPopdown: "[data-popdown]",
      searchResultsLiveRegion:
        "[data-predictive-search-live-region-count-value]",
      searchResultsGroupsWrapper: "[data-search-results-groups-wrapper]",
      searchForText: "[data-predictive-search-search-for-text]",
      sectionPredictiveSearch: "#shopify-section-predictive-search",
      selectedLink: '[aria-selected="true"] a',
      selectedOption: '[aria-selected="true"] a, button[aria-selected="true"]',
    },
    j = {
      popoutList: "[data-popout-list]",
      popoutToggle: "[data-popout-toggle]",
      popoutToggleText: "[data-popout-toggle-text]",
      popoutInput: "[data-popout-input]",
      popoutOptions: "[data-popout-option]",
      productGridImage: "[data-product-image]",
      productGridItem: "[data-grid-item]",
      section: "[data-section-type]",
    },
    G = {
      listVisible: "popout-list--visible",
      visible: "is-visible",
      active: "is-active",
      popoutListTop: "popout-list--top",
    },
    J = {
      ariaExpanded: "aria-expanded",
      ariaCurrent: "aria-current",
      dataValue: "data-value",
      popoutToggleText: "data-popout-toggle-text",
      submit: "submit",
    };
  class X extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      (this.popoutList = this.querySelector(j.popoutList)),
        (this.popoutToggle = this.querySelector(j.popoutToggle)),
        (this.popoutToggleText = this.querySelector(j.popoutToggleText)),
        (this.popoutInput = this.querySelector(j.popoutInput)),
        (this.popoutOptions = this.querySelectorAll(j.popoutOptions)),
        (this.productGridItem = this.popoutList.closest(j.productGridItem)),
        (this.fireSubmitEvent = this.hasAttribute(J.submit)),
        (this.popupToggleFocusoutEvent = (t) => this.onPopupToggleFocusout(t)),
        (this.popupListFocusoutEvent = (t) => this.onPopupListFocusout(t)),
        (this.popupToggleClickEvent = (t) => this.onPopupToggleClick(t)),
        (this.keyUpEvent = (t) => this.onKeyUp(t)),
        (this.bodyClickEvent = (t) => this.onBodyClick(t)),
        this._connectOptions(),
        this._connectToggle(),
        this._onFocusOut(),
        this.popupListSetDimensions();
    }
    onPopupToggleClick(t) {
      let e = t.currentTarget,
        i = "true" === e.getAttribute(J.ariaExpanded);
      if (this.productGridItem) {
        let s = this.productGridItem.querySelector(j.productGridImage);
        s && s.classList.toggle(G.visible, !i),
          (this.popoutList.style.maxHeight = `${Math.abs(
            this.popoutToggle.getBoundingClientRect().bottom -
              this.productGridItem.getBoundingClientRect().bottom
          )}px`);
      }
      t.currentTarget.setAttribute(J.ariaExpanded, !i),
        this.popoutList.classList.toggle(G.listVisible),
        this.popupListSetDimensions(),
        this.toggleListPosition(),
        document.body.addEventListener("click", this.bodyClickEvent);
    }
    onPopupToggleFocusout(t) {
      let e = this.contains(t.relatedTarget);
      e || this._hideList();
    }
    onPopupListFocusout(t) {
      let e = t.currentTarget.contains(t.relatedTarget),
        i = this.popoutList.classList.contains(G.listVisible);
      i && !e && this._hideList();
    }
    toggleListPosition() {
      let t = this.querySelector(j.popoutToggle),
        e = "true" === t.getAttribute(J.ariaExpanded),
        i = window.innerHeight,
        s = this.getBoundingClientRect().top,
        r = () => {
          this.popoutList.classList.remove(G.popoutListTop),
            this.popoutList.removeEventListener("transitionend", r);
        };
      e
        ? i / 2 > s && this.popoutList.classList.add(G.popoutListTop)
        : this.popoutList.addEventListener("transitionend", r);
    }
    popupListSetDimensions() {
      this.popoutList.style.setProperty("--max-width", "100vw"),
        this.popoutList.style.setProperty("--max-height", "100vh"),
        requestAnimationFrame(() => {
          this.popoutList.style.setProperty(
            "--max-width",
            `${parseInt(
              document.body.clientWidth -
                this.popoutList.getBoundingClientRect().left
            )}px`
          ),
            this.popoutList.style.setProperty(
              "--max-height",
              `${parseInt(
                window.innerHeight - this.popoutList.getBoundingClientRect().top
              )}px`
            );
        });
    }
    popupOptionsClick(t) {
      let e = t.target.closest(j.popoutOptions);
      if ("#" === e.attributes.href.value) {
        t.preventDefault();
        let i = t.currentTarget.hasAttribute(J.dataValue)
          ? t.currentTarget.getAttribute(J.dataValue)
          : "";
        if (
          ((this.popoutInput.value = i),
          this.popoutInput.disabled &&
            this.popoutInput.removeAttribute("disabled"),
          this.fireSubmitEvent)
        )
          this._submitForm(i);
        else {
          let s = t.currentTarget.parentElement,
            r = this.popoutList.querySelector(`.${G.active}`),
            o = this.popoutList.querySelector(`[${J.ariaCurrent}]`);
          this.popoutInput.dispatchEvent(new Event("change")),
            r && (r.classList.remove(G.active), s.classList.add(G.active)),
            "quantity" != this.popoutInput.name ||
              s.nextSibling ||
              this.classList.add(G.active),
            o &&
              o.hasAttribute(`${J.ariaCurrent}`) &&
              (o.removeAttribute(`${J.ariaCurrent}`),
              t.currentTarget.setAttribute(`${J.ariaCurrent}`, "true")),
            "" !== i &&
              ((this.popoutToggleText.innerHTML = i),
              this.popoutToggleText.hasAttribute(J.popoutToggleText) &&
                "" !== this.popoutToggleText.getAttribute(J.popoutToggleText) &&
                this.popoutToggleText.setAttribute(J.popoutToggleText, i)),
            this.onPopupToggleFocusout(t),
            this.onPopupListFocusout(t);
        }
      }
    }
    onKeyUp(t) {
      "Escape" === t.code && (this._hideList(), this.popoutToggle.focus());
    }
    onBodyClick(t) {
      let e = this.contains(t.target),
        i = this.popoutList.classList.contains(G.listVisible);
      i && !e && this._hideList();
    }
    _connectToggle() {
      this.popoutToggle.addEventListener("click", this.popupToggleClickEvent);
    }
    _connectOptions() {
      this.popoutOptions.length &&
        this.popoutOptions.forEach((t) => {
          t.addEventListener("click", (t) => this.popupOptionsClick(t));
        });
    }
    _onFocusOut() {
      this.addEventListener("keyup", this.keyUpEvent),
        this.popoutToggle.addEventListener(
          "focusout",
          this.popupToggleFocusoutEvent
        ),
        this.popoutList.addEventListener(
          "focusout",
          this.popupListFocusoutEvent
        );
    }
    _submitForm() {
      let t = this.closest("form");
      t && t.submit();
    }
    _hideList() {
      this.popoutList.classList.remove(G.listVisible),
        this.popoutToggle.setAttribute(J.ariaExpanded, !1),
        this.toggleListPosition(),
        document.body.removeEventListener("click", this.bodyClickEvent);
    }
  }
  let Q = {
      aos: "[data-aos]:not(.aos-animate)",
      aosAnchor: "[data-aos-anchor]",
      aosIndividual: "[data-aos]:not([data-aos-anchor]):not(.aos-animate)",
    },
    Y = { aosAnimate: "aos-animate" },
    K = { attributes: !1, childList: !0, subtree: !0 },
    Z = [],
    tt = (t) => {
      for (let e of t)
        if ("childList" === e.type) {
          let i = e.target,
            s = i.querySelectorAll(Q.aos),
            r = i.querySelectorAll(Q.aosAnchor);
          s.length &&
            s.forEach((t) => {
              te.observe(t);
            }),
            r.length && ts(r);
        }
    },
    te = new IntersectionObserver(
      (t, e) => {
        t.forEach((t) => {
          t.isIntersecting &&
            (t.target.classList.add(Y.aosAnimate), e.unobserve(t.target));
        });
      },
      { root: null, rootMargin: "0px", threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] }
    ),
    ti = new IntersectionObserver(
      (t, e) => {
        t.forEach((t) => {
          if (t.intersectionRatio) {
            let i = t.target.querySelectorAll(Q.aos);
            i.length &&
              i.forEach((t) => {
                t.classList.add(Y.aosAnimate);
              }),
              e.unobserve(t.target);
          }
        });
      },
      { root: null, rootMargin: "0px", threshold: [0.1, 0.25, 0.5, 0.75, 1] }
    );
  function ts(t) {
    t.length &&
      t.forEach((t) => {
        let e = t.dataset.aosAnchor;
        if (e && -1 === Z.indexOf(e)) {
          let i = document.querySelector(e);
          i && (ti.observe(i), Z.push(e));
        }
      });
  }
  let tr = {
      deferredMediaButton: "[data-deferred-media-button]",
      media: "video, model-viewer, iframe",
      youtube: '[data-host="youtube"]',
      vimeo: '[data-host="vimeo"]',
      productGridItem: "[data-grid-item]",
      section: ".shopify-section",
      template: "template",
      video: "video",
      productModel: "product-model",
    },
    to = { loaded: "loaded", autoplay: "autoplay" };
  class ta extends HTMLElement {
    constructor() {
      super();
      let t = this.querySelector(tr.deferredMediaButton);
      t?.addEventListener("click", this.loadContent.bind(this)),
        (this.section = this.closest(tr.section)),
        (this.productGridItem = this.closest(tr.productGridItem)),
        (this.hovered = !1),
        (this.mouseEnterEvent = () => this.mouseEnterActions()),
        (this.mouseLeaveEvent = () => this.mouseLeaveActions());
    }
    connectedCallback() {
      this.productGridItem &&
        (this.section.addEventListener("mouseover", this.mouseOverEvent, {
          once: !0,
        }),
        this.addEventListener("mouseenter", this.mouseEnterEvent),
        this.addEventListener("mouseleave", this.mouseLeaveEvent));
    }
    disconnectedCallback() {
      this.productGridItem &&
        (this.section.removeEventListener("mouseover", this.mouseOverEvent, {
          once: !0,
        }),
        this.removeEventListener("mouseenter", this.mouseEnterEvent),
        this.removeEventListener("mouseleave", this.mouseLeaveEvent));
    }
    mouseEnterActions() {
      (this.hovered = !0),
        this.videoActions(),
        this.getAttribute(to.loaded) || this.loadContent();
    }
    mouseLeaveActions() {
      (this.hovered = !1), this.videoActions();
    }
    videoActions() {
      if (this.getAttribute(to.loaded)) {
        let t = this.querySelector(tr.youtube),
          e = this.querySelector(tr.vimeo),
          i = t || e,
          s = this.querySelector(tr.video);
        if (i) {
          let r = this.hovered ? "playVideo" : "pauseVideo",
            o = `{"event":"command","func":"${r}","args":""}`;
          e && (o = `{"method":"${(r = this.hovered ? "play" : "pause")}"}`),
            i.contentWindow.postMessage(o, "*"),
            i.addEventListener("load", (t) => {
              this.videoActions();
            });
        } else s && (this.hovered ? s.play() : s.pause());
      }
    }
    loadContent(t = !0) {
      if ((this.pauseAllMedia(), !this.getAttribute(to.loaded))) {
        let e = document.createElement("div"),
          i = this.querySelector(
            tr.template
          ).content.firstElementChild.cloneNode(!0);
        e.appendChild(i), this.setAttribute(to.loaded, !0);
        let s = this.appendChild(e.querySelector(tr.media));
        t && s.focus(),
          "VIDEO" == s.nodeName && s.getAttribute(to.autoplay) && s.play(),
          this.productGridItem && this.videoActions();
      }
    }
    pauseAllMedia() {
      document.querySelectorAll(tr.youtube).forEach((t) => {
        t.contentWindow.postMessage(
          '{"event":"command","func":"pauseVideo","args":""}',
          "*"
        );
      }),
        document.querySelectorAll(tr.vimeo).forEach((t) => {
          t.contentWindow.postMessage('{"method":"pause"}', "*");
        }),
        document.querySelectorAll(tr.video).forEach((t) => t.pause()),
        document.querySelectorAll(tr.productModel).forEach((t) => {
          t.modelViewerUI && t.modelViewerUI.pause();
        });
    }
  }
  let tn = { visible: "is-visible" };
  class tl {
    constructor(t, e) {
      if (!t || !e) return;
      (this.observer = null),
        (this.container = t),
        (this.itemSelector = e),
        this.init();
    }
    init() {
      let t = { root: this.container, threshold: [0.01, 0.5, 0.75, 0.99] };
      (this.observer = new IntersectionObserver((t) => {
        t.forEach((t) => {
          t.intersectionRatio >= 0.99
            ? t.target.classList.add(tn.visible)
            : t.target.classList.remove(tn.visible);
        });
      }, t)),
        this.container.querySelectorAll(this.itemSelector)?.forEach((t) => {
          this.observer.observe(t);
        });
    }
    destroy() {
      this.observer.disconnect();
    }
  }
  let tc = {
      dragging: "is-dragging",
      enabled: "is-enabled",
      scrolling: "is-scrolling",
      visible: "is-visible",
    },
    td = {
      image: "img, svg",
      productImage: "[data-product-image]",
      slide: "[data-grid-item]",
      slider: "[data-grid-slider]",
    };
  class th {
    constructor(t) {
      (this.slider = t),
        (this.isDown = !1),
        (this.startX = 0),
        (this.scrollLeft = 0),
        (this.velX = 0),
        (this.scrollAnimation = null),
        (this.isScrolling = !1),
        (this.duration = 800),
        (this.scrollStep = this.scrollStep.bind(this)),
        (this.scrollToSlide = this.scrollToSlide.bind(this)),
        (this.handleMouseDown = this.handleMouseDown.bind(this)),
        (this.handleMouseLeave = this.handleMouseLeave.bind(this)),
        (this.handleMouseUp = this.handleMouseUp.bind(this)),
        (this.handleMouseMove = this.handleMouseMove.bind(this)),
        (this.handleMouseWheel = this.handleMouseWheel.bind(this)),
        this.slider.addEventListener("mousedown", this.handleMouseDown),
        this.slider.addEventListener("mouseleave", this.handleMouseLeave),
        this.slider.addEventListener("mouseup", this.handleMouseUp),
        this.slider.addEventListener("mousemove", this.handleMouseMove),
        this.slider.addEventListener("wheel", this.handleMouseWheel, {
          passive: !0,
        }),
        this.slider.classList.add(tc.enabled);
    }
    handleMouseDown(t) {
      t.preventDefault(),
        (this.isDown = !0),
        (this.startX = t.pageX - this.slider.offsetLeft),
        (this.scrollLeft = this.slider.scrollLeft),
        this.cancelMomentumTracking();
    }
    handleMouseLeave() {
      this.isDown && ((this.isDown = !1), this.beginMomentumTracking());
    }
    handleMouseUp() {
      (this.isDown = !1), this.beginMomentumTracking();
    }
    handleMouseMove(t) {
      if (!this.isDown) return;
      t.preventDefault();
      let e = t.pageX - this.slider.offsetLeft,
        i = (e - this.startX) * 1,
        s = this.slider.scrollLeft;
      this.slider.classList.add(tc.dragging, tc.scrolling),
        (this.slider.scrollLeft = this.scrollLeft - i),
        this.slider.scrollLeft !== s &&
          (this.velX = this.slider.scrollLeft - s || (i > 0 ? 1 : -1));
    }
    handleMouseWheel() {
      this.cancelMomentumTracking(), this.slider.classList.remove(tc.scrolling);
    }
    beginMomentumTracking() {
      (this.isScrolling = !1),
        this.slider.classList.remove(tc.dragging),
        this.cancelMomentumTracking(),
        this.scrollToSlide();
    }
    cancelMomentumTracking() {
      cancelAnimationFrame(this.scrollAnimation);
    }
    scrollToSlide() {
      if (!this.velX && !this.isScrolling) return;
      let t = this.slider.querySelector(`${td.slide}.${tc.visible}`);
      if (!t) return;
      let e = parseInt(window.getComputedStyle(t).marginRight) || 0,
        i = t.offsetWidth + e,
        s = t.offsetLeft,
        r = this.velX > 0 ? 1 : -1,
        o = Math.floor(Math.abs(this.velX) / 100) || 1;
      (this.startPosition = this.slider.scrollLeft),
        (this.distance = s - this.startPosition),
        (this.startTime = performance.now()),
        (this.isScrolling = !0),
        r < 0 && this.velX < i && (this.distance -= i * o),
        r > 0 && this.velX < i && (this.distance += i * o),
        (this.scrollAnimation = requestAnimationFrame(this.scrollStep));
    }
    scrollStep() {
      let t = performance.now() - this.startTime,
        e = parseFloat(this.easeOutCubic(Math.min(t, this.duration))).toFixed(
          1
        );
      (this.slider.scrollLeft = e),
        t < this.duration
          ? (this.scrollAnimation = requestAnimationFrame(this.scrollStep))
          : (this.slider.classList.remove(tc.scrolling),
            (this.velX = 0),
            (this.isScrolling = !1));
    }
    easeOutCubic(t) {
      return (
        (t /= this.duration),
        t--,
        this.distance * (t * t * t + 1) + this.startPosition
      );
    }
    destroy() {
      this.slider.classList.remove(tc.enabled),
        this.slider.removeEventListener("mousedown", this.handleMouseDown),
        this.slider.removeEventListener("mouseleave", this.handleMouseLeave),
        this.slider.removeEventListener("mouseup", this.handleMouseUp),
        this.slider.removeEventListener("mousemove", this.handleMouseMove),
        this.slider.removeEventListener("wheel", this.handleMouseWheel);
    }
  }
  let tu = {
      buttonArrow: "[data-button-arrow]",
      collectionImage: "[data-collection-image]",
      columnImage: "[data-column-image]",
      productImage: "[data-product-image]",
      slide: "[data-grid-item]",
      slider: "[data-grid-slider]",
    },
    tp = {
      buttonPrev: "data-button-prev",
      buttonNext: "data-button-next",
      alignArrows: "align-arrows",
    },
    tm = {
      arrows: "slider__arrows",
      visible: "is-visible",
      scrollSnapDisabled: "scroll-snap-disabled",
    };
  class tg extends HTMLElement {
    constructor() {
      super(),
        (this.isInitialized = !1),
        (this.draggableSlider = null),
        (this.positionArrows = this.positionArrows.bind(this)),
        (this.onButtonArrowClick = (t) => this.buttonArrowClickEvent(t)),
        (this.slidesObserver = null),
        (this.firstLastSlidesObserver = null),
        (this.isDragging = !1),
        (this.toggleSlider = this.toggleSlider.bind(this));
    }
    connectedCallback() {
      this.init(), this.addEventListener("theme:grid-slider:init", this.init);
    }
    init() {
      var t;
      (this.slider = this.querySelector(tu.slider)),
        (this.slides = this.querySelectorAll(tu.slide)),
        (this.buttons = this.querySelectorAll(tu.buttonArrow)),
        this.slider.classList.add(tm.scrollSnapDisabled),
        this.toggleSlider(),
        document.addEventListener("theme:resize:width", this.toggleSlider),
        ((t = this),
        new Promise((e, i) => {
          let s = t.querySelectorAll("[data-aos]"),
            r = 0;
          function o(t) {
            ++r === s.length && e(),
              t.target.removeEventListener("animationend", o);
          }
          s.forEach((t) => {
            t.addEventListener("animationend", o);
          }),
            r || i();
        }))
          .then(() => {
            this.slider.classList.remove(tm.scrollSnapDisabled);
          })
          .catch(() => {
            this.slider.classList.remove(tm.scrollSnapDisabled);
          });
    }
    toggleSlider() {
      let t = this.slider.clientWidth,
        e = this.getSlidesWidth();
      if (t < e && (g() || !window.theme.touch)) {
        if (this.isInitialized) return;
        (this.slidesObserver = new tl(this.slider, tu.slide)),
          this.initArrows(),
          (this.isInitialized = !0),
          (this.draggableSlider = new th(this.slider));
      } else this.destroy();
    }
    initArrows() {
      if (!this.buttons.length) {
        let t = document.createElement("div");
        t.classList.add(tm.arrows),
          (t.innerHTML = theme.sliderArrows.prev + theme.sliderArrows.next),
          this.append(t),
          (this.buttons = this.querySelectorAll(tu.buttonArrow)),
          (this.buttonPrev = this.querySelector(`[${tp.buttonPrev}]`)),
          (this.buttonNext = this.querySelector(`[${tp.buttonNext}]`));
      }
      this.toggleArrowsObserver(),
        this.hasAttribute(tp.alignArrows) &&
          (this.positionArrows(), this.arrowsResizeObserver()),
        this.buttons.forEach((t) => {
          t.addEventListener("click", this.onButtonArrowClick);
        });
    }
    buttonArrowClickEvent(t) {
      t.preventDefault();
      let e = this.slider.querySelector(`${tu.slide}.${tm.visible}`),
        i = null;
      t.target.hasAttribute(tp.buttonPrev) && (i = e?.previousElementSibling),
        t.target.hasAttribute(tp.buttonNext) && (i = e?.nextElementSibling),
        this.goToSlide(i);
    }
    removeArrows() {
      this.querySelector(`.${tm.arrows}`)?.remove();
    }
    goToSlide(t) {
      t &&
        this.slider.scrollTo({
          top: 0,
          left: t.offsetLeft,
          behavior: "smooth",
        });
    }
    getSlidesWidth() {
      return (
        this.slider.querySelector(tu.slide)?.clientWidth *
        this.slider.querySelectorAll(tu.slide).length
      );
    }
    toggleArrowsObserver() {
      if (this.buttonPrev && this.buttonNext) {
        let t = this.slides.length,
          e = this.slides[0],
          i = this.slides[t - 1],
          s = { attributes: !0, childList: !1, subtree: !1 },
          r = (t) => {
            for (let s of t)
              if ("attributes" === s.type) {
                let r = s.target,
                  o = Boolean(r.classList.contains(tm.visible));
                r == e && (this.buttonPrev.disabled = o),
                  r == i && (this.buttonNext.disabled = o);
              }
          };
        e &&
          i &&
          ((this.firstLastSlidesObserver = new MutationObserver(r)),
          this.firstLastSlidesObserver.observe(e, s),
          this.firstLastSlidesObserver.observe(i, s));
      }
    }
    positionArrows() {
      let t =
        this.slider.querySelector(tu.productImage) ||
        this.slider.querySelector(tu.collectionImage) ||
        this.slider.querySelector(tu.columnImage) ||
        this.slider;
      t &&
        this.style.setProperty("--button-position", `${t.clientHeight / 2}px`);
    }
    arrowsResizeObserver() {
      document.addEventListener("theme:resize:width", this.positionArrows);
    }
    disconnectedCallback() {
      this.destroy(),
        document.removeEventListener("theme:resize:width", this.toggleSlider);
    }
    destroy() {
      (this.isInitialized = !1),
        this.draggableSlider?.destroy(),
        (this.draggableSlider = null),
        this.slidesObserver?.destroy(),
        (this.slidesObserver = null),
        this.removeArrows(),
        document.removeEventListener("theme:resize:width", this.positionArrows);
    }
  }
  let tb = {
      time: "time",
      days: "[data-days]",
      hours: "[data-hours]",
      minutes: "[data-minutes]",
      seconds: "[data-seconds]",
      shopifySection: ".shopify-section",
      countdownBlock: "[data-countdown-block]",
      tickerText: "[data-ticker-text]",
    },
    tv = {
      expirationBehavior: "data-expiration-behavior",
      clone: "data-clone",
    },
    tf = { showMessage: "show-message", hideCountdown: "hidden" },
    ty = { hideSection: "hide-section", showMessage: "show-message" };
  class tS extends HTMLElement {
    constructor() {
      super(),
        (this.section = this.closest(tb.shopifySection)),
        (this.countdownParent =
          this.closest(tb.countdownBlock) || this.section),
        (this.expirationBehavior = this.getAttribute(tv.expirationBehavior)),
        (this.time = this.querySelector(tb.time)),
        (this.days = this.querySelector(tb.days)),
        (this.hours = this.querySelector(tb.hours)),
        (this.minutes = this.querySelector(tb.minutes)),
        (this.seconds = this.querySelector(tb.seconds)),
        (this.endDate = Date.parse(this.time.dateTime)),
        (this.daysInMs = 864e5),
        (this.hoursInMs = this.daysInMs / 24),
        (this.minutesInMs = this.hoursInMs / 60),
        (this.secondsInMs = this.minutesInMs / 60),
        (this.shouldHideOnComplete =
          this.expirationBehavior === ty.hideSection),
        (this.shouldShowMessage = this.expirationBehavior === ty.showMessage),
        (this.update = this.update.bind(this));
    }
    connectedCallback() {
      if (isNaN(this.endDate) || this.endDate <= Date.now()) {
        this.onComplete();
        return;
      }
      this.update(), (this.interval = setInterval(this.update, 1e3));
    }
    disconnectedCallback() {
      this.stopTimer();
    }
    convertTime(t) {
      let e = this.formatDigits(parseInt(t / this.daysInMs, 10));
      t -= e * this.daysInMs;
      let i = this.formatDigits(parseInt(t / this.hoursInMs, 10));
      t -= i * this.hoursInMs;
      let s = this.formatDigits(parseInt(t / this.minutesInMs, 10));
      t -= s * this.minutesInMs;
      let r = this.formatDigits(parseInt(t / this.secondsInMs, 10));
      return { days: e, hours: i, minutes: s, seconds: r };
    }
    formatDigits(t) {
      return t < 10 && (t = "0" + t), t;
    }
    render(t) {
      (this.days.textContent = t.days),
        (this.hours.textContent = t.hours),
        (this.minutes.textContent = t.minutes),
        (this.seconds.textContent = t.seconds);
    }
    stopTimer() {
      clearInterval(this.interval);
    }
    onComplete() {
      this.render({ days: 0, hours: 0, minutes: 0, seconds: 0 }),
        this.shouldHideOnComplete &&
          (this.countdownParent?.classList.add(tf.hideCountdown),
          this.countdownParent?.dispatchEvent(
            new CustomEvent("theme:countdown:hide", {
              detail: { element: this },
              bubbles: !0,
            })
          )),
        this.shouldShowMessage &&
          (this.classList?.add(tf.showMessage),
          !this.closest(tb.tickerText).hasAttribute(tv.clone) &&
            this.countdownParent?.dispatchEvent(
              new CustomEvent("theme:countdown:expire", { bubbles: !0 })
            ));
    }
    update() {
      let t = new Date().getTime(),
        e = this.endDate - t;
      e < 1e3 && (this.stopTimer(), this.onComplete());
      let i = this.convertTime(e);
      this.render(i);
    }
  }
  let tw = {
      animates: "data-animates",
      drawerMenu: "[data-drawer-menu]",
      links: "[data-links]",
      sliderule: "[data-sliderule]",
      slideruleOpen: "data-sliderule-open",
      slideruleClose: "data-sliderule-close",
      sliderulePane: "data-sliderule-pane",
      drawerContent: "[data-drawer-content]",
      focusable:
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
      children: `:scope > [data-animates],
             :scope > * > [data-animates],
             :scope > * > * > [data-animates],
             :scope > * > .sliderule-grid  > *`,
    },
    tL = {
      isOpen: "is-open",
      isVisible: "is-visible",
      isHiding: "is-hiding",
      isHidden: "is-hidden",
      focused: "is-focused",
      scrolling: "is-scrolling",
    },
    tE = { sliderule: "data-sliderule" };
  class tk extends HTMLElement {
    constructor() {
      super(),
        (this.key = this.id),
        (this.drawerMenu = this.closest(tw.drawerMenu)),
        (this.sliderule = this.querySelector(tw.sliderule));
      let t = `[${tw.slideruleOpen}='${this.key}']`;
      (this.exitSelector = `[${tw.slideruleClose}='${this.key}']`),
        (this.trigger = this.querySelector(t)),
        (this.exit = document.querySelectorAll(this.exitSelector)),
        (this.pane = this.trigger.closest(`[${tw.sliderulePane}]`)),
        (this.childrenElements = this.querySelectorAll(tw.children)),
        (this.drawerContent = this.closest(tw.drawerContent)),
        (this.cachedButton = null),
        (this.accessibility = M),
        this.trigger.setAttribute("aria-haspopup", !0),
        this.trigger.setAttribute("aria-expanded", !1),
        this.trigger.setAttribute("aria-controls", this.key),
        (this.closeSliderule = this.closeSliderule.bind(this)),
        this.clickEvents(),
        this.keyboardEvents(),
        document.addEventListener("theme:sliderule:close", this.closeSliderule);
    }
    clickEvents() {
      this.trigger.addEventListener("click", () => {
        (this.cachedButton = this.trigger), this.showSliderule();
      }),
        this.exit.forEach((t) => {
          t.addEventListener("click", () => {
            this.hideSliderule();
          });
        });
    }
    keyboardEvents() {
      this.addEventListener("keyup", (t) => {
        t.stopPropagation(), "Escape" === t.code && this.hideSliderule();
      });
    }
    trapFocusSliderule(t = !0) {
      let e = t ? this.querySelector(this.exitSelector) : this.cachedButton;
      this.accessibility.removeTrapFocus(),
        e &&
          this.drawerContent &&
          this.accessibility.trapFocus(this.drawerContent, {
            elementToFocus: document.body.classList.contains(tL.focused)
              ? e
              : null,
          });
    }
    hideSliderule(t = !1) {
      let e = parseInt(this.pane.dataset.sliderulePane, 10) - 1;
      this.pane.setAttribute(tw.sliderulePane, e),
        this.pane.classList.add(tL.isHiding),
        this.sliderule.classList.add(tL.isHiding);
      let i = t ? `[${tw.animates}].${tL.isHidden}` : `[${tw.animates}="${e}"]`,
        s = this.pane.querySelectorAll(i);
      s.length &&
        s.forEach((t) => {
          t.classList.remove(tL.isHidden);
        });
      let r = this.closest("header-drawer").classList.contains(tL.isOpen);
      if (e > 0 && r) {
        let o = this.sliderule.closest(`[${tE.sliderule}="${e}"]`),
          a = o.querySelector(tw.links).scrollHeight;
        setTimeout(() => {
          this.drawerMenu.style.height = `${a}px`;
        }, 500);
      } else
        setTimeout(() => {
          this.drawerMenu.style.height = "auto";
        }, 500);
      let n = t
        ? this.pane.querySelectorAll(`.${tL.isVisible}, .${tL.isHiding}`)
        : this.childrenElements;
      n.forEach((i, s) => {
        let r = n.length - 1 == s;
        i.classList.remove(tL.isVisible),
          t &&
            (i.classList.remove(tL.isHiding),
            this.pane.classList.remove(tL.isHiding));
        let o = () => {
          parseInt(this.pane.getAttribute(tw.sliderulePane)) === e &&
            this.sliderule.classList.remove(tL.isVisible),
            this.sliderule.classList.remove(tL.isHiding),
            this.pane.classList.remove(tL.isHiding),
            r &&
              (this.accessibility.removeTrapFocus(),
              t || this.trapFocusSliderule(!1)),
            i.removeEventListener("animationend", o);
        };
        window.theme.settings.enableAnimations
          ? i.addEventListener("animationend", o)
          : o();
      });
    }
    showSliderule() {
      let t = null,
        e = this.closest(`.${tL.isVisible}`),
        i = this.pane;
      e && (i = e),
        i.scrollTo({ top: 0, left: 0, behavior: "smooth" }),
        i.classList.add(tL.scrolling);
      let s = () => {
        i.scrollTop <= 0
          ? (i.classList.remove(tL.scrolling), t && cancelAnimationFrame(t))
          : (t = requestAnimationFrame(s));
      };
      t = requestAnimationFrame(s);
      let r = parseInt(this.pane.dataset.sliderulePane, 10),
        o = r + 1;
      if (
        (this.sliderule.classList.add(tL.isVisible),
        this.pane.setAttribute(tw.sliderulePane, o),
        o > 0)
      ) {
        let a = this.sliderule.scrollHeight;
        this.drawerMenu.style.height = `${a}px`;
      }
      let n = this.pane.querySelectorAll(`[${tw.animates}="${r}"]`);
      n.length &&
        n.forEach((t, e) => {
          let i = n.length - 1 == e;
          t.classList.add(tL.isHiding);
          let s = () => {
            t.classList.remove(tL.isHiding),
              parseInt(this.pane.getAttribute(tw.sliderulePane)) !== r &&
                t.classList.add(tL.isHidden),
              i && this.trapFocusSliderule(),
              t.removeEventListener("animationend", s);
          };
          window.theme.settings.enableAnimations
            ? t.addEventListener("animationend", s)
            : s();
        });
    }
    closeSliderule() {
      this.pane &&
        this.pane.hasAttribute(tw.sliderulePane) &&
        parseInt(this.pane.getAttribute(tw.sliderulePane)) > 0 &&
        (this.hideSliderule(!0),
        parseInt(this.pane.getAttribute(tw.sliderulePane)) > 0 &&
          this.pane.setAttribute(tw.sliderulePane, 0));
    }
    disconnectedCallback() {
      document.removeEventListener(
        "theme:sliderule:close",
        this.closeSliderule
      );
    }
  }
  (window.requestIdleCallback =
    window.requestIdleCallback ||
    function (t) {
      var e = Date.now();
      return setTimeout(function () {
        t({
          didTimeout: !1,
          timeRemaining: function () {
            return Math.max(0, 50 - (Date.now() - e));
          },
        });
      }, 1);
    }),
    (window.cancelIdleCallback =
      window.cancelIdleCallback ||
      function (t) {
        clearTimeout(t);
      }),
    window.theme.settings.enableAnimations &&
      ((function t() {
        let e = document.querySelectorAll(Q.aosIndividual);
        e.length &&
          e.forEach((t) => {
            te.observe(t);
          });
      })(),
      (function t() {
        let e = document.querySelectorAll(Q.aosAnchor);
        e.length && ts(e);
      })(),
      (function t() {
        let e = new MutationObserver(tt);
        e.observe(document.body, K);
      })(),
      document.addEventListener("shopify:section:unload", (t) => {
        let e = "#" + t.target.querySelector("[data-section-id]")?.id,
          i = Z.indexOf(e);
        -1 !== i && Z.splice(i, 1);
      })),
    window.addEventListener(
      "resize",
      u(function () {
        document.dispatchEvent(
          new CustomEvent("theme:resize", { bubbles: !0 })
        ),
          v !== p() &&
            (document.dispatchEvent(
              new CustomEvent("theme:resize:width", { bubbles: !0 })
            ),
            (v = p())),
          f !== m() &&
            (document.dispatchEvent(
              new CustomEvent("theme:resize:height", { bubbles: !0 })
            ),
            (f = m()));
      }, 50)
    );
  let tA;
  window.addEventListener(
    "scroll",
    function () {
      tA && window.cancelAnimationFrame(tA),
        (tA = window.requestAnimationFrame(function () {
          !(function t() {
            let e = window.scrollY;
            e > y
              ? ((w = !0), (S = !1))
              : e < y
              ? ((w = !1), (S = !0))
              : ((S = null), (w = null)),
              (y = e),
              document.dispatchEvent(
                new CustomEvent("theme:scroll", {
                  detail: { up: S, down: w, position: e },
                  bubbles: !1,
                })
              ),
              S &&
                !L &&
                document.dispatchEvent(
                  new CustomEvent("theme:scroll:up", {
                    detail: { position: e },
                    bubbles: !1,
                  })
                ),
              w &&
                !E &&
                document.dispatchEvent(
                  new CustomEvent("theme:scroll:down", {
                    detail: { position: e },
                    bubbles: !1,
                  })
                ),
              (E = w),
              (L = S);
          })();
        }));
    },
    { passive: !0 }
  ),
    window.addEventListener("theme:scroll:lock", function e(i) {
      setTimeout(() => {
        k && clearTimeout(k),
          t.disablePageScroll(i.detail, {
            allowTouchMove: (t) => "TEXTAREA" === t.tagName,
          }),
          document.documentElement.setAttribute("data-scroll-locked", "");
      });
    }),
    window.addEventListener("theme:scroll:unlock", function t(e) {
      let i = e.detail;
      i ? (k = setTimeout(A, i)) : A();
    }),
    "ontouchstart" in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
      ? ((document.documentElement.className =
          document.documentElement.className.replace(
            "no-touch",
            "supports-touch"
          )),
        (window.theme.touch = !0))
      : (window.theme.touch = !1),
    l(),
    document.addEventListener(
      "load",
      (t) => {
        "img" == t.target.tagName.toLowerCase() &&
          t.target.classList.contains(T.loading) &&
          (t.target.classList.remove(T.loading),
          t.target.parentNode.classList.remove(T.loading),
          t.target.parentNode.parentNode.classList.contains(T.loading) &&
            t.target.parentNode.parentNode.classList.remove(T.loading));
      },
      !0
    ),
    window.addEventListener("DOMContentLoaded", () => {
      n(),
        $(document),
        r(document),
        q(document),
        (function t(e) {
          e.querySelectorAll(x.img).forEach((t) => {
            t.complete &&
              (t.classList.remove(T.loading),
              t.parentNode.classList.remove(T.loading),
              t.parentNode.parentNode.classList.contains(T.loading) &&
                t.parentNode.parentNode.classList.remove(T.loading));
          });
        })(document),
        document.body.classList.add("is-loaded"),
        s(),
        requestIdleCallback(() => {
          Shopify.visualPreviewMode &&
            document.documentElement.classList.add("preview-mode");
        });
    }),
    document.addEventListener("shopify:section:load", (t) => {
      let e = t.target;
      r(e), q(e), $(document), n();
    }),
    customElements.get("header-drawer") ||
      customElements.define("header-drawer", W),
    customElements.get("mobile-sliderule") ||
      customElements.define("mobile-sliderule", tk),
    customElements.get("popout-select") ||
      customElements.define("popout-select", X),
    customElements.get("predictive-search") ||
      customElements.define(
        "predictive-search",
        class t extends U {
          constructor() {
            super(),
              (this.a11y = M),
              (this.abortController = new AbortController()),
              (this.allPredictiveSearchInstances = document.querySelectorAll(
                z.predictiveSearch
              )),
              (this.cachedResults = {}),
              (this.input = this.querySelector(z.searchInput)),
              (this.isOpen = !1),
              (this.predictiveSearchResults = this.querySelector(
                z.predictiveSearchResults
              )),
              (this.searchPopdown = this.closest(z.searchPopdown)),
              (this.popularSearches = this.searchPopdown?.querySelector(
                z.popularSearches
              )),
              (this.searchTerm = "");
          }
          connectedCallback() {
            this.input.addEventListener("focus", this.onFocus.bind(this)),
              this.input.form.addEventListener(
                "submit",
                this.onFormSubmit.bind(this)
              ),
              this.addEventListener("focusout", this.onFocusOut.bind(this)),
              this.addEventListener("keyup", this.onKeyup.bind(this)),
              this.addEventListener("keydown", this.onKeydown.bind(this));
          }
          getQuery() {
            return this.input.value.trim();
          }
          onChange() {
            super.onChange();
            let t = this.getQuery();
            if (
              ((this.searchTerm && t.startsWith(this.searchTerm)) ||
                this.querySelector(z.searchResultsGroupsWrapper)?.remove(),
              this.updateSearchForTerm(this.searchTerm, t),
              (this.searchTerm = t),
              !this.searchTerm.length)
            ) {
              this.reset();
              return;
            }
            this.getSearchResults(this.searchTerm);
          }
          onFormSubmit(t) {
            (!this.getQuery().length || this.querySelector(z.selectedLink)) &&
              t.preventDefault();
          }
          onFormReset(t) {
            super.onFormReset(t),
              super.shouldResetForm() &&
                ((this.searchTerm = ""),
                this.abortController.abort(),
                (this.abortController = new AbortController()),
                this.closeResults(!0));
          }
          shouldResetForm() {
            return !document.querySelector(z.selectedLink);
          }
          onFocus() {
            let t = this.getQuery();
            t.length &&
              (this.searchTerm !== t
                ? this.onChange()
                : "true" === this.getAttribute("results")
                ? this.open()
                : this.getSearchResults(this.searchTerm));
          }
          onFocusOut() {
            setTimeout(() => {
              this.contains(document.activeElement) || this.close();
            });
          }
          onKeyup(t) {
            switch (
              (this.getQuery().length || this.close(!0),
              t.preventDefault(),
              t.code)
            ) {
              case "ArrowUp":
                this.switchOption("up");
                break;
              case "ArrowDown":
                this.switchOption("down");
                break;
              case "Enter":
                this.selectOption();
            }
          }
          onKeydown(t) {
            ("ArrowUp" === t.code || "ArrowDown" === t.code) &&
              t.preventDefault();
          }
          updateSearchForTerm(t, e) {
            let i = this.querySelector(z.searchForText),
              s = i?.innerText;
            if (s) {
              if (s.match(RegExp(t, "g"))?.length > 1) return;
              let r = s.replace(t, e);
              i.innerText = r;
            }
          }
          switchOption(t) {
            if (!this.getAttribute("open")) return;
            let e = "up" === t,
              i = this.querySelector(z.ariaSelected),
              s = Array.from(
                this.querySelectorAll(z.allVisibleElements)
              ).filter((t) => null !== t.offsetParent),
              r = 0;
            if (e && !i) return;
            let o = -1,
              a = 0;
            for (; -1 === o && a <= s.length; ) s[a] === i && (o = a), a++;
            if (
              ((this.statusElement.textContent = ""),
              !e && i
                ? (r = o === s.length - 1 ? 0 : o + 1)
                : e && (r = 0 === o ? s.length - 1 : o - 1),
              r === o)
            )
              return;
            let n = s[r];
            n.setAttribute("aria-selected", !0),
              i && i.setAttribute("aria-selected", !1),
              this.input.setAttribute("aria-activedescendant", n.id);
          }
          selectOption() {
            let t = this.querySelector(z.selectedOption);
            t && t.click();
          }
          getSearchResults(t) {
            let e = t.replace(" ", "-").toLowerCase();
            if ((this.setLiveRegionLoadingState(), this.cachedResults[e])) {
              this.renderSearchResults(this.cachedResults[e]);
              return;
            }
            fetch(
              `${theme.routes.predictive_search_url}?q=${encodeURIComponent(
                t
              )}&section_id=predictive-search`,
              { signal: this.abortController.signal }
            )
              .then((t) => {
                if (!t.ok) {
                  var e = Error(t.status);
                  throw (this.close(), e);
                }
                return t.text();
              })
              .then((t) => {
                let i = new DOMParser()
                  .parseFromString(t, "text/html")
                  .querySelector(z.sectionPredictiveSearch).innerHTML;
                this.allPredictiveSearchInstances.forEach((t) => {
                  t.cachedResults[e] = i;
                }),
                  this.renderSearchResults(i);
              })
              .catch((t) => {
                if (t?.code !== 20) throw (this.close(), t);
              });
          }
          setLiveRegionLoadingState() {
            (this.statusElement =
              this.statusElement ||
              this.querySelector(z.predictiveSearchStatus)),
              (this.loadingText =
                this.loadingText || this.getAttribute("data-loading-text")),
              this.setLiveRegionText(this.loadingText),
              this.setAttribute("loading", !0);
          }
          setLiveRegionText(t) {
            this.statusElement.setAttribute("aria-hidden", "false"),
              (this.statusElement.textContent = t),
              setTimeout(() => {
                this.statusElement.setAttribute("aria-hidden", "true");
              }, 1e3);
          }
          renderSearchResults(t) {
            (this.predictiveSearchResults.innerHTML = t),
              this.setAttribute("results", !0),
              this.setLiveRegionResults(),
              this.open();
          }
          setLiveRegionResults() {
            this.removeAttribute("loading"),
              this.setLiveRegionText(
                this.querySelector(z.searchResultsLiveRegion).textContent
              );
          }
          open() {
            this.setAttribute("open", !0),
              this.input.setAttribute("aria-expanded", !0),
              (this.isOpen = !0),
              this.predictiveSearchResults.style.setProperty(
                "--full-screen",
                `${window.visualViewport.height}px`
              );
          }
          close(t = !1) {
            this.closeResults(t),
              (this.isOpen = !1),
              this.predictiveSearchResults.style.removeProperty(
                "--full-screen"
              );
          }
          closeResults(t = !1) {
            t && ((this.input.value = ""), this.removeAttribute("results"));
            let e = this.querySelector(z.ariaSelected);
            e && e.setAttribute("aria-selected", !1),
              this.input.setAttribute("aria-activedescendant", ""),
              this.removeAttribute("loading"),
              this.removeAttribute("open"),
              this.input.setAttribute("aria-expanded", !1),
              this.predictiveSearchResults?.removeAttribute("style");
          }
          reset() {
            (this.predictiveSearchResults.innerHTML = ""),
              (this.input.val = ""),
              this.a11y.removeTrapFocus(),
              this.popularSearches &&
                (this.input.dispatchEvent(new Event("blur", { bubbles: !1 })),
                this.a11y.trapFocus(this.searchPopdown, {
                  elementToFocus: this.input,
                }));
          }
        }
      ),
    customElements.get("deferred-media") ||
      customElements.define("deferred-media", ta),
    customElements.get("grid-slider") ||
      customElements.define("grid-slider", tg),
    customElements.get("countdown-timer") ||
      customElements.define("countdown-timer", tS),
    (Shopify.Products = (function () {
      let t = {
          howManyToShow: 4,
          howManyToStoreInMemory: 10,
          wrapperId: "recently-viewed-products",
          section: null,
          target: "api-product-grid-item",
          onComplete: null,
        },
        e = [],
        i = null,
        s = null,
        r = new Date(),
        o = new Date();
      o.setTime(r.getTime() + 7776e6);
      let a = {
          configuration: {
            expires: o.toGMTString(),
            path: "/",
            domain: window.location.hostname,
            sameSite: "none",
            secure: !0,
          },
          name: "shopify_recently_viewed",
          write: function (t) {
            let e = encodeURIComponent(t.join(" "));
            document.cookie = `${this.name}=${e}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`;
          },
          read: function () {
            let t = [],
              e = null;
            return (
              -1 !== document.cookie.indexOf("; ") &&
                document.cookie
                  .split("; ")
                  .find((t) => t.startsWith(this.name)) &&
                (e = document.cookie
                  .split("; ")
                  .find((t) => t.startsWith(this.name))
                  .split("=")[1]),
              null !== e && (t = decodeURIComponent(e).split(" ")),
              t
            );
          },
          destroy: function () {
            document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`;
          },
          remove: function (t) {
            let e = this.read(),
              i = e.indexOf(t);
            -1 !== i && (e.splice(i, 1), this.write(e));
          },
        },
        n = (e, i) => {
          e.classList.remove("hidden");
          let r = a.read().length;
          if (Shopify.recentlyViewed && s && r && r < s && e.children.length) {
            let o = [],
              n = [],
              l = 0;
            for (let c in Shopify.recentlyViewed) {
              l += 1;
              let d = Shopify.recentlyViewed[c],
                h = d.split(" "),
                u = parseInt(c.split("_")[1]);
              (o = [...o, ...h]),
                (a.read().length !== u &&
                  (l !== Object.keys(Shopify.recentlyViewed).length ||
                    n.length)) ||
                  (n = [...n, ...h]);
            }
            for (let p = 0; p < e.children.length; p++) {
              let m = e.children[p];
              o.length && m.classList.remove(...o),
                n.length && m.classList.add(...n);
            }
          }
          if (t.onComplete)
            try {
              t.onComplete(e, i);
            } catch (g) {
              console.log(g);
            }
        },
        l = (t, e, i, s, r, o) => {
          e.length && t < o
            ? fetch(
                `${window.theme.routes.root}products/${e[0]}?section_id=${r}`
              )
                .then((t) => t.text())
                .then((a) => {
                  let n = 100 * t,
                    c = i.id ? `#${i.id}` : "",
                    d = document.createElement("div"),
                    h = a;
                  (h = (h = h.includes("||itemAnimationDelay||")
                    ? h.replaceAll("||itemAnimationDelay||", n)
                    : h).includes("||itemAnimationAnchor||")
                    ? h.replaceAll("||itemAnimationAnchor||", c)
                    : h),
                    (d.innerHTML = h),
                    (i.innerHTML +=
                      d.querySelector("[data-api-content]").innerHTML),
                    e.shift(),
                    l(++t, e, i, s, r, o);
                })
                .catch(() => {
                  a.remove(e[0]), e.shift(), l(t, e, i, s, r, o);
                })
            : n(i, s);
        };
      return {
        showRecentlyViewed: function (r) {
          Object.assign(t, r || {}),
            (e = a.read()),
            (i = document.querySelector(`#${t.wrapperId}`)),
            (s = t.howManyToShow),
            (t.howManyToShow = Math.min(e.length, t.howManyToShow)),
            t.howManyToShow && i && l(0, e, i, t.section, t.target, s);
        },
        getConfig: function () {
          return t;
        },
        clearList: function () {
          a.destroy();
        },
        recordRecentlyViewed: function (e) {
          Object.assign(t, e || {});
          let i = a.read();
          if (-1 !== window.location.pathname.indexOf("/products/")) {
            let s = decodeURIComponent(window.location.pathname)
              .match(
                /\/products\/([a-z0-9\-]|[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|[\u203B]|[\w\u0430-\u044f]|[\u0400-\u04FF]|[\u0900-\u097F]|[\u0590-\u05FF\u200f\u200e]|[\u0621-\u064A\u0660-\u0669 ])+/
              )[0]
              .split("/products/")[1];
            t.handle && (s = t.handle);
            let r = i.indexOf(s);
            -1 === r
              ? (i.unshift(s), (i = i.splice(0, t.howManyToStoreInMemory)))
              : (i.splice(r, 1), i.unshift(s)),
              a.write(i);
          }
        },
        hasProducts: a.read().length > 0,
      };
    })());
  let tC = { focus: "is-focused" },
    tq = {
      inPageLink: "[data-skip-content]",
      linkesWithOnlyHash: 'a[href="#"]',
    };
  function t$(t, e) {
    "string" == typeof t && (t = t.replace(".", ""));
    let i = "",
      s = /\{\{\s*(\w+)\s*\}\}/,
      r = e || "${{amount}}";
    function o(t, e = 2, i = ",", s = ".") {
      if (isNaN(t) || null == t) return 0;
      t = (t / 100).toFixed(e);
      let r = t.split("."),
        o = r[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${i}`),
        a = r[1] ? s + r[1] : "";
      return o + a;
    }
    switch (r.match(s)[1]) {
      case "amount":
        i = o(t, 2);
        break;
      case "amount_no_decimals":
        i = o(t, 0);
        break;
      case "amount_with_comma_separator":
        i = o(t, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        i = o(t, 0, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        i = o(t, 2, "'", ".");
        break;
      case "amount_no_decimals_with_space_separator":
        i = o(t, 0, " ", "");
        break;
      case "amount_with_space_separator":
        i = o(t, 2, " ", ",");
        break;
      case "amount_with_period_and_space_separator":
        i = o(t, 2, " ", ".");
    }
    return r.replace(s, i);
  }
  window.a11y = new (class t {
    constructor() {
      this.init();
    }
    init() {
      (this.a11y = M),
        (this.html = document.documentElement),
        (this.body = document.body),
        (this.inPageLink = document.querySelector(tq.inPageLink)),
        (this.linkesWithOnlyHash = document.querySelectorAll(
          tq.linkesWithOnlyHash
        )),
        this.a11y.focusHash(),
        this.a11y.bindInPageLinks(),
        this.clickEvents(),
        this.focusEvents();
    }
    clickEvents() {
      this.inPageLink &&
        this.inPageLink.addEventListener("click", (t) => {
          t.preventDefault();
        }),
        this.linkesWithOnlyHash &&
          this.linkesWithOnlyHash.forEach((t) => {
            t.addEventListener("click", (t) => {
              t.preventDefault();
            });
          });
    }
    focusEvents() {
      document.addEventListener("mousedown", () => {
        this.body.classList.remove(tC.focus);
      }),
        document.addEventListener("keyup", (t) => {
          "Tab" === t.code && this.body.classList.add(tC.focus);
        });
    }
  })();
  let tT = (t, e) => {
    let i, s;
    return function r(...o) {
      let a = Date.now();
      (s = clearTimeout(s)),
        !i || a - i >= e
          ? (t.apply(null, o), (i = a))
          : (s = setTimeout(r.bind(null, ...o), e - (a - i)));
    };
  };
  function tx(t) {
    (this.status = t.status || null),
      (this.headers = t.headers || null),
      (this.json = t.json || null),
      (this.body = t.body || null);
  }
  tx.prototype = Error.prototype;
  let tP = {
      animated: "is-animated",
      active: "is-active",
      added: "is-added",
      disabled: "is-disabled",
      empty: "is-empty",
      error: "has-error",
      headerStuck: "js__header__stuck",
      hidden: "is-hidden",
      hiding: "is-hiding",
      loading: "is-loading",
      open: "is-open",
      removed: "is-removed",
      success: "is-success",
      visible: "is-visible",
      expanded: "is-expanded",
      updated: "is-updated",
      variantSoldOut: "variant--soldout",
      variantUnavailable: "variant--unavailable",
    },
    tI = {
      apiContent: "[data-api-content]",
      apiLineItems: "[data-api-line-items]",
      apiUpsellItems: "[data-api-upsell-items]",
      apiCartPrice: "[data-api-cart-price]",
      animation: "[data-animation]",
      additionalCheckoutButtons: ".additional-checkout-buttons",
      buttonSkipUpsellProduct: "[data-skip-upsell-product]",
      cartBarAdd: "[data-add-to-cart-bar]",
      cartCloseError: "[data-cart-error-close]",
      cartDrawer: "cart-drawer",
      cartDrawerClose: "[data-cart-drawer-close]",
      cartEmpty: "[data-cart-empty]",
      cartErrors: "[data-cart-errors]",
      cartItemRemove: "[data-item-remove]",
      cartPage: "[data-cart-page]",
      cartForm: "[data-cart-form]",
      cartTermsCheckbox: "[data-cart-acceptance-checkbox]",
      cartCheckoutButtonWrapper: "[data-cart-checkout-buttons]",
      cartCheckoutButton: "[data-cart-checkout-button]",
      cartTotal: "[data-cart-total]",
      checkoutButtons: "[data-checkout-buttons]",
      errorMessage: "[data-error-message]",
      formCloseError: "[data-close-error]",
      formErrorsContainer: "[data-cart-errors-container]",
      formWrapper: "[data-form-wrapper]",
      freeShipping: "[data-free-shipping]",
      freeShippingGraph: "[data-progress-graph]",
      freeShippingProgress: "[data-progress-bar]",
      headerWrapper: "[data-header-wrapper]",
      item: "[data-item]",
      itemsHolder: "[data-items-holder]",
      leftToSpend: "[data-left-to-spend]",
      navDrawer: "[data-drawer]",
      outerSection: "[data-section-id]",
      priceHolder: "[data-cart-price-holder]",
      quickAddHolder: "[data-quick-add-holder]",
      quickAddModal: "[data-quick-add-modal]",
      qtyInput: 'input[name="updates[]"]',
      upsellProductsHolder: "[data-upsell-products]",
      upsellWidget: "[data-upsell-widget]",
      termsErrorMessage: "[data-terms-error-message]",
      collapsibleBody: "[data-collapsible-body]",
      recentlyViewedHolderId: "recently-viewed-products-cart",
      noscript: "noscript",
    },
    t_ = {
      cartTotal: "data-cart-total",
      disabled: "disabled",
      freeShipping: "data-free-shipping",
      freeShippingLimit: "data-free-shipping-limit",
      item: "data-item",
      itemIndex: "data-item-index",
      itemTitle: "data-item-title",
      open: "open",
      quickAddHolder: "data-quick-add-holder",
      quickAddVariant: "data-quick-add-variant",
      scrollLocked: "data-scroll-locked",
      upsellAutoOpen: "data-upsell-auto-open",
      name: "name",
    };
  class tH extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      (this.cartPage = document.querySelector(tI.cartPage)),
        (this.cartForm = document.querySelector(tI.cartForm)),
        (this.cartDrawer = document.querySelector(tI.cartDrawer)),
        (this.cartEmpty = document.querySelector(tI.cartEmpty)),
        (this.cartTermsCheckbox = document.querySelector(tI.cartTermsCheckbox)),
        (this.cartCheckoutButtonWrapper = document.querySelector(
          tI.cartCheckoutButtonWrapper
        )),
        (this.cartCheckoutButton = document.querySelector(
          tI.cartCheckoutButton
        )),
        (this.checkoutButtons = document.querySelector(tI.checkoutButtons)),
        (this.itemsHolder = document.querySelector(tI.itemsHolder)),
        (this.priceHolder = document.querySelector(tI.priceHolder)),
        (this.items = document.querySelectorAll(tI.item)),
        (this.cartTotal = document.querySelector(tI.cartTotal)),
        (this.freeShipping = document.querySelectorAll(tI.freeShipping)),
        (this.cartErrorHolder = document.querySelector(tI.cartErrors)),
        (this.cartCloseErrorMessage = document.querySelector(
          tI.cartCloseError
        )),
        (this.headerWrapper = document.querySelector(tI.headerWrapper)),
        (this.navDrawer = document.querySelector(tI.navDrawer)),
        (this.upsellProductsHolder = document.querySelector(
          tI.upsellProductsHolder
        )),
        (this.subtotal = window.theme.subtotal),
        (this.cart = this.cartDrawer || this.cartPage),
        (this.animateItems = this.animateItems.bind(this)),
        (this.addToCart = this.addToCart.bind(this)),
        (this.cartAddEvent = this.cartAddEvent.bind(this)),
        (this.updateProgress = this.updateProgress.bind(this)),
        (this.onCartDrawerClose = this.onCartDrawerClose.bind(this)),
        document.addEventListener("theme:cart:add", this.cartAddEvent),
        document.addEventListener(
          "theme:announcement:init",
          this.updateProgress
        ),
        "drawer" == theme.settings.cartType &&
          (document.addEventListener(
            "theme:cart-drawer:open",
            this.animateItems
          ),
          document.addEventListener(
            "theme:cart-drawer:close",
            this.onCartDrawerClose
          )),
        (this.skipUpsellProductsArray = []),
        this.skipUpsellProductEvent(),
        this.checkSkippedUpsellProductsFromStorage(),
        this.toggleCartUpsellWidgetVisibility(),
        (this.circumference = 28 * Math.PI),
        (this.freeShippingLimit = this.freeShipping.length
          ? 100 *
            Number(this.freeShipping[0].getAttribute(t_.freeShippingLimit)) *
            window.Shopify.currency.rate
          : 0),
        this.freeShippingMessageHandle(this.subtotal),
        this.updateProgress(),
        (this.build = this.build.bind(this)),
        (this.updateCart = this.updateCart.bind(this)),
        (this.productAddCallback = this.productAddCallback.bind(this)),
        (this.formSubmitHandler = tT(this.formSubmitHandler.bind(this), 50)),
        this.cartPage && this.animateItems(),
        this.cart &&
          (this.recentlyViewedProducts(),
          (this.hasItemsInCart = this.hasItemsInCart.bind(this)),
          (this.cartCount = this.getCartItemCount())),
        (this.toggleClassesOnContainers =
          this.toggleClassesOnContainers.bind(this)),
        (this.totalItems = this.items.length),
        (this.cartUpdateFailed = !1),
        this.cartEvents(),
        this.cartRemoveEvents(),
        this.cartUpdateEvents(),
        document.addEventListener("theme:product:add", this.productAddCallback),
        document.addEventListener(
          "theme:product:add-error",
          this.productAddCallback
        ),
        document.addEventListener(
          "theme:cart:refresh",
          this.getCart.bind(this)
        ),
        document.dispatchEvent(
          new CustomEvent("theme:cart:load", { bubbles: !0 })
        );
    }
    disconnectedCallback() {
      document.removeEventListener("theme:cart:add", this.cartAddEvent),
        document.removeEventListener("theme:cart:refresh", this.cartAddEvent),
        document.removeEventListener(
          "theme:announcement:init",
          this.updateProgress
        ),
        document.removeEventListener(
          "theme:product:add",
          this.productAddCallback
        ),
        document.removeEventListener(
          "theme:product:add-error",
          this.productAddCallback
        ),
        document.dispatchEvent(
          new CustomEvent("theme:cart:unload", { bubbles: !0 })
        ),
        document.documentElement.hasAttribute(t_.scrollLocked) &&
          document.dispatchEvent(
            new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
          );
    }
    onCartDrawerClose() {
      this.resetAnimatedItems(),
        this.cartDrawer?.classList.contains(tP.open) &&
          this.cart.classList.remove(tP.updated),
        this.cartEmpty.classList.remove(tP.updated),
        this.cartErrorHolder.classList.remove(tP.expanded),
        this.cart.querySelectorAll(tI.animation).forEach((t) => {
          let e = () => {
            t.classList.remove(tP.hiding),
              t.removeEventListener("animationend", e);
          };
          t.classList.add(tP.hiding), t.addEventListener("animationend", e);
        });
    }
    cartUpdateEvents() {
      (this.items = document.querySelectorAll(tI.item)),
        this.items.forEach((t) => {
          t.addEventListener("theme:cart:update", (e) => {
            this.updateCart(
              { id: e.detail.id, quantity: e.detail.quantity },
              t
            );
          });
        });
    }
    cartRemoveEvents() {
      let t = document.querySelectorAll(tI.cartItemRemove);
      t.forEach((t) => {
        let e = t.closest(tI.item);
        t.addEventListener("click", (i) => {
          i.preventDefault(),
            t.classList.contains(tP.disabled) ||
              this.updateCart({ id: t.dataset.id, quantity: 0 }, e);
        });
      }),
        this.cartCloseErrorMessage &&
          this.cartCloseErrorMessage.addEventListener("click", (t) => {
            t.preventDefault(),
              this.cartErrorHolder.classList.remove(tP.expanded);
          });
    }
    cartAddEvent(t) {
      let e = "",
        i = t.detail.button;
      if (i.hasAttribute("disabled")) return;
      let s = i.closest("form");
      if (!s.checkValidity()) {
        s.reportValidity();
        return;
      }
      e = new FormData(s);
      let r = [...s.elements].some((t) => t.closest(tI.noscript));
      r && (e = this.handleFormDataDuplicates([...s.elements], e)),
        !(null !== s && s.querySelector('[type="file"]')) &&
          ("drawer" === theme.settings.cartType &&
            this.cartDrawer &&
            t.preventDefault(),
          this.addToCart(e, i));
    }
    handleFormDataDuplicates(t, e) {
      return (
        t.length &&
          "object" == typeof e &&
          t.forEach((t) => {
            if (t.closest(tI.noscript)) {
              let i = t.getAttribute(t_.name),
                s = t.value;
              if (i) {
                let r = e.getAll(i);
                r.length > 1 && r.splice(r.indexOf(s), 1),
                  e.delete(i),
                  e.set(i, r[0]);
              }
            }
          }),
        e
      );
    }
    cartEvents() {
      this.cartTermsCheckbox &&
        (this.cartTermsCheckbox.removeEventListener(
          "change",
          this.formSubmitHandler
        ),
        this.cartCheckoutButtonWrapper.removeEventListener(
          "click",
          this.formSubmitHandler
        ),
        this.cartForm.removeEventListener("submit", this.formSubmitHandler),
        this.cartTermsCheckbox.addEventListener(
          "change",
          this.formSubmitHandler
        ),
        this.cartCheckoutButtonWrapper.addEventListener(
          "click",
          this.formSubmitHandler
        ),
        this.cartForm.addEventListener("submit", this.formSubmitHandler));
    }
    formSubmitHandler() {
      let t = document.querySelector(tI.cartTermsCheckbox).checked,
        e = document.querySelector(tI.termsErrorMessage);
      if (t)
        e.classList.remove(tP.expanded),
          this.cartCheckoutButton.removeAttribute(t_.disabled);
      else {
        if (document.querySelector(tI.termsErrorMessage).length > 0) return;
        (e.innerText = theme.strings.cartAcceptanceError),
          this.cartCheckoutButton.setAttribute(t_.disabled, !0),
          e.classList.add(tP.expanded);
      }
    }
    formErrorsEvents(t) {
      let e = t.querySelector(tI.formCloseError);
      e?.addEventListener("click", (e) => {
        e.preventDefault(), t && t.classList.remove(tP.visible);
      });
    }
    getCart() {
      fetch(theme.routes.cart_url + "?section_id=api-cart-items")
        .then(this.cartErrorsHandler)
        .then((t) => t.text())
        .then((t) => {
          let e = document.createElement("div");
          e.innerHTML = t;
          let i = e.querySelector(tI.apiContent);
          this.build(i);
        })
        .catch((t) => console.log(t));
    }
    addToCart(t, e) {
      this.cart && this.cart.classList.add(tP.loading);
      let i = e?.closest(tI.quickAddHolder);
      e && (e.classList.add(tP.loading), (e.disabled = !0)),
        i && i.classList.add(tP.visible),
        fetch(theme.routes.cart_add_url, {
          method: "POST",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            Accept: "application/javascript",
          },
          body: t,
        })
          .then((t) => t.json())
          .then((t) => {
            if (t.status) {
              this.addToCartError(t, e),
                e && (e.classList.remove(tP.loading), (e.disabled = !1));
              return;
            }
            this.cart
              ? (e &&
                  (e.classList.remove(tP.loading),
                  e.classList.add(tP.added),
                  e.dispatchEvent(
                    new CustomEvent("theme:product:add", {
                      detail: { response: t, button: e },
                      bubbles: !0,
                    })
                  )),
                "page" === theme.settings.cartType &&
                  (window.location = theme.routes.cart_url),
                this.getCart())
              : (window.location = theme.routes.cart_url);
          })
          .catch((t) => {
            this.addToCartError(t, e), this.enableCartButtons();
          });
    }
    updateCart(t = {}, e = null) {
      this.cart.classList.add(tP.loading);
      let i = t.quantity;
      null !== e &&
        (i ? e.classList.add(tP.loading) : e.classList.add(tP.removed)),
        this.disableCartButtons();
      let s = this.cart.querySelector(`[${t_.item}="${t.id}"]`) || e,
        r = s?.hasAttribute(t_.itemIndex)
          ? parseInt(s.getAttribute(t_.itemIndex))
          : 0,
        o = s?.hasAttribute(t_.itemTitle) ? s.getAttribute(t_.itemTitle) : null;
      0 !== r &&
        fetch(theme.routes.cart_change_url, {
          method: "post",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ line: r, quantity: i }),
        })
          .then((t) => t.text())
          .then((t) => {
            let i = JSON.parse(t);
            if (i.errors) {
              (this.cartUpdateFailed = !0),
                this.updateErrorText(o),
                this.toggleErrorMessage(),
                this.resetLineItem(e),
                this.enableCartButtons();
              return;
            }
            this.getCart();
          })
          .catch((t) => {
            console.log(t), this.enableCartButtons();
          });
    }
    resetLineItem(t) {
      let e = t.querySelector(tI.qtyInput),
        i = e.getAttribute("value");
      (e.value = i), t.classList.remove(tP.loading);
    }
    disableCartButtons() {
      let t = this.cart.querySelectorAll("input"),
        e = this.cart.querySelectorAll(`button, ${tI.cartItemRemove}`);
      t.length &&
        t.forEach((t) => {
          t.classList.add(tP.disabled), t.blur(), (t.disabled = !0);
        }),
        e.length &&
          e.forEach((t) => {
            t.setAttribute(t_.disabled, !0);
          });
    }
    enableCartButtons() {
      let t = this.cart.querySelectorAll("input"),
        e = this.cart.querySelectorAll(`button, ${tI.cartItemRemove}`);
      t.length &&
        t.forEach((t) => {
          t.classList.remove(tP.disabled), (t.disabled = !1);
        }),
        e.length &&
          e.forEach((t) => {
            t.removeAttribute(t_.disabled);
          }),
        this.cart.classList.remove(tP.loading);
    }
    updateErrorText(t) {
      this.cartErrorHolder.querySelector(tI.errorMessage).innerText = t;
    }
    toggleErrorMessage() {
      this.cartErrorHolder &&
        (this.cartErrorHolder.classList.toggle(
          tP.expanded,
          this.cartUpdateFailed
        ),
        (this.cartUpdateFailed = !1));
    }
    cartErrorsHandler(t) {
      return t.ok
        ? t
        : t.json().then(function (e) {
            let i = new tx({
              status: t.statusText,
              headers: t.headers,
              json: e,
            });
            throw i;
          });
    }
    addToCartError(t, e) {
      if (null !== e) {
        let i =
            e.closest(tI.outerSection) ||
            e.closest(tI.quickAddHolder) ||
            e.closest(tI.quickAddModal),
          s = i?.querySelector(tI.formErrorsContainer),
          r = e.closest(tI.quickAddHolder);
        if (
          (r &&
            r.querySelector(tI.formErrorsContainer) &&
            (s = r.querySelector(tI.formErrorsContainer)),
          s)
        ) {
          let o = `${t.message}: ${t.description}`;
          t.message == t.description && (o = t.message),
            (s.innerHTML = `<div class="errors">${o}<button type="button" class="errors__close" data-close-error><svg aria-hidden="true" focusable="false" role="presentation" width="24px" height="24px" stroke-width="1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor" class="icon icon-cancel"><path d="M6.758 17.243L12.001 12m5.243-5.243L12 12m0 0L6.758 6.757M12.001 12l5.243 5.243" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path></svg></button></div>`),
            s.classList.add(tP.visible),
            this.formErrorsEvents(s);
        }
        e.dispatchEvent(
          new CustomEvent("theme:product:add-error", {
            detail: { response: t, button: e },
            bubbles: !0,
          })
        );
      }
      let a = e?.closest(tI.quickAddHolder);
      a &&
        a.dispatchEvent(
          new CustomEvent("theme:cart:error", {
            bubbles: !0,
            detail: {
              message: t.message,
              description: t.description,
              holder: a,
            },
          })
        ),
        this.cart?.classList.remove(tP.loading);
    }
    productAddCallback(t) {
      let e = [],
        i = null,
        s = "theme:product:add-error" == t.type,
        r = t.detail.button,
        o = document.querySelector(tI.cartBarAdd);
      e.push(r),
        (i = r.closest(tI.quickAddHolder)),
        o && e.push(o),
        e.forEach((t) => {
          t.classList.remove(tP.loading), s || t.classList.add(tP.added);
        }),
        setTimeout(() => {
          e.forEach((t) => {
            t.classList.remove(tP.added);
            let e =
              t
                .closest(tI.formWrapper)
                ?.classList.contains(tP.variantSoldOut) ||
              t
                .closest(tI.formWrapper)
                ?.classList.contains(tP.variantUnavailable);
            e || (t.disabled = !1);
          }),
            i?.classList.remove(tP.visible);
        }, 1e3);
    }
    toggleClassesOnContainers() {
      let t = this.hasItemsInCart();
      this.cart.classList.toggle(tP.empty, !t),
        !t &&
          this.cartDrawer &&
          setTimeout(() => {
            H(this.cartDrawer, {
              elementToFocus: this.cartDrawer.querySelector(tI.cartDrawerClose),
            });
          }, 100);
    }
    build(t) {
      let e = t.querySelector(tI.apiLineItems),
        i = t.querySelector(tI.apiUpsellItems),
        s = Boolean(null === e && null === i),
        r = t.querySelector(tI.apiCartPrice),
        o = t.querySelector(tI.cartTotal);
      this.priceHolder && r && (this.priceHolder.innerHTML = r.innerHTML),
        s
          ? ((this.itemsHolder.innerHTML = t.innerHTML),
            this.upsellProductsHolder &&
              (this.upsellProductsHolder.innerHTML = ""))
          : ((this.itemsHolder.innerHTML = e.innerHTML),
            this.upsellProductsHolder &&
              (this.upsellProductsHolder.innerHTML = i.innerHTML),
            this.skipUpsellProductEvent(),
            this.checkSkippedUpsellProductsFromStorage(),
            this.toggleCartUpsellWidgetVisibility()),
        (this.newTotalItems =
          e && e.querySelectorAll(tI.item).length
            ? e.querySelectorAll(tI.item).length
            : 0),
        (this.subtotal =
          o && o.hasAttribute(t_.cartTotal)
            ? parseInt(o.getAttribute(t_.cartTotal))
            : 0),
        (this.cartCount = this.getCartItemCount()),
        document.dispatchEvent(
          new CustomEvent("theme:cart:change", {
            bubbles: !0,
            detail: { cartCount: this.cartCount },
          })
        ),
        (this.cartTotal.innerHTML =
          0 === this.subtotal
            ? window.theme.strings.free
            : t$(this.subtotal, theme.moneyWithCurrencyFormat)),
        this.totalItems !== this.newTotalItems &&
          ((this.totalItems = this.newTotalItems),
          this.toggleClassesOnContainers()),
        this.cartDrawer?.classList.contains(tP.open) &&
          this.cart.classList.add(tP.updated),
        this.cart.classList.remove(tP.loading),
        this.hasItemsInCart() ||
          this.cartEmpty.querySelectorAll(tI.animation).forEach((t) => {
            t.classList.remove(tP.animated);
          }),
        this.freeShippingMessageHandle(this.subtotal),
        this.cartRemoveEvents(),
        this.cartUpdateEvents(),
        this.toggleErrorMessage(),
        this.enableCartButtons(),
        this.updateProgress(),
        this.animateItems(),
        document.dispatchEvent(
          new CustomEvent("theme:product:added", { bubbles: !0 })
        );
    }
    getCartItemCount() {
      return Array.from(this.cart.querySelectorAll(tI.qtyInput)).reduce(
        (t, e) => t + parseInt(e.value),
        0
      );
    }
    hasItemsInCart() {
      return this.totalItems > 0;
    }
    freeShippingMessageHandle(t) {
      this.freeShipping.length &&
        this.freeShipping.forEach((e) => {
          let i =
            e.hasAttribute(t_.freeShipping) &&
            "true" === e.getAttribute(t_.freeShipping) &&
            t >= 0;
          e.classList.toggle(tP.success, i && t >= this.freeShippingLimit);
        });
    }
    updateProgress() {
      if (
        ((this.freeShipping = document.querySelectorAll(tI.freeShipping)),
        !this.freeShipping.length)
      )
        return;
      let t = isNaN(this.subtotal / this.freeShippingLimit)
          ? 100
          : this.subtotal / this.freeShippingLimit,
        e = Math.min(100 * t, 100),
        i = this.circumference - ((e / 100) * this.circumference) / 2,
        s = t$(this.freeShippingLimit - this.subtotal, theme.moneyFormat);
      this.freeShipping.forEach((t) => {
        let r = t.querySelector(tI.freeShippingProgress),
          o = t.querySelector(tI.freeShippingGraph),
          a = t.querySelector(tI.leftToSpend);
        a && (a.innerHTML = s.replace(".00", "")),
          r && (r.value = e),
          o && o.style.setProperty("--stroke-dashoffset", `${i}`);
      });
    }
    skipUpsellProductEvent() {
      if (null === this.upsellProductsHolder) return;
      let t = this.upsellProductsHolder.querySelectorAll(
        tI.buttonSkipUpsellProduct
      );
      t.length &&
        t.forEach((t) => {
          t.addEventListener("click", (e) => {
            e.preventDefault();
            let i = t
              .closest(tI.quickAddHolder)
              .getAttribute(t_.quickAddHolder);
            this.skipUpsellProductsArray.includes(i) ||
              this.skipUpsellProductsArray.push(i),
              window.sessionStorage.setItem(
                "skip_upsell_products",
                this.skipUpsellProductsArray
              ),
              this.removeUpsellProduct(i),
              this.toggleCartUpsellWidgetVisibility();
          });
        });
    }
    checkSkippedUpsellProductsFromStorage() {
      let t = window.sessionStorage.getItem("skip_upsell_products");
      if (!t) return;
      let e = t.split(",");
      e.forEach((t) => {
        this.skipUpsellProductsArray.includes(t) ||
          this.skipUpsellProductsArray.push(t),
          this.removeUpsellProduct(t);
      });
    }
    removeUpsellProduct(t) {
      if (!this.upsellProductsHolder) return;
      let e = this.upsellProductsHolder.querySelector(
        `[${t_.quickAddHolder}="${t}"]`
      );
      e && e.parentNode.remove();
    }
    toggleCartUpsellWidgetVisibility() {
      if (!this.upsellProductsHolder) return;
      let t = this.upsellProductsHolder.querySelectorAll(tI.quickAddHolder),
        e = this.upsellProductsHolder.closest(tI.upsellWidget);
      if (
        e &&
        (e.classList.toggle(tP.hidden, !t.length),
        t.length &&
          !e.hasAttribute(t_.open) &&
          e.hasAttribute(t_.upsellAutoOpen))
      ) {
        e.setAttribute(t_.open, !0);
        let i = e.querySelector(tI.collapsibleBody);
        i && (i.style.height = "auto");
      }
    }
    resetAnimatedItems() {
      this.cart.querySelectorAll(tI.animation).forEach((t) => {
        t.classList.remove(tP.animated), t.classList.remove(tP.hiding);
      });
    }
    animateItems(t) {
      requestAnimationFrame(() => {
        let e = this.cart;
        t && t.detail && t.detail.target && (e = t.detail.target),
          e?.querySelectorAll(tI.animation).forEach((t) => {
            t.classList.add(tP.animated);
          });
      });
    }
    recentlyViewedProducts() {
      let t = this.cart.querySelector(`#${tI.recentlyViewedHolderId}`);
      t &&
        Shopify.Products.showRecentlyViewed({
          howManyToShow: 3,
          wrapperId: tI.recentlyViewedHolderId,
          section: this,
          target: "api-upsell-product",
        });
    }
  }
  customElements.get("cart-items") || customElements.define("cart-items", tH);
  let tB = { count: "data-cart-count", limit: "data-limit" };
  class tO extends HTMLElement {
    constructor() {
      super(),
        (this.cartCount = null),
        (this.limit = this.getAttribute(tB.limit)),
        (this.onCartChangeCallback = this.onCartChange.bind(this));
    }
    connectedCallback() {
      document.addEventListener("theme:cart:change", this.onCartChangeCallback);
    }
    disconnectedCallback() {
      document.addEventListener("theme:cart:change", this.onCartChangeCallback);
    }
    onCartChange(t) {
      (this.cartCount = t.detail.cartCount), this.update();
    }
    update() {
      if (null !== this.cartCount) {
        this.setAttribute(tB.count, this.cartCount);
        let t = this.cartCount;
        this.limit && this.cartCount >= this.limit && (t = "9+"),
          (this.innerText = t);
      }
    }
  }
  customElements.get("cart-count") || customElements.define("cart-count", tO);
  let tM = {
      open: "is-open",
      closing: "is-closing",
      duplicate: "drawer--duplicate",
      drawerEditorError: "drawer-editor-error",
    },
    tD = {
      cartDrawer: "cart-drawer",
      cartDrawerClose: "[data-cart-drawer-close]",
      cartDrawerSection: '[data-section-type="cart-drawer"]',
      cartDrawerInner: "[data-cart-drawer-inner]",
      shopifySection: ".shopify-section",
    },
    t8 = { drawerUnderlay: "data-drawer-underlay" };
  class t9 extends HTMLElement {
    constructor() {
      super(),
        (this.cartDrawerIsOpen = !1),
        (this.cartDrawerClose = this.querySelector(tD.cartDrawerClose)),
        (this.cartDrawerInner = this.querySelector(tD.cartDrawerInner)),
        (this.openCartDrawer = this.openCartDrawer.bind(this)),
        (this.closeCartDrawer = this.closeCartDrawer.bind(this)),
        (this.toggleCartDrawer = this.toggleCartDrawer.bind(this)),
        (this.openCartDrawerOnProductAdded =
          this.openCartDrawerOnProductAdded.bind(this)),
        (this.openCartDrawerOnSelect = this.openCartDrawerOnSelect.bind(this)),
        (this.closeCartDrawerOnDeselect =
          this.closeCartDrawerOnDeselect.bind(this)),
        (this.cartDrawerSection = this.closest(tD.shopifySection)),
        this.closeCartEvents();
    }
    connectedCallback() {
      let t = this.closest(tD.shopifySection);
      if (window.theme.hasCartDrawer) {
        if (window.Shopify.designMode) {
          let e = document.createElement("div");
          e.classList.add(tM.drawerEditorError),
            (e.innerText = "Cart drawer section already exists."),
            this.querySelector(`.${tM.drawerEditorError}`) ||
              this.querySelector(tD.cartDrawerInner).append(e),
            this.classList.add(tM.duplicate);
        } else {
          t.remove();
          return;
        }
      }
      (window.theme.hasCartDrawer = !0),
        this.addEventListener("theme:cart-drawer:show", this.openCartDrawer),
        document.addEventListener("theme:cart:toggle", this.toggleCartDrawer),
        document.addEventListener("theme:quick-add:open", this.closeCartDrawer),
        document.addEventListener(
          "theme:product:added",
          this.openCartDrawerOnProductAdded
        ),
        document.addEventListener(
          "shopify:block:select",
          this.openCartDrawerOnSelect
        ),
        document.addEventListener(
          "shopify:section:select",
          this.openCartDrawerOnSelect
        ),
        document.addEventListener(
          "shopify:section:deselect",
          this.closeCartDrawerOnDeselect
        );
    }
    disconnectedCallback() {
      document.removeEventListener(
        "theme:product:added",
        this.openCartDrawerOnProductAdded
      ),
        document.removeEventListener(
          "theme:cart:toggle",
          this.toggleCartDrawer
        ),
        document.removeEventListener(
          "theme:quick-add:open",
          this.closeCartDrawer
        ),
        document.removeEventListener(
          "shopify:block:select",
          this.openCartDrawerOnSelect
        ),
        document.removeEventListener(
          "shopify:section:select",
          this.openCartDrawerOnSelect
        ),
        document.removeEventListener(
          "shopify:section:deselect",
          this.closeCartDrawerOnDeselect
        ),
        document.querySelectorAll(tD.cartDrawer).length <= 1 &&
          (window.theme.hasCartDrawer = !1),
        s();
    }
    openCartDrawerOnProductAdded() {
      this.cartDrawerIsOpen || this.openCartDrawer();
    }
    openCartDrawerOnSelect(t) {
      let e =
        t.target.querySelector(tD.shopifySection) ||
        t.target.closest(tD.shopifySection) ||
        t.target;
      e === this.cartDrawerSection && this.openCartDrawer(!0);
    }
    closeCartDrawerOnDeselect() {
      this.cartDrawerIsOpen && this.closeCartDrawer();
    }
    openCartDrawer(t = !1) {
      (!t && this.classList.contains(tM.duplicate)) ||
        ((this.cartDrawerIsOpen = !0),
        (this.onBodyClickEvent =
          this.onBodyClickEvent || this.onBodyClick.bind(this)),
        document.body.addEventListener("click", this.onBodyClickEvent),
        document.dispatchEvent(
          new CustomEvent("theme:cart-drawer:open", {
            detail: { target: this },
            bubbles: !0,
          })
        ),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:lock", { bubbles: !0 })
        ),
        this.classList.add(tM.open),
        this.observeAdditionalCheckoutButtons(),
        D(this.cartDrawerInner).then(() => {
          H(this, { elementToFocus: this.querySelector(tD.cartDrawerClose) });
        }));
    }
    closeCartDrawer() {
      this.classList.contains(tM.open) &&
        (this.classList.add(tM.closing),
        this.classList.remove(tM.open),
        (this.cartDrawerIsOpen = !1),
        document.dispatchEvent(
          new CustomEvent("theme:cart-drawer:close", { bubbles: !0 })
        ),
        B(),
        O(),
        document.body.removeEventListener("click", this.onBodyClickEvent),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
        ),
        D(this.cartDrawerInner).then(() => {
          this.classList.remove(tM.closing);
        }));
    }
    toggleCartDrawer() {
      this.cartDrawerIsOpen ? this.closeCartDrawer() : this.openCartDrawer();
    }
    closeCartEvents() {
      this.cartDrawerClose.addEventListener("click", (t) => {
        t.preventDefault(), this.closeCartDrawer();
      }),
        this.addEventListener("keyup", (t) => {
          "Escape" === t.code && this.closeCartDrawer();
        });
    }
    onBodyClick(t) {
      t.target.hasAttribute(t8.drawerUnderlay) && this.closeCartDrawer();
    }
    observeAdditionalCheckoutButtons() {
      let t = this.querySelector(tD.additionalCheckoutButtons);
      if (t) {
        let e = new MutationObserver(() => {
          H(this, { elementToFocus: this.querySelector(tD.cartDrawerClose) }),
            e.disconnect();
        });
        e.observe(t, { subtree: !0, childList: !0 });
      }
    }
  }
  customElements.get("cart-drawer") || customElements.define("cart-drawer", t9);
  let tF = {
      collapsible: "[data-collapsible]",
      trigger: "[data-collapsible-trigger]",
      body: "[data-collapsible-body]",
      content: "[data-collapsible-content]",
    },
    tN = {
      desktop: "desktop",
      disabled: "disabled",
      mobile: "mobile",
      open: "open",
      single: "single",
    };
  class tW extends HTMLElement {
    constructor() {
      super(),
        (this.collapsibles = this.querySelectorAll(tF.collapsible)),
        (this.single = this.hasAttribute(tN.single)),
        (this.toggle = this.toggle.bind(this));
    }
    connectedCallback() {
      this.toggle(),
        document.addEventListener("theme:resize:width", this.toggle),
        this.collapsibles.forEach((t) => {
          let e = t.querySelector(tF.trigger),
            i = t.querySelector(tF.body);
          e?.addEventListener("click", (t) => this.onCollapsibleClick(t)),
            i?.addEventListener("transitionend", (e) => {
              e.target === i &&
                ("true" == t.getAttribute(tN.open) &&
                  this.setBodyHeight(i, "auto"),
                "false" == t.getAttribute(tN.open) &&
                  (t.removeAttribute(tN.open), this.setBodyHeight(i, "")));
            });
        });
    }
    disconnectedCallback() {
      document.removeEventListener("theme:resize:width", this.toggle);
    }
    toggle() {
      let t = g();
      this.collapsibles.forEach((e) => {
        if (!e.hasAttribute(tN.desktop) && !e.hasAttribute(tN.mobile)) return;
        let i = e.hasAttribute(tN.desktop)
            ? e.getAttribute(tN.desktop)
            : "true",
          s = e.hasAttribute(tN.mobile) ? e.getAttribute(tN.mobile) : "true",
          r = e.querySelector(tF.body);
        (t && "true" == i) || (!t && "true" == s)
          ? (e.removeAttribute(tN.disabled),
            e.querySelector(tF.trigger).removeAttribute("tabindex"),
            e.removeAttribute(tN.open),
            this.setBodyHeight(r, ""))
          : (e.setAttribute(tN.disabled, ""),
            e.setAttribute("open", !0),
            e.querySelector(tF.trigger).setAttribute("tabindex", -1));
      });
    }
    open(t) {
      if ("true" == t.getAttribute("open")) return;
      let e = t.querySelector(tF.body),
        i = t.querySelector(tF.content);
      t.setAttribute("open", !0), this.setBodyHeight(e, i.offsetHeight);
    }
    close(t) {
      if (!t.hasAttribute("open")) return;
      let e = t.querySelector(tF.body),
        i = t.querySelector(tF.content);
      this.setBodyHeight(e, i.offsetHeight),
        t.setAttribute("open", !1),
        setTimeout(() => {
          requestAnimationFrame(() => {
            this.setBodyHeight(e, 0);
          });
        });
    }
    setBodyHeight(t, e) {
      t.style.height = "auto" !== e && "" !== e ? `${e}px` : e;
    }
    onCollapsibleClick(t) {
      t.preventDefault();
      let e = t.target,
        i = e.closest(tF.collapsible);
      this.single &&
        this.collapsibles.forEach((t) => {
          t.hasAttribute(tN.open) &&
            t != i &&
            requestAnimationFrame(() => {
              this.close(t);
            });
        }),
        i.hasAttribute(tN.open) ? this.close(i) : this.open(i),
        i.dispatchEvent(
          new CustomEvent("theme:form:sticky", {
            bubbles: !0,
            detail: { element: "accordion" },
          })
        ),
        i.dispatchEvent(
          new CustomEvent("theme:collapsible:toggle", { bubbles: !0 })
        );
    }
  }
  customElements.get("collapsible-elements") ||
    customElements.define("collapsible-elements", tW);
  let tR = {
      details: "details",
      popdown: "[data-popdown]",
      popdownClose: "[data-popdown-close]",
      input: 'input:not([type="hidden"])',
      mobileMenu: "mobile-menu",
    },
    tV = {
      popdownUnderlay: "data-popdown-underlay",
      scrollLocked: "data-scroll-locked",
    },
    tU = { open: "is-open" };
  class tz extends HTMLElement {
    constructor() {
      super(),
        (this.popdown = this.querySelector(tR.popdown)),
        (this.popdownContainer = this.querySelector(tR.details)),
        (this.popdownClose = this.querySelector(tR.popdownClose)),
        (this.popdownTransitionCallback =
          this.popdownTransitionCallback.bind(this)),
        (this.detailsToggleCallback = this.detailsToggleCallback.bind(this)),
        (this.mobileMenu = this.closest(tR.mobileMenu)),
        (this.a11y = M);
    }
    connectedCallback() {
      this.popdown.addEventListener(
        "transitionend",
        this.popdownTransitionCallback
      ),
        this.popdownContainer.addEventListener(
          "keyup",
          (t) => "ESCAPE" === t.code.toUpperCase() && this.close()
        ),
        this.popdownContainer.addEventListener(
          "toggle",
          this.detailsToggleCallback
        ),
        this.popdownClose.addEventListener("click", this.close.bind(this));
    }
    detailsToggleCallback(t) {
      t.target.hasAttribute("open") && this.open();
    }
    popdownTransitionCallback(t) {
      t.target === this.popdown &&
        (this.classList.contains(tU.open)
          ? ("transform" === t.propertyName || "opacity" === t.propertyName) &&
            this.a11y.trapFocus(this.popdown, {
              elementToFocus: this.popdown.querySelector(tR.input),
            })
          : (this.popdownContainer.removeAttribute("open"),
            this.a11y.removeTrapFocus()));
    }
    onBodyClick(t) {
      (!this.contains(t.target) || t.target.hasAttribute(tV.popdownUnderlay)) &&
        this.close();
    }
    open() {
      (this.onBodyClickEvent =
        this.onBodyClickEvent || this.onBodyClick.bind(this)),
        document.body.addEventListener("click", this.onBodyClickEvent),
        this.mobileMenu?.dispatchEvent(new CustomEvent("theme:search:open")),
        document.documentElement.hasAttribute(tV.scrollLocked) ||
          document.dispatchEvent(
            new CustomEvent("theme:scroll:lock", { bubbles: !0 })
          ),
        requestAnimationFrame(() => {
          this.classList.add(tU.open);
        });
    }
    close() {
      this.classList.remove(tU.open),
        this.mobileMenu?.dispatchEvent(new CustomEvent("theme:search:close")),
        document.body.removeEventListener("click", this.onBodyClickEvent),
        this.mobileMenu ||
          document.dispatchEvent(
            new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
          );
    }
  }
  customElements.define("header-search-popdown", tz),
    customElements.define(
      "main-search",
      class t extends U {
        constructor() {
          super(),
            (this.allSearchInputs = document.querySelectorAll(
              'input[type="search"]'
            )),
            this.setupEventListeners();
        }
        setupEventListeners() {
          let t = [];
          this.allSearchInputs.forEach((e) => t.push(e.form)),
            this.input.addEventListener("focus", this.onInputFocus.bind(this)),
            t.length < 2 ||
              (t.forEach((t) =>
                t.addEventListener("reset", this.onFormReset.bind(this))
              ),
              this.allSearchInputs.forEach((t) =>
                t.addEventListener("input", this.onInput.bind(this))
              ));
        }
        onFormReset(t) {
          super.onFormReset(t),
            super.shouldResetForm() && this.keepInSync("", this.input);
        }
        onInput(t) {
          let e = t.target;
          this.keepInSync(e.value, e);
        }
        onInputFocus() {
          g() || this.scrollIntoView({ behavior: "smooth" });
        }
        keepInSync(t, e) {
          this.allSearchInputs.forEach((i) => {
            i !== e && (i.value = t);
          });
        }
      }
    );
  let t0 = {
      actions: "[data-actions]",
      content: "[data-content]",
      trigger: "[data-button]",
    },
    tj = { open: "is-open", enabled: "is-enabled" };
  class t3 extends HTMLElement {
    constructor() {
      super(),
        (this.initialHeight = this.getAttribute("data-height")),
        (this.content = this.querySelector(t0.content)),
        (this.trigger = this.querySelector(t0.trigger)),
        (this.actions = this.querySelector(t0.actions)),
        (this.toggleActions = this.toggleActions.bind(this));
    }
    connectedCallback() {
      this.setHeight(this.initialHeight),
        this.trigger.addEventListener("click", () => {
          this.setHeight(this.content.offsetHeight),
            this.classList.add(tj.open);
        }),
        this.setHeight(this.initialHeight),
        this.toggleActions(),
        document.addEventListener("theme:resize", this.toggleActions),
        document.addEventListener(
          "theme:collapsible:toggle",
          this.toggleActions
        );
    }
    disconnectedCallback() {
      document.removeEventListener("theme:resize", this.toggleActions),
        document.removeEventListener(
          "theme:collapsible:toggle",
          this.toggleActions
        );
    }
    setHeight(t) {
      this.style.setProperty("--height", `${t}px`);
    }
    toggleActions() {
      this.classList.toggle(
        tj.enabled,
        this.content.offsetHeight + this.actions.offsetHeight >
          this.initialHeight
      );
    }
  }
  customElements.get("toggle-ellipsis") ||
    customElements.define("toggle-ellipsis", t3),
    (window.Shopify = window.Shopify || {}),
    (window.Shopify.theme = window.Shopify.theme || {}),
    (window.Shopify.theme.sections = window.Shopify.theme.sections || {}),
    (window.Shopify.theme.sections.registered =
      window.Shopify.theme.sections.registered || {}),
    (window.Shopify.theme.sections.instances =
      window.Shopify.theme.sections.instances || []);
  let t2 = window.Shopify.theme.sections.registered,
    tG = window.Shopify.theme.sections.instances,
    tJ = { id: "data-section-id", type: "data-section-type" };
  class tX {
    constructor(t = null, e = []) {
      (this.type = t),
        (this.components = (function t(e) {
          if ((void 0 !== e && "object" != typeof e) || null === e)
            throw TypeError(
              "Theme Sections: The components object provided is not a valid"
            );
          return e;
        })(e)),
        (this.callStack = {
          onLoad: [],
          onUnload: [],
          onSelect: [],
          onDeselect: [],
          onBlockSelect: [],
          onBlockDeselect: [],
          onReorder: [],
        }),
        e.forEach((t) => {
          for (let [e, i] of Object.entries(t)) {
            let s = this.callStack[e];
            Array.isArray(s) && "function" == typeof i
              ? s.push(i)
              : (console.warn(
                  `Unregisted function: '${e}' in component: '${this.type}'`
                ),
                console.warn(i));
          }
        });
    }
    getStack() {
      return this.callStack;
    }
  }
  class t1 {
    constructor(t, e) {
      (this.container = (function t(e) {
        if (!(e instanceof Element))
          throw TypeError(
            "Theme Sections: Attempted to load section. The section container provided is not a DOM element."
          );
        if (null === e.getAttribute(tJ.id))
          throw Error(
            "Theme Sections: The section container provided does not have an id assigned to the " +
              tJ.id +
              " attribute."
          );
        return e;
      })(t)),
        (this.id = t.getAttribute(tJ.id)),
        (this.type = e.type),
        (this.callStack = e.getStack());
      try {
        this.onLoad();
      } catch (i) {
        console.warn(`Error in section: ${this.id}`),
          console.warn(this),
          console.warn(i);
      }
    }
    callFunctions(t, e = null) {
      this.callStack[t].forEach((t) => {
        let i = { id: this.id, type: this.type, container: this.container };
        e ? t.call(i, e) : t.call(i);
      });
    }
    onLoad() {
      this.callFunctions("onLoad");
    }
    onUnload() {
      this.callFunctions("onUnload");
    }
    onSelect(t) {
      this.callFunctions("onSelect", t);
    }
    onDeselect(t) {
      this.callFunctions("onDeselect", t);
    }
    onBlockSelect(t) {
      this.callFunctions("onBlockSelect", t);
    }
    onBlockDeselect(t) {
      this.callFunctions("onBlockDeselect", t);
    }
    onReorder(t) {
      this.callFunctions("onReorder", t);
    }
  }
  function t4(t, e) {
    if ("string" != typeof t)
      throw TypeError(
        "Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered"
      );
    if (void 0 !== t2[t])
      throw Error(
        'Theme Sections: A section of type "' +
          t +
          '" has already been registered. You cannot register the same section type twice'
      );
    Array.isArray(e) || (e = [e]);
    let i = new tX(t, e);
    return (t2[t] = i), t2;
  }
  function t7(t, e) {
    (t = t5(t)),
      void 0 === e && (e = document.querySelectorAll("[" + tJ.type + "]")),
      (e = t6(e)),
      t.forEach(function (t) {
        let i = t2[t];
        void 0 !== i &&
          (e = e.filter(function (e) {
            var s;
            return (
              (s = e),
              !(tQ(s).length > 0) &&
                null !== e.getAttribute(tJ.type) &&
                (e.getAttribute(tJ.type) !== t || (tG.push(new t1(e, i)), !1))
            );
          }));
      });
  }
  function tQ(t) {
    var e = [];
    if (NodeList.prototype.isPrototypeOf(t) || Array.isArray(t)) var i = t[0];
    return (
      t instanceof Element || i instanceof Element
        ? t6(t).forEach(function (t) {
            e = e.concat(
              tG.filter(function (e) {
                return e.container === t;
              })
            );
          })
        : ("string" == typeof t || "string" == typeof i) &&
          t5(t).forEach(function (t) {
            e = e.concat(
              tG.filter(function (e) {
                return e.type === t;
              })
            );
          }),
      e
    );
  }
  function tY(t) {
    for (var e, i = 0; i < tG.length; i++)
      if (tG[i].id === t) {
        e = tG[i];
        break;
      }
    return e;
  }
  function t5(t) {
    return (
      "*" === t
        ? (t = Object.keys(t2))
        : "string" == typeof t
        ? (t = [t])
        : t.constructor === t1
        ? (t = [t.prototype.type])
        : Array.isArray(t) &&
          t[0].constructor === t1 &&
          (t = t.map(function (t) {
            return t.type;
          })),
      (t = t.map(function (t) {
        return t.toLowerCase();
      }))
    );
  }
  function t6(t) {
    return (
      NodeList.prototype.isPrototypeOf(t) && t.length > 0
        ? (t = Array.prototype.slice.call(t))
        : NodeList.prototype.isPrototypeOf(t) && 0 === t.length
        ? (t = [])
        : null === t
        ? (t = [])
        : !Array.isArray(t) && t instanceof Element && (t = [t]),
      t
    );
  }
  window.Shopify.designMode &&
    (document.addEventListener("shopify:section:load", function (t) {
      var e = t.detail.sectionId,
        i = t.target.querySelector("[" + tJ.id + '="' + e + '"]');
      null !== i && t7(i.getAttribute(tJ.type), i);
    }),
    document.addEventListener("shopify:section:reorder", function (t) {
      var e = t.detail.sectionId,
        i = t.target.querySelector("[" + tJ.id + '="' + e + '"]');
      "object" == typeof tQ(i)[0] &&
        (function t(e) {
          tQ(e).forEach(function (t) {
            t.onReorder();
          });
        })(i);
    }),
    document.addEventListener("shopify:section:unload", function (t) {
      var e = t.detail.sectionId,
        i = t.target.querySelector("[" + tJ.id + '="' + e + '"]');
      "object" == typeof tQ(i)[0] &&
        (function t(e) {
          tQ(e).forEach(function (t) {
            var e = tG
              .map(function (t) {
                return t.id;
              })
              .indexOf(t.id);
            tG.splice(e, 1), t.onUnload();
          });
        })(i);
    }),
    document.addEventListener("shopify:section:select", function (t) {
      var e = tY(t.detail.sectionId);
      "object" == typeof e && e.onSelect(t);
    }),
    document.addEventListener("shopify:section:deselect", function (t) {
      var e = tY(t.detail.sectionId);
      "object" == typeof e && e.onDeselect(t);
    }),
    document.addEventListener("shopify:block:select", function (t) {
      var e = tY(t.detail.sectionId);
      "object" == typeof e && e.onBlockSelect(t);
    }),
    document.addEventListener("shopify:block:deselect", function (t) {
      var e = tY(t.detail.sectionId);
      "object" == typeof e && e.onBlockDeselect(t);
    }));
  let tK = {
      sectionId: "[data-section-id]",
      tooltip: "data-tooltip",
      tooltipStopMouseEnter: "data-tooltip-stop-mouseenter",
    },
    tZ = {
      tooltipDefault: "tooltip-default",
      visible: "is-visible",
      hiding: "is-hiding",
    },
    et = {};
  class ee {
    constructor(t, e = {}) {
      if (((this.tooltip = t), !this.tooltip.hasAttribute(tK.tooltip))) return;
      (this.label = this.tooltip.getAttribute(tK.tooltip)),
        (this.class = e.class || tZ.tooltipDefault),
        (this.transitionSpeed = e.transitionSpeed || 200),
        (this.hideTransitionTimeout = 0),
        (this.addPinEvent = () => this.addPin()),
        (this.addPinMouseEvent = () => this.addPin(!0)),
        (this.removePinEvent = (t) => tT(this.removePin(t), 50)),
        (this.removePinMouseEvent = (t) => this.removePin(t, !0, !0)),
        this.init();
    }
    init() {
      if (!document.querySelector(`.${this.class}`)) {
        let t = `<div class="${this.class}__arrow"></div><div class="${this.class}__inner"><div class="${this.class}__text"></div></div>`,
          e = document.createElement("div");
        (e.className = this.class),
          (e.innerHTML = t),
          document.body.appendChild(e);
      }
      this.tooltip.addEventListener("mouseenter", this.addPinMouseEvent),
        this.tooltip.addEventListener("mouseleave", this.removePinMouseEvent),
        this.tooltip.addEventListener("theme:tooltip:init", this.addPinEvent),
        document.addEventListener("theme:tooltip:close", this.removePinEvent);
    }
    addPin(t = !1) {
      let e = document.querySelector(`.${this.class}`),
        i = this.tooltip.closest(tK.sectionId),
        s = Array.from(i.classList).find((t) => t.startsWith("color-scheme-"));
      if (
        (e?.classList.add(s),
        this.label &&
          e &&
          ((t && !this.tooltip.hasAttribute(tK.tooltipStopMouseEnter)) || !t))
      ) {
        let r = e.querySelector(`.${this.class}__arrow`),
          o = e.querySelector(`.${this.class}__inner`),
          a = e.querySelector(`.${this.class}__text`);
        a.innerHTML = this.label;
        let n = o.offsetWidth,
          l = this.tooltip.getBoundingClientRect(),
          c = l.top,
          d = l.width,
          h = l.height,
          u = c + h + window.scrollY,
          m = l.left - n / 2 + d / 2,
          g = m + n,
          b = g - p() + 24;
        b > 0 && (m -= b),
          m < 0 && (m = 0),
          (r.style.left = `${l.left + d / 2}px`),
          e.style.setProperty("--tooltip-top", `${u}px`),
          (o.style.transform = `translateX(${m}px)`),
          e.classList.remove(tZ.hiding),
          e.classList.add(tZ.visible),
          document.addEventListener("theme:scroll", this.removePinEvent);
      }
    }
    removePin(t, e = !1, i = !1) {
      let s = document.querySelector(`.${this.class}`),
        r = s.classList.contains(tZ.visible);
      s &&
        ((e && !this.tooltip.hasAttribute(tK.tooltipStopMouseEnter)) || !e) &&
        (r &&
          (i || t.detail.hideTransition) &&
          (s.classList.add(tZ.hiding),
          this.hideTransitionTimeout &&
            clearTimeout(this.hideTransitionTimeout),
          (this.hideTransitionTimeout = setTimeout(() => {
            s.classList.remove(tZ.hiding);
          }, this.transitionSpeed))),
        s.classList.remove(tZ.visible),
        document.removeEventListener("theme:scroll", this.removePinEvent));
    }
    unload() {
      this.tooltip.removeEventListener("mouseenter", this.addPinMouseEvent),
        this.tooltip.removeEventListener(
          "mouseleave",
          this.removePinMouseEvent
        ),
        this.tooltip.removeEventListener(
          "theme:tooltip:init",
          this.addPinEvent
        ),
        document.removeEventListener(
          "theme:tooltip:close",
          this.removePinEvent
        ),
        document.removeEventListener("theme:scroll", this.removePinEvent);
    }
  }
  let ei = {
    onLoad() {
      et[this.id] = [];
      let t = this.container.querySelectorAll(`[${tK.tooltip}]`);
      t.forEach((t) => {
        et[this.id].push(new ee(t));
      });
    },
    onUnload: function () {
      et[this.id].forEach((t) => {
        "function" == typeof t.unload && t.unload();
      });
    },
  };
  t4("article", [ei]);
  let es = {
      aos: "[data-aos]",
      collectionImage: ".collection-item__image",
      columnImage: "[data-column-image]",
      flickityNextArrow: ".flickity-button.next",
      flickityPrevArrow: ".flickity-button.previous",
      link: "a:not(.btn)",
      productItemImage: ".product-item__image",
      slide: "[data-slide]",
      slideValue: "data-slide",
      slider: "[data-slider]",
      sliderThumb: "[data-slider-thumb]",
    },
    er = {
      arrowPositionMiddle: "data-arrow-position-middle",
      slideIndex: "data-slide-index",
      sliderOptions: "data-options",
      slideTextColor: "data-slide-text-color",
    },
    eo = {
      aosAnimate: "aos-animate",
      desktop: "desktop",
      focused: "is-focused",
      flickityEnabled: "flickity-enabled",
      heroContentTransparent: "hero__content--transparent",
      initialized: "is-initialized",
      isLoading: "is-loading",
      isSelected: "is-selected",
      mobile: "mobile",
      singleSlide: "single-slide",
      sliderInitialized: "js-slider--initialized",
    },
    ea = {};
  class en {
    constructor(t, e = null) {
      if (
        ((this.container = t),
        (this.slideshow = e || this.container.querySelector(es.slider)),
        !this.slideshow ||
          ((this.slideshowSlides = this.slideshow.querySelectorAll(es.slide)),
          this.slideshowSlides.length <= 1))
      )
        return;
      (this.sliderThumbs = this.container.querySelectorAll(es.sliderThumb)),
        this.slideshow.hasAttribute(er.sliderOptions) &&
          (this.customOptions = JSON.parse(
            decodeURIComponent(this.slideshow.getAttribute(er.sliderOptions))
          )),
        (this.flkty = null),
        this.init();
    }
    init() {
      this.slideshow.classList.add(eo.isLoading);
      let t = es.slide,
        s = g(),
        r = `${es.slide}:not(.${eo.mobile})`,
        o = `${es.slide}:not(.${eo.desktop})`,
        a =
          this.slideshow.querySelectorAll(o).length ||
          this.slideshow.querySelectorAll(r).length;
      a && (t = s ? r : o),
        this.slideshow.querySelectorAll(t).length <= 1 &&
          (this.slideshow.classList.add(eo.singleSlide),
          this.slideshow.classList.remove(eo.isLoading)),
        (this.sliderOptions = {
          cellSelector: t,
          contain: !0,
          wrapAround: !0,
          adaptiveHeight: !0,
          ...this.customOptions,
          on: {
            ready: () => {
              requestAnimationFrame(() => {
                this.slideshow.classList.add(eo.initialized),
                  this.slideshow.classList.remove(eo.isLoading),
                  this.slideshow.parentNode.dispatchEvent(
                    new CustomEvent("theme:slider:loaded", {
                      bubbles: !0,
                      detail: { slider: this },
                    })
                  );
              }),
                this.slideActions(),
                this.sliderOptions.prevNextButtons && this.positionArrows();
            },
            change: (t) => {
              let e = this.slideshowSlides[t];
              if (!e || this.sliderOptions.groupCells) return;
              let i = e.querySelectorAll(es.aos);
              i.length &&
                i.forEach((t) => {
                  t.classList.remove(eo.aosAnimate),
                    requestAnimationFrame(() => {
                      setTimeout(() => {
                        t.classList.add(eo.aosAnimate);
                      }, 0);
                    });
                });
            },
            resize: () => {
              this.sliderOptions.prevNextButtons && this.positionArrows();
            },
          },
        }),
        this.sliderOptions.fade &&
          (this.flkty = new i(this.slideshow, this.sliderOptions)),
        this.sliderOptions.fade ||
          (this.flkty = new e(this.slideshow, this.sliderOptions)),
        this.flkty.on("change", () => this.slideActions(!0)),
        this.sliderThumbs.length &&
          this.sliderThumbs.forEach((t) => {
            t.addEventListener("click", (e) => {
              e.preventDefault();
              let i = [...t.parentElement.children].indexOf(t);
              this.flkty.select(i);
            });
          }),
        (this.flkty && this.flkty.isActive) ||
          this.slideshow.classList.remove(eo.isLoading);
    }
    slideActions(t = !1) {
      let e = this.slideshow.querySelector(`.${eo.isSelected}`);
      if (!e) return;
      let i = e.hasAttribute(er.slideTextColor)
          ? e.getAttribute(er.slideTextColor)
          : "",
        s = e.querySelector(es.link),
        r = this.slideshow.querySelectorAll(
          `${es.slide} a, ${es.slide} button`
        );
      if (
        (document.body.classList.contains(eo.focused) &&
          s &&
          this.sliderOptions.groupCells &&
          t &&
          s.focus(),
        r.length &&
          r.forEach((t) => {
            let e = t.closest(es.slide);
            if (e) {
              let i = e.classList.contains(eo.isSelected) ? 0 : -1;
              t.setAttribute("tabindex", i);
            }
          }),
        this.slideshow.style.setProperty("--text", i),
        this.sliderThumbs.length &&
          this.sliderThumbs.length === this.slideshowSlides.length &&
          e.hasAttribute(er.slideIndex))
      ) {
        let o = parseInt(e.getAttribute(er.slideIndex)),
          a = this.container.querySelector(
            `${es.sliderThumb}.${eo.isSelected}`
          );
        a && a.classList.remove(eo.isSelected),
          this.sliderThumbs[o].classList.add(eo.isSelected);
      }
    }
    positionArrows() {
      if (
        this.slideshow.hasAttribute(er.arrowPositionMiddle) &&
        this.sliderOptions.prevNextButtons
      ) {
        let t =
          this.slideshow.querySelector(es.collectionImage) ||
          this.slideshow.querySelector(es.productItemImage) ||
          this.slideshow.querySelector(es.columnImage);
        t &&
          ((this.slideshow.querySelector(es.flickityPrevArrow).style.top =
            t.clientHeight / 2 + "px"),
          (this.slideshow.querySelector(es.flickityNextArrow).style.top =
            t.clientHeight / 2 + "px"));
      }
    }
    onUnload() {
      this.slideshow &&
        this.flkty &&
        ((this.flkty.options.watchCSS = !1), this.flkty.destroy());
    }
    onBlockSelect(t) {
      if (!this.slideshow) return;
      let e = this.slideshow.querySelector(
        `[${es.slideValue}="${t.detail.blockId}"]`
      );
      if (!e) return;
      let i = parseInt(e.getAttribute(er.slideIndex));
      this.slideshow.classList.add(eo.isSelected),
        this.flkty &&
          this.slideshow.classList.contains(eo.flickityEnabled) &&
          (this.flkty.selectCell(i), this.flkty.stopPlayer());
    }
    onBlockDeselect() {
      this.slideshow &&
        (this.slideshow.classList.remove(eo.isSelected),
        this.flkty &&
          this.sliderOptions.hasOwnProperty("autoPlay") &&
          this.sliderOptions.autoPlay &&
          this.flkty.playPlayer());
    }
  }
  let el = {
    onLoad() {
      ea[this.id] = [];
      let t = this.container.querySelectorAll(es.slider);
      t.forEach((t) => {
        ea[this.id].push(new en(this.container, t));
      });
    },
    onUnload() {
      ea[this.id].forEach((t) => {
        "function" == typeof t.onUnload && t.onUnload();
      });
    },
    onBlockSelect(t) {
      ea[this.id].forEach((e) => {
        "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
      });
    },
    onBlockDeselect(t) {
      ea[this.id].forEach((e) => {
        "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
      });
    },
  };
  t4("blog-section", [el]), t4("double", el);
  let ec = (t) => {
    let { stickyHeaderHeight: e } = a();
    window.scrollTo({
      top: t + window.scrollY - e,
      left: 0,
      behavior: "smooth",
    });
  };
  class ed {
    constructor(t, e, i = 7) {
      let s = new Date(),
        r = new Date();
      r.setTime(s.getTime() + 864e5 * i),
        (this.configuration = {
          expires: r.toGMTString(),
          path: "/",
          domain: window.location.hostname,
          sameSite: "none",
          secure: !0,
        }),
        (this.name = t),
        (this.value = e);
    }
    write() {
      let t =
        -1 !== document.cookie.indexOf("; ") &&
        !document.cookie.split("; ").find((t) => t.startsWith(this.name));
      (t || -1 === document.cookie.indexOf("; ")) &&
        (document.cookie = `${this.name}=${this.value}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`);
    }
    read() {
      if (
        !(
          -1 !== document.cookie.indexOf("; ") &&
          document.cookie.split("; ").find((t) => t.startsWith(this.name))
        )
      )
        return !1;
      {
        let t = document.cookie
          .split("; ")
          .find((t) => t.startsWith(this.name))
          .split("=")[1];
        return t;
      }
    }
    destroy() {
      document.cookie.split("; ").find((t) => t.startsWith(this.name)) &&
        (document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`);
    }
  }
  let eh = {
      newsletterForm: "[data-newsletter-form]",
      newsletterHeading: "[data-newsletter-heading]",
      newsletterPopup: "[data-newsletter]",
    },
    eu = { success: "has-success", error: "has-error", hidden: "hidden" },
    ep = {};
  class em {
    constructor(t) {
      (this.sessionStorage = window.sessionStorage),
        (this.newsletter = t),
        (this.popup = this.newsletter.closest(eh.newsletterPopup)),
        this.popup &&
          (this.cookie = new ed(
            this.popup.getAttribute("data-cookie-name"),
            "user_has_closed",
            null
          )),
        (this.stopSubmit = !0),
        (this.isChallengePage = !1),
        (this.formID = null),
        this.checkForChallengePage(),
        (this.newsletterSubmit = (t) => this.newsletterSubmitEvent(t)),
        this.isChallengePage || this.init();
    }
    init() {
      this.newsletter.addEventListener("submit", this.newsletterSubmit),
        this.showMessage();
    }
    newsletterSubmitEvent(t) {
      this.stopSubmit &&
        (t.preventDefault(),
        t.stopImmediatePropagation(),
        this.removeStorage(),
        this.writeStorage(),
        (this.stopSubmit = !1),
        this.newsletter.submit());
    }
    checkForChallengePage() {
      this.isChallengePage = "/challenge" === window.location.pathname;
    }
    writeStorage() {
      void 0 !== this.sessionStorage &&
        this.sessionStorage.setItem("newsletter_form_id", this.newsletter.id);
    }
    readStorage() {
      this.formID = this.sessionStorage.getItem("newsletter_form_id");
    }
    removeStorage() {
      this.sessionStorage.removeItem("newsletter_form_id");
    }
    showMessage() {
      if ((this.readStorage(), this.newsletter.id === this.formID)) {
        let t = document.getElementById(this.formID),
          e = t.parentElement.querySelector(eh.newsletterHeading),
          i = -1 !== window.location.search.indexOf("?customer_posted=true"),
          s = -1 !== window.location.search.indexOf("accepts_marketing");
        i
          ? (t.classList.remove(eu.error),
            t.classList.add(eu.success),
            e && (e.classList.add(eu.hidden), t.classList.remove(eu.hidden)),
            this.popup && this.cookie.write())
          : s &&
            (t.classList.remove(eu.success),
            t.classList.add(eu.error),
            e && (e.classList.add(eu.hidden), t.classList.remove(eu.hidden))),
          (i || s) &&
            window.addEventListener("load", () => {
              this.scrollToForm(t);
            });
      }
    }
    scrollToForm(t) {
      let e = t.getBoundingClientRect(),
        i = e.top >= 0 && e.left >= 0 && e.bottom <= m() && e.right <= p();
      i ||
        setTimeout(() => {
          ec(t.getBoundingClientRect().top);
        }, 500);
    }
    unload() {
      this.newsletter.removeEventListener("submit", this.newsletterSubmit);
    }
  }
  let eg = {
    onLoad() {
      ep[this.id] = [];
      let t = this.container.querySelectorAll(eh.newsletterForm);
      t.forEach((t) => {
        ep[this.id].push(new em(t));
      });
    },
    onUnload() {
      ep[this.id].forEach((t) => {
        "function" == typeof t.unload && t.unload();
      });
    },
  };
  t4("footer", [eg]);
  let eb = {
      collectionSidebar: "[data-collection-sidebar]",
      collectionSidebarSlideOut: "[data-collection-sidebar-slide-out]",
      collectionSidebarCloseButton: "[data-collection-sidebar-close]",
      groupTagsButton: "[data-aria-toggle]",
      animation: "[data-animation]",
    },
    ev = {
      animated: "drawer--animated",
      hiding: "is-hiding",
      expanded: "expanded",
      noMobileAnimation: "no-mobile-animation",
      focused: "is-focused",
    },
    ef = {};
  class ey {
    constructor(t) {
      (this.container = t.container),
        (this.collectionSidebar = this.container.querySelector(
          eb.collectionSidebar
        )),
        (this.groupTagsButton = this.container.querySelector(
          eb.groupTagsButton
        )),
        (this.a11y = M),
        (this.groupTagsButtonClickEvent = (t) => this.groupTagsButtonClick(t)),
        (this.sidebarResizeEvent = () => this.toggleSidebarSlider()),
        (this.collectionSidebarCloseEvent = (t) =>
          this.collectionSidebarClose(t)),
        this.init();
    }
    init() {
      if (null !== this.groupTagsButton) {
        document.addEventListener(
          "theme:resize:width",
          this.sidebarResizeEvent
        ),
          this.groupTagsButton.addEventListener(
            "click",
            this.groupTagsButtonClickEvent
          ),
          this.collectionSidebar &&
            setTimeout(() => {
              this.collectionSidebar.classList.remove(ev.noMobileAnimation);
            }, 1e3);
        let t = new MutationObserver((t) => {
          for (let e of t)
            if ("attributes" === e.type) {
              let i = "true" == e.target.getAttribute("aria-expanded");
              i && this.showSidebarCallback();
            }
        });
        t.observe(this.groupTagsButton, {
          attributes: !0,
          childList: !1,
          subtree: !1,
        });
      }
      this.container.addEventListener(
        "keyup",
        function (t) {
          "Escape" === t.code && this.hideSidebar();
        }.bind(this)
      ),
        this.collectionSidebar &&
          (this.collectionSidebar.addEventListener("transitionend", () => {
            this.collectionSidebar.classList.contains(ev.expanded) ||
              this.collectionSidebar.classList.remove(ev.animated);
          }),
          this.toggleSidebarSlider(),
          this.container.addEventListener(
            "theme:filter:close",
            this.collectionSidebarCloseEvent
          ));
    }
    showSidebarCallback() {
      let t = this.container.querySelector(eb.collectionSidebarSlideOut),
        e = document.documentElement.hasAttribute("data-scroll-locked"),
        i = b();
      this.collectionSidebar.classList.add(ev.animated),
        null === t &&
          !i &&
          e &&
          (this.a11y.removeTrapFocus(),
          document.dispatchEvent(
            new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
          )),
        (i || null !== t) &&
          (t &&
            this.a11y.trapFocus(this.collectionSidebar, {
              elementToFocus: this.collectionSidebar.querySelector(
                eb.collectionSidebarCloseButton
              ),
            }),
          document.dispatchEvent(
            new CustomEvent("theme:scroll:lock", { bubbles: !0 })
          ));
    }
    hideSidebar() {
      let t = this.container.querySelector(eb.collectionSidebarSlideOut),
        e = document.documentElement.hasAttribute("data-scroll-locked");
      this.groupTagsButton.setAttribute("aria-expanded", "false"),
        this.collectionSidebar.classList.remove(ev.expanded),
        t && this.a11y.removeTrapFocus(),
        e &&
          document.dispatchEvent(
            new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
          );
    }
    toggleSidebarSlider() {
      b()
        ? this.hideSidebar()
        : this.collectionSidebar.classList.contains(ev.expanded) &&
          this.showSidebarCallback();
    }
    collectionSidebarClose(t) {
      t.preventDefault(),
        this.hideSidebar(),
        document.body.classList.contains(ev.focused) &&
          this.groupTagsButton &&
          this.groupTagsButton.focus();
    }
    groupTagsButtonClick() {
      let t = document.documentElement.hasAttribute("data-scroll-locked");
      t &&
        document.dispatchEvent(
          new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
        );
    }
    onUnload() {
      null !== this.groupTagsButton &&
        (document.removeEventListener(
          "theme:resize:width",
          this.sidebarResizeEvent
        ),
        this.groupTagsButton.removeEventListener(
          "click",
          this.groupTagsButtonClickEvent
        )),
        this.collectionSidebar &&
          this.container.removeEventListener(
            "theme:filter:close",
            this.collectionSidebarCloseEvent
          );
    }
  }
  t4("collection", [
    el,
    {
      onLoad() {
        ef[this.id] = new ey(this);
      },
      onUnload() {
        ef[this.id].onUnload();
      },
    },
    ei,
  ]);
  let eS = {
      marquee: ".announcement__bar-holder--marquee",
      slide: "[data-slide]",
      slider: "[data-slider]",
      ticker: "ticker-bar",
      tickerSlide: ".announcement__slide",
    },
    ew = { hidden: "hidden" };
  class eL extends HTMLElement {
    constructor() {
      super(),
        (this.slider = this.querySelector(eS.slider)),
        (this.enableSlider = g()),
        (this.slidesCount = this.querySelectorAll(eS.tickerSlide).length),
        (this.initSliderEvent = (t) => this.initSlider(t));
    }
    connectedCallback() {
      this.slider && this.initSliders(),
        this.addEventListener("theme:block:select", (t) => {
          this.onBlockSelect(t);
        }),
        this.addEventListener("theme:block:deselect", (t) => {
          this.onBlockDeselect(t);
        }),
        this.addEventListener("theme:countdown:hide", (t) => {
          if (window.Shopify.designMode) return;
          let e = t.target.closest(eS.marquee);
          if (1 === this.slidesCount) {
            let i = this.querySelector(eS.ticker);
            i.style.display = "none";
          }
          if (e) {
            let s = t.target.closest(eS.tickerSlide);
            this.removeTickerText(s);
          } else {
            let r = t.target.closest(eS.slide);
            this.removeSlide(r);
          }
        }),
        this.addEventListener("theme:countdown:expire", () => {
          this.querySelectorAll(eS.ticker)?.forEach((t) => {
            t.dispatchEvent(new CustomEvent("theme:ticker:refresh"));
          });
        }),
        document.dispatchEvent(
          new CustomEvent("theme:announcement:init", { bubbles: !0 })
        );
    }
    initSliders() {
      this.initSlider(),
        document.addEventListener("theme:resize:width", this.initSliderEvent),
        this.addEventListener("theme:slider:loaded", () => {
          this.querySelectorAll(eS.tickerBar)?.forEach((t) => {
            t.dispatchEvent(new CustomEvent("theme:ticker:refresh"));
          });
        });
    }
    initSlider() {
      let t = g(),
        e = !t;
      ((t && this.enableSlider) || (e && !this.enableSlider)) &&
        (this.slider.flkty?.destroy(),
        t && this.enableSlider
          ? (this.enableSlider = !1)
          : e && !this.enableSlider && (this.enableSlider = !0),
        (this.slider = new en(this, this.querySelector(eS.slider))),
        this.slider.flkty?.reposition());
    }
    removeSlide(t) {
      this.slider.flkty?.remove(t),
        0 === this.slider.flkty?.cells.length &&
          this.section.classList.add(ew.hidden);
    }
    removeTickerText(t) {
      let e = t.closest(eS.ticker);
      t.remove(), e.dispatchEvent(new CustomEvent("theme:ticker:refresh"));
    }
    onBlockSelect(t) {
      this.slider && this.slider.onBlockSelect(t);
    }
    onBlockDeselect(t) {
      this.slider && this.slider.onBlockDeselect(t);
    }
    disconnectedCallback() {
      document.removeEventListener("theme:resize:width", this.initSliderEvent),
        document.removeEventListener(
          "theme:resize:width",
          this.tickerResizeEvent
        ),
        this.removeEventListener("theme:block:select", (t) => {
          this.onBlockSelect(t);
        }),
        this.removeEventListener("theme:block:deselect", (t) => {
          this.onBlockDeselect(t);
        });
    }
  }
  customElements.get("announcement-bar") ||
    customElements.define("announcement-bar", eL);
  let eE = { pageHeader: ".page-header" },
    ek = {
      stuck: "js__header__stuck",
      sticky: "has-header-sticky",
      headerGroup: "shopify-section-group-header-group",
    },
    eA = {
      stickyHeader: "data-header-sticky",
      scrollLock: "data-scroll-locked",
    },
    eC = {};
  class eq {
    constructor(t) {
      if (
        ((this.wrapper = t),
        (this.sticks = this.wrapper.hasAttribute(eA.stickyHeader)),
        document.body.classList.toggle(ek.sticky, this.sticks),
        !this.sticks)
      )
        return;
      (this.isStuck = !1),
        (this.cls = this.wrapper.classList),
        (this.headerOffset = document.querySelector(eE.pageHeader)?.offsetTop),
        (this.updateHeaderOffset = this.updateHeaderOffset.bind(this)),
        (this.scrollEvent = (t) => this.onScroll(t)),
        this.listen(),
        this.stickOnLoad();
    }
    listen() {
      document.addEventListener("theme:scroll", this.scrollEvent),
        document.addEventListener(
          "shopify:section:load",
          this.updateHeaderOffset
        ),
        document.addEventListener(
          "shopify:section:unload",
          this.updateHeaderOffset
        );
    }
    onScroll(t) {
      t.detail.down
        ? !this.isStuck &&
          t.detail.position > this.headerOffset &&
          this.stickSimple()
        : t.detail.position <= this.headerOffset && this.unstickSimple();
    }
    updateHeaderOffset(t) {
      t.target.classList.contains(ek.headerGroup) &&
        setTimeout(() => {
          this.headerOffset = document.querySelector(eE.pageHeader)?.offsetTop;
        });
    }
    stickOnLoad() {
      window.scrollY > this.headerOffset && this.stickSimple();
    }
    stickSimple() {
      this.cls.add(ek.stuck), (this.isStuck = !0);
    }
    unstickSimple() {
      document.documentElement.hasAttribute(eA.scrollLock) ||
        (this.cls.remove(ek.stuck), (this.isStuck = !1));
    }
    unload() {
      document.removeEventListener("theme:scroll", this.scrollEvent),
        document.removeEventListener(
          "shopify:section:load",
          this.updateHeaderOffset
        ),
        document.removeEventListener(
          "shopify:section:unload",
          this.updateHeaderOffset
        );
    }
  }
  let e$ = {
      disclosureToggle: "data-hover-disclosure-toggle",
      disclosureWrappper: "[data-hover-disclosure]",
      link: "[data-top-link]",
      wrapper: "[data-header-wrapper]",
      stagger: "[data-stagger]",
      staggerPair: "[data-stagger-first]",
      staggerAfter: "[data-stagger-second]",
      focusable:
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
    },
    eT = {
      isVisible: "is-visible",
      meganavVisible: "meganav--visible",
      meganavIsTransitioning: "meganav--is-transitioning",
    },
    ex = {},
    eP = {};
  class eI {
    constructor(t) {
      (this.disclosure = t),
        (this.wrapper = t.closest(e$.wrapper)),
        (this.key = this.disclosure.id),
        (this.trigger = document.querySelector(
          `[${e$.disclosureToggle}='${this.key}']`
        )),
        (this.link = this.trigger.querySelector(e$.link)),
        (this.grandparent = this.trigger.classList.contains("grandparent")),
        (this.transitionTimeout = 0),
        this.trigger.setAttribute("aria-haspopup", !0),
        this.trigger.setAttribute("aria-expanded", !1),
        this.trigger.setAttribute("aria-controls", this.key),
        this.connectHoverToggle(),
        this.handleTablets(),
        this.staggerChildAnimations();
    }
    onBlockSelect(t) {
      this.disclosure.contains(t.target) && this.showDisclosure(t);
    }
    onBlockDeselect(t) {
      this.disclosure.contains(t.target) && this.hideDisclosure();
    }
    showDisclosure(t) {
      t &&
        t.type &&
        "mouseenter" === t.type &&
        this.wrapper.classList.add(eT.meganavIsTransitioning),
        this.grandparent
          ? this.wrapper.classList.add(eT.meganavVisible)
          : this.wrapper.classList.remove(eT.meganavVisible),
        this.trigger.setAttribute("aria-expanded", !0),
        this.trigger.classList.add(eT.isVisible),
        this.disclosure.classList.add(eT.isVisible),
        this.transitionTimeout && clearTimeout(this.transitionTimeout),
        (this.transitionTimeout = setTimeout(() => {
          this.wrapper.classList.remove(eT.meganavIsTransitioning);
        }, 200));
    }
    hideDisclosure() {
      this.disclosure.classList.remove(eT.isVisible),
        this.trigger.classList.remove(eT.isVisible),
        this.trigger.setAttribute("aria-expanded", !1),
        this.wrapper.classList.remove(
          eT.meganavVisible,
          eT.meganavIsTransitioning
        );
    }
    staggerChildAnimations() {
      let t = this.disclosure.querySelectorAll(e$.stagger),
        e = 50;
      t.forEach((t, i) => {
        (t.style.transitionDelay = `${i * e + 10}ms`), (e *= 0.95);
      });
      let i = this.disclosure.querySelectorAll(e$.staggerPair);
      i.forEach((t, e) => {
        let i = 100 * e;
        (t.style.transitionDelay = `${i}ms`),
          t.parentElement.querySelectorAll(e$.staggerAfter).forEach((t, e) => {
            t.style.transitionDelay = `${i + 20 * (e + 1)}ms`;
          });
      });
    }
    handleTablets() {
      this.trigger.addEventListener(
        "touchstart",
        function (t) {
          let e = this.disclosure.classList.contains(eT.isVisible);
          e || (t.preventDefault(), this.showDisclosure(t));
        }.bind(this),
        { passive: !0 }
      );
    }
    connectHoverToggle() {
      this.trigger.addEventListener("mouseenter", (t) =>
        this.showDisclosure(t)
      ),
        this.link.addEventListener("focus", (t) => this.showDisclosure(t)),
        this.trigger.addEventListener("mouseleave", () =>
          this.hideDisclosure()
        ),
        this.trigger.addEventListener("focusout", (t) => {
          let e = this.trigger.contains(t.relatedTarget);
          e || this.hideDisclosure();
        }),
        this.disclosure.addEventListener("keyup", (t) => {
          "Escape" === t.code && this.hideDisclosure();
        });
    }
  }
  let e_ = {
      wrapper: "[data-header-wrapper]",
      style: "data-header-style",
      widthContentWrapper: "[data-takes-space-wrapper]",
      widthContent: "[data-child-takes-space]",
      desktop: "[data-header-desktop]",
      deadLink: '.navlink[href="#"]',
      cartDrawer: "cart-drawer",
      cartToggleButton: "[data-cart-toggle]",
      firstSectionOverlayHeader:
        ".main-content > .shopify-section.section-overlay-header:first-of-type",
      preventTransparent: "[data-prevent-transparent-header]",
    },
    eH = {
      clone: "js__header__clone",
      firstSectionOverlayHeader: "has-first-section-overlay-header",
      showMobileClass: "js__show__mobile",
      transparent: "has-header-transparent",
    },
    eB = {
      drawer: "data-drawer",
      drawerToggle: "data-drawer-toggle",
      transparent: "data-header-transparent",
    },
    eO = {};
  class eM {
    constructor(t) {
      (this.wrapper = t),
        (this.style = this.wrapper.dataset.style),
        (this.desktop = this.wrapper.querySelector(e_.desktop)),
        (this.deadLinks = document.querySelectorAll(e_.deadLink)),
        (this.resizeObserver = null),
        (this.checkWidth = this.checkWidth.bind(this)),
        this.killDeadLinks(),
        "drawer" !== this.style &&
          this.desktop &&
          ((this.minWidth = this.getMinWidth()), this.listenWidth()),
        this.drawerToggleEvent(),
        this.cartToggleEvent();
      let e = !1,
        i = document.querySelector(e_.firstSectionOverlayHeader);
      i && !i.querySelector(e_.preventTransparent) && (e = !0),
        document.body.classList.toggle(
          eH.transparent,
          this.wrapper.hasAttribute(eB.transparent)
        ),
        document.body.classList.toggle(eH.firstSectionOverlayHeader, e);
    }
    initTicker(t = !1) {
      this.tickerFrames.forEach((e) => {
        new Ticker(e, t);
      }),
        (this.tickerResizeEvent = (t) => this.onTickerResize(t)),
        document.addEventListener("theme:resize:width", this.tickerResizeEvent);
    }
    listenWidth() {
      "ResizeObserver" in window
        ? ((this.resizeObserver = new ResizeObserver(this.checkWidth)),
          this.resizeObserver.observe(this.wrapper))
        : document.addEventListener("theme:resize", this.checkWidth);
    }
    drawerToggleEvent() {
      this.wrapper.querySelectorAll(`[${eB.drawerToggle}]`)?.forEach((t) => {
        t.addEventListener("click", () => {
          let e,
            i = t.hasAttribute(eB.drawerToggle)
              ? t.getAttribute(eB.drawerToggle)
              : "",
            s = document.querySelector(`[${eB.drawer}="${i}"]`),
            r = document.querySelector(`mobile-menu > [${eB.drawer}]`),
            o = g();
          (e = o
            ? s
            : ("new" === theme.settings.mobileMenuType && r) ||
              s).dispatchEvent(
            new CustomEvent("theme:drawer:toggle", {
              bubbles: !1,
              detail: { button: t },
            })
          );
        });
      });
    }
    killDeadLinks() {
      this.deadLinks.forEach((t) => {
        t.onclick = (t) => {
          t.preventDefault();
        };
      });
    }
    checkWidth() {
      if (document.body.clientWidth < this.minWidth) {
        this.wrapper.classList.add(eH.showMobileClass);
        let { headerHeight: t } = a();
        document.documentElement.style.setProperty("--header-height", `${t}px`);
      } else this.wrapper.classList.remove(eH.showMobileClass);
    }
    getMinWidth() {
      let t = this.wrapper.cloneNode(!0);
      t.classList.add(eH.clone), document.body.appendChild(t);
      let e = t.querySelectorAll(e_.widthContentWrapper),
        i = 0,
        s = 0;
      return (
        e.forEach((t) => {
          var e;
          let r = t.querySelectorAll(e_.widthContent),
            o = 0,
            a;
          (o =
            3 === r.length
              ? (function t(e) {
                  let i = [];
                  e.forEach((t) => {
                    t.firstElementChild &&
                      i.push(t.firstElementChild.clientWidth);
                  }),
                    i[0] > i[2] ? (i[2] = i[0]) : (i[0] = i[2]);
                  let s = i.reduce((t, e) => t + e);
                  return s;
                })(r)
              : ((e = r),
                (a = 0),
                e.forEach((t) => {
                  a += t.clientWidth;
                }),
                a)) > i && ((i = o), (s = 20 * r.length));
        }),
        document.body.removeChild(t),
        i + s
      );
    }
    cartToggleEvent() {
      "drawer" === theme.settings.cartType &&
        this.wrapper.querySelectorAll(e_.cartToggleButton)?.forEach((t) => {
          t.addEventListener("click", (e) => {
            let i = document.querySelector(e_.cartDrawer);
            i &&
              (e.preventDefault(),
              i.dispatchEvent(new CustomEvent("theme:cart-drawer:show")),
              (window.a11y.lastElement = t));
          });
        });
    }
    toggleButtonClick(t) {
      t.preventDefault(),
        document.dispatchEvent(
          new CustomEvent("theme:cart:toggle", { bubbles: !0 })
        );
    }
    unload() {
      "ResizeObserver" in window
        ? this.resizeObserver?.unobserve(this.wrapper)
        : document.removeEventListener("theme:resize", this.checkWidth);
    }
  }
  t4("header", [
    {
      onLoad() {
        eO = new eM(this.container);
      },
      onUnload() {
        "function" == typeof eO.unload && eO.unload();
      },
    },
    {
      onLoad() {
        eC = new eq(this.container);
      },
      onUnload: function () {
        "function" == typeof eC.unload && eC.unload();
      },
    },
    {
      onLoad() {
        (ex[this.id] = []),
          (eP = this.container.querySelectorAll(e$.disclosureWrappper)).forEach(
            (t) => {
              ex[this.id].push(new eI(t));
            }
          );
      },
      onBlockSelect(t) {
        ex[this.id].forEach((e) => {
          "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
        });
      },
      onBlockDeselect(t) {
        ex[this.id].forEach((e) => {
          "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
        });
      },
    },
  ]);
  let eD = {
      slider: "[data-slider-mobile]",
      slide: "[data-slide]",
      thumb: "[data-slider-thumb]",
      sliderContainer: "[data-slider-container]",
      popupContainer: "[data-popup-container]",
      popupClose: "[data-popup-close]",
    },
    e8 = {
      isAnimating: "is-animating",
      isSelected: "is-selected",
      isOpen: "is-open",
    },
    e9 = { thumbValue: "data-slider-thumb" },
    eF = {};
  class eN {
    constructor(t) {
      (this.container = t.container),
        (this.slider = this.container.querySelector(eD.slider)),
        (this.slides = this.container.querySelectorAll(eD.slide)),
        (this.thumbs = this.container.querySelectorAll(eD.thumb)),
        (this.popupContainer = this.container.querySelector(eD.popupContainer)),
        (this.popupClose = this.container.querySelectorAll(eD.popupClose)),
        (this.popupCloseByEvent = this.popupCloseByEvent.bind(this)),
        this.init();
    }
    init() {
      this.slider &&
        this.slides.length &&
        this.thumbs.length &&
        (this.popupContainer.addEventListener("transitionend", (t) => {
          t.target == this.popupContainer &&
            (this.popupContainer.classList.remove(e8.isAnimating),
            t.target.classList.contains(e8.isOpen)
              ? this.popupOpenCallback()
              : this.popupCloseCallback());
        }),
        this.popupContainer.addEventListener("transitionstart", (t) => {
          t.target == this.popupContainer &&
            this.popupContainer.classList.add(e8.isAnimating);
        }),
        this.popupClose.forEach((t) => {
          t.addEventListener("click", () => {
            this.popupContainer.classList.remove(e8.isOpen),
              document.dispatchEvent(
                new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
              );
          });
        }),
        this.thumbs.forEach((t, e) => {
          t.addEventListener("click", (i) => {
            i.preventDefault();
            let s =
                t.hasAttribute(e9.thumbValue) &&
                "" !== t.getAttribute(e9.thumbValue)
                  ? parseInt(t.getAttribute(e9.thumbValue))
                  : e,
              r = this.slides[s];
            if (b()) {
              let o = parseInt(
                window.getComputedStyle(this.slider).paddingLeft
              );
              this.slider.scrollTo({
                top: 0,
                left: r.offsetLeft - o,
                behavior: "auto",
              }),
                document.dispatchEvent(
                  new CustomEvent("theme:scroll:lock", { bubbles: !0 })
                ),
                this.popupContainer.classList.add(e8.isAnimating, e8.isOpen);
            } else {
              let { stickyHeaderHeight: n } = a(),
                l = r.getBoundingClientRect().top,
                c = r.offsetHeight / 2,
                d = window.innerHeight,
                h = this.container.querySelector(eD.sliderContainer),
                u = l + c - d / 2 + window.scrollY;
              if (h) {
                let p = h.getBoundingClientRect().top + window.scrollY,
                  m = h.offsetHeight,
                  g = p + m;
                u < p ? (u = p - n) : u + d > g && (u = g - d);
              }
              window.scrollTo({ top: u, left: 0, behavior: "smooth" });
            }
          });
        }));
    }
    popupCloseByEvent() {
      this.popupContainer.classList.remove(e8.isOpen);
    }
    popupOpenCallback() {
      document.addEventListener(
        "theme:quick-add:open",
        this.popupCloseByEvent,
        { once: !0 }
      ),
        document.addEventListener(
          "theme:product:added",
          this.popupCloseByEvent,
          { once: !0 }
        );
    }
    popupCloseCallback() {
      document.removeEventListener(
        "theme:quick-add:open",
        this.popupCloseByEvent,
        { once: !0 }
      ),
        document.removeEventListener(
          "theme:product:added",
          this.popupCloseByEvent,
          { once: !0 }
        );
    }
  }
  function eW() {
    this.entries = [];
  }
  function eR(t) {
    if ("object" != typeof t) throw TypeError(t + " is not an object.");
    if (0 === Object.keys(t).length && t.constructor === Object)
      throw Error(t + " is empty.");
  }
  t4("look", [
    {
      onLoad() {
        eF[this.id] = new eN(this);
      },
    },
  ]),
    (eW.prototype.add = function (t, e, i) {
      this.entries.push({ element: t, event: e, fn: i }),
        t.addEventListener(e, i);
    }),
    (eW.prototype.removeAll = function () {
      this.entries = this.entries.filter(function (t) {
        return t.element.removeEventListener(t.event, t.fn), !1;
      });
    });
  var eV = {
    idInput: '[name="id"]',
    planInput: '[name="selling_plan"]',
    optionInput: '[name^="options"]',
    quantityInput: '[name="quantity"]',
    propertyInput: '[name^="properties"]',
  };
  class eU {
    constructor(t, e, i) {
      (this.element = t),
        (this.product = this._validateProductObject(e)),
        (this.variantElement = this.element.querySelector(eV.idInput)),
        (i = i || {}),
        (this._listeners = new eW()),
        this._listeners.add(
          this.element,
          "submit",
          this._onSubmit.bind(this, i)
        ),
        (this.optionInputs = this._initInputs(
          eV.optionInput,
          i.onOptionChange
        )),
        (this.planInputs = this._initInputs(eV.planInput, i.onPlanChange)),
        (this.quantityInputs = this._initInputs(
          eV.quantityInput,
          i.onQuantityChange
        )),
        (this.propertyInputs = this._initInputs(
          eV.propertyInput,
          i.onPropertyChange
        ));
    }
    destroy() {
      this._listeners.removeAll();
    }
    options() {
      return this._serializeInputValues(this.optionInputs, function (t) {
        return (t.name = /(?:^(options\[))(.*?)(?:\])/.exec(t.name)[2]), t;
      });
    }
    variant() {
      var t, e, i, s, r, o, a, n;
      let l = this.options();
      if (!l.length) return this.product.variants[0];
      return (
        (t = this.product),
        (e = l),
        eR(t),
        (i =
          ((s = t),
          (r = e),
          eR(s),
          (function t(e) {
            if (!Array.isArray(e)) throw TypeError(e + " is not an array.");
            if (0 === e.length) throw Error(e + " is empty.");
            if (e[0].hasOwnProperty("name")) {
              if ("string" != typeof e[0].name)
                throw TypeError(
                  "Invalid value type passed for name of option " +
                    e[0].name +
                    ". Value should be string."
                );
            } else throw Error(e[0] + "does not contain name key.");
          })(r),
          (o = []),
          r.forEach(function (t) {
            for (var e = 0; e < s.options.length; e++)
              if (
                (s.options[e].name || s.options[e]).toLowerCase() ===
                t.name.toLowerCase()
              ) {
                o[e] = t.value;
                break;
              }
          }),
          o)),
        (a = t),
        (n = i),
        eR(a),
        (function t(e) {
          if (Array.isArray(e) && "object" == typeof e[0])
            throw Error(e + "is not a valid array of options.");
        })(n),
        a.variants.filter(function (t) {
          return n.every(function (e, i) {
            return t.options[i] === e;
          });
        })[0] || null
      );
    }
    plan(t) {
      let e = { allocation: null, group: null, detail: null },
        i = this.element.querySelector(`${eV.planInput}:checked`);
      if (!i) return null;
      let s = i.value,
        r = s && "" !== s ? s : null;
      return (r &&
        t &&
        (e.allocation = t.selling_plan_allocations.find(function (t) {
          return t.selling_plan_id.toString() === r.toString();
        })),
      e.allocation &&
        (e.group = this.product.selling_plan_groups.find(function (t) {
          return (
            t.id.toString() === e.allocation.selling_plan_group_id.toString()
          );
        })),
      e.group &&
        (e.detail = e.group.selling_plans.find(function (t) {
          return t.id.toString() === r.toString();
        })),
      e && e.allocation && e.detail && e.allocation)
        ? e
        : null;
    }
    properties() {
      return this._serializeInputValues(this.propertyInputs, function (t) {
        return (t.name = /(?:^(properties\[))(.*?)(?:\])/.exec(t.name)[2]), t;
      });
    }
    quantity() {
      return this.quantityInputs[0]
        ? Number.parseInt(this.quantityInputs[0].value, 10)
        : 1;
    }
    getFormState() {
      let t = this.variant();
      return {
        options: this.options(),
        variant: t,
        properties: this.properties(),
        quantity: this.quantity(),
        plan: this.plan(t),
      };
    }
    _setIdInputValue(t) {
      t && t.id
        ? (this.variantElement.value = t.id.toString())
        : (this.variantElement.value = ""),
        this.variantElement.dispatchEvent(new Event("change"));
    }
    _onSubmit(t, e) {
      (e.dataset = this.getFormState()), t.onFormSubmit && t.onFormSubmit(e);
    }
    _onOptionChange(t) {
      this._setIdInputValue(t.dataset.variant);
    }
    _onFormEvent(t) {
      return void 0 === t
        ? Function.prototype.bind()
        : function (e) {
            (e.dataset = this.getFormState()),
              this._setIdInputValue(e.dataset.variant),
              t(e);
          }.bind(this);
    }
    _initInputs(t, e) {
      return Array.prototype.slice.call(this.element.querySelectorAll(t)).map(
        function (t) {
          return this._listeners.add(t, "change", this._onFormEvent(e)), t;
        }.bind(this)
      );
    }
    _serializeInputValues(t, e) {
      return t.reduce(function (t, i) {
        return (
          (i.checked || ("radio" !== i.type && "checkbox" !== i.type)) &&
            t.push(e({ name: i.name, value: i.value })),
          t
        );
      }, []);
    }
    _validateProductObject(t) {
      if ("object" != typeof t) throw TypeError(t + " is not an object.");
      if (void 0 === t.variants[0].options)
        throw TypeError(
          "Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route"
        );
      return t;
    }
  }
  let ez = {
      scrollbarAttribute: "data-scrollbar",
      scrollbar: "data-scrollbar-slider",
      scrollbarSlideFullWidth: "data-scrollbar-slide-fullwidth",
      scrollbarArrowPrev: "[data-scrollbar-arrow-prev]",
      scrollbarArrowNext: "[data-scrollbar-arrow-next]",
    },
    e0 = { hidden: "is-hidden" };
  class ej {
    constructor(t) {
      (this.scrollbar = t),
        (this.arrowNext = this.scrollbar.parentNode.querySelector(
          ez.scrollbarArrowNext
        )),
        (this.arrowPrev = this.scrollbar.parentNode.querySelector(
          ez.scrollbarArrowPrev
        )),
        this.scrollbar.hasAttribute(ez.scrollbarAttribute) &&
          (this.init(), this.listen()),
        this.scrollbar.hasAttribute(ez.scrollbar) &&
          this.scrollToVisibleElement();
    }
    init() {
      this.arrowNext &&
        this.arrowPrev &&
        (this.toggleNextArrow(), this.events());
    }
    listen() {
      document.addEventListener("theme:modal:open", () => {
        this.toggleNextArrow();
      }),
        document.addEventListener("theme:resize", () => {
          this.toggleNextArrow();
        });
    }
    events() {
      this.arrowNext.addEventListener("click", (t) => {
        t.preventDefault(), this.goToNext();
      }),
        this.arrowPrev.addEventListener("click", (t) => {
          t.preventDefault(), this.goToPrev();
        }),
        this.scrollbar.addEventListener("scroll", () => {
          this.togglePrevArrow(), this.toggleNextArrow();
        });
    }
    goToNext() {
      let t = this.scrollbar.hasAttribute(ez.scrollbarSlideFullWidth)
          ? this.scrollbar.getBoundingClientRect().width
          : this.scrollbar.getBoundingClientRect().width / 2,
        e = t + this.scrollbar.scrollLeft;
      this.move(e),
        this.arrowPrev.classList.remove(e0.hidden),
        this.toggleNextArrow();
    }
    goToPrev() {
      let t = this.scrollbar.hasAttribute(ez.scrollbarSlideFullWidth)
          ? this.scrollbar.getBoundingClientRect().width
          : this.scrollbar.getBoundingClientRect().width / 2,
        e = this.scrollbar.scrollLeft - t;
      this.move(e),
        this.arrowNext.classList.remove(e0.hidden),
        this.togglePrevArrow();
    }
    toggleNextArrow() {
      requestAnimationFrame(() => {
        this.arrowNext?.classList.toggle(
          e0.hidden,
          Math.round(
            this.scrollbar.scrollLeft +
              this.scrollbar.getBoundingClientRect().width +
              1
          ) >= this.scrollbar.scrollWidth
        );
      });
    }
    togglePrevArrow() {
      requestAnimationFrame(() => {
        this.arrowPrev.classList.toggle(
          e0.hidden,
          this.scrollbar.scrollLeft <= 0
        );
      });
    }
    scrollToVisibleElement() {
      [].forEach.call(this.scrollbar.children, (t) => {
        t.addEventListener("click", (e) => {
          e.preventDefault(), this.move(t.offsetLeft - t.clientWidth);
        });
      });
    }
    move(t) {
      this.scrollbar.scrollTo({ top: 0, left: t, behavior: "smooth" });
    }
  }
  let e3 = {
      gridSwatchForm: "[data-grid-swatch-form]",
      input: "[data-swatch-input]",
      productItem: "[data-grid-item]",
      productInfo: "[data-product-information]",
      sectionId: "[data-section-id]",
      productImage: "[data-product-image]",
      swatchButton: "[data-swatch-button]",
      swatchLink: "[data-swatch-link]",
      swatchText: "[data-swatch-text]",
      template: "[data-swatch-template]",
    },
    e2 = {
      visible: "is-visible",
      hidden: "hidden",
      stopEvents: "no-events",
      swatch: "swatch",
    },
    eG = {
      image: "data-swatch-image",
      handle: "data-swatch-handle",
      label: "data-swatch-label",
      scrollbar: "data-scrollbar",
      swatchCount: "data-swatch-count",
      tooltip: "data-tooltip",
      variant: "data-swatch-variant",
      variantName: "data-swatch-variant-name",
      variantTitle: "data-variant-title",
      swatchValues: "data-swatch-values",
    };
  class eJ extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.hasAttribute(eG.tooltip) && new ee(this);
    }
  }
  class eX extends HTMLElement {
    constructor() {
      super(),
        (this.productItemMouseLeaveEvent = () => this.hideVariantImages()),
        (this.showVariantImageEvent = (t) => this.showVariantImage(t));
    }
    connectedCallback() {
      (this.handle = this.getAttribute(eG.handle)),
        (this.productItem = this.closest(e3.productItem)),
        (this.productInfo = this.closest(e3.productInfo)),
        (this.productImage = this.productItem.querySelector(e3.productImage)),
        (this.template = document.querySelector(e3.template).innerHTML),
        (this.swatchesJSON = this.getSwatchesJSON()),
        (this.swatchesStyle = theme.settings.collectionSwatchStyle);
      let t = this.getAttribute(eG.label).trim().toLowerCase();
      (function t(e) {
        let i = `${window.theme.routes.root}products/${e}.js`;
        return window
          .fetch(i)
          .then((t) => t.json())
          .catch((t) => {
            console.error(t);
          });
      })(this.handle).then((e) => {
        (this.product = e),
          (this.colorOption = e.options.find(function (e) {
            return e.name.toLowerCase() === t || null;
          })),
          this.colorOption &&
            ((this.swatches = this.colorOption.values), this.init());
      });
    }
    init() {
      if (
        ((this.innerHTML = ""),
        (this.count = 0),
        (this.limitedCount = 0),
        this.swatches.forEach((t) => {
          let e = null,
            i = !1,
            s = "";
          for (let r of this.product.variants) {
            let o = r.options.includes(t);
            if ((!e && o && (e = r), o && r.featured_media)) {
              (s = r.featured_media.preview_image.src), (e = r);
              break;
            }
          }
          for (let a of this.product.variants) {
            let n = a.options.includes(t);
            if (n && a.available) {
              i = !0;
              break;
            }
          }
          if (e) {
            var l, c;
            let d = document.createElement("div");
            d.innerHTML = this.template;
            let h = d.querySelector(e3.swatchButton),
              u = d.querySelector(e3.swatchLink),
              p = d.querySelector(e3.swatchText),
              m = this.swatchesJSON[t],
              g = "native" == theme.settings.swatchesType ? m : `var(--${m})`,
              b = e.title.replaceAll('"', "'");
            (h.style = `--animation-delay: ${(100 * this.count) / 1250}s`),
              h.classList.add(`${e2.swatch}-${m}`),
              (h.dataset.tooltip = t),
              (h.dataset.swatchVariant = e.id),
              (h.dataset.swatchVariantName = b),
              (h.dataset.swatchImage = s),
              (h.dataset.variant = e.id),
              h.style.setProperty("--swatch", g),
              (u.href =
                ((l = this.product.url),
                (c = e.id),
                /variant=/.test(l)
                  ? l.replace(/(variant=)[^&]+/, "$1" + c)
                  : /\?/.test(l)
                  ? l.concat("&variant=").concat(c)
                  : l.concat("?variant=").concat(c))),
              (u.dataset.swatch = t),
              (u.disabled = !i),
              (p.innerText = t),
              "limited" != this.swatchesStyle
                ? (this.innerHTML += d.innerHTML)
                : this.count <= 4 &&
                  ((this.innerHTML += d.innerHTML), this.limitedCount++),
              this.count++;
          }
        }),
        (this.swatchCount = this.productInfo.querySelector(
          `[${eG.swatchCount}]`
        )),
        (this.swatchElements = this.querySelectorAll(e3.swatchLink)),
        (this.swatchForm = this.productInfo.querySelector(e3.gridSwatchForm)),
        (this.hideSwatchesTimer = 0),
        this.swatchCount.hasAttribute(eG.swatchCount))
      ) {
        if (
          "text" == this.swatchesStyle ||
          "text-slider" == this.swatchesStyle
        ) {
          if (
            ((this.swatchCount.innerText = `${this.count} ${
              this.count > 1 ? theme.strings.otherColor : theme.strings.oneColor
            }`),
            "text" == this.swatchesStyle)
          )
            return;
          this.swatchCount.addEventListener("mouseenter", () => {
            this.hideSwatchesTimer && clearTimeout(this.hideSwatchesTimer),
              this.productInfo.classList.add(e2.stopEvents),
              this.swatchForm.classList.add(e2.visible);
          }),
            this.productInfo.addEventListener("mouseleave", () => {
              this.hideSwatchesTimer = setTimeout(() => {
                this.productInfo.classList.remove(e2.stopEvents),
                  this.swatchForm.classList.remove(e2.visible);
              }, 100);
            });
        }
        if (
          (("slider" == this.swatchesStyle || "grid" == this.swatchesStyle) &&
            this.swatchForm.classList.add(e2.visible),
          "limited" == this.swatchesStyle)
        ) {
          let t = this.count - this.limitedCount;
          this.swatchForm.classList.add(e2.visible),
            t > 0 &&
              (this.innerHTML += `<div class="swatch-limited">+${t}</div>`);
        }
      }
      ("text-slider" == this.swatchesStyle || "slider" == this.swatchesStyle) &&
        this.hasAttribute(eG.scrollbar) &&
        new ej(this),
        this.bindSwatchButtonEvents();
    }
    bindSwatchButtonEvents() {
      this.querySelectorAll(e3.swatchButton)?.forEach((t) => {
        t.addEventListener("mouseenter", this.showVariantImageEvent),
          t.hasAttribute(eG.tooltip) && new ee(t);
      }),
        this.productItem.addEventListener(
          "mouseleave",
          this.productItemMouseLeaveEvent
        );
    }
    showVariantImage(t) {
      let e = t.target,
        i = e.getAttribute(eG.variantName)?.replaceAll('"', "'"),
        s = this.productImage.querySelectorAll(`[${eG.variantTitle}]`),
        r = this.productImage.querySelector(`[${eG.variantTitle}="${i}"]`);
      s?.forEach((t) => {
        t.classList.remove(e2.visible);
      }),
        r?.classList.add(e2.visible);
    }
    hideVariantImages() {
      this.productImage
        .querySelectorAll(`[${eG.variantTitle}].${e2.visible}`)
        ?.forEach((t) => {
          t.classList.remove(e2.visible);
        });
    }
    getSwatchesJSON() {
      if (!this.hasAttribute(eG.swatchValues)) return {};
      let t = this.getAttribute(eG.swatchValues).split(","),
        e = {};
      return (
        t?.forEach((t) => {
          let [i, s] = t.split(":");
          e[i.trim()] = s.trim();
        }),
        e
      );
    }
  }
  function e1(t) {
    return t.replace(/http(s)?:/, "");
  }
  let e4 = {
      productCutline: "[data-product-cutline]",
      productLink: "[data-product-link]",
      productGridItem: "[data-grid-item]",
      productInfo: "[data-product-information]",
      productImage: "[data-product-image-default]",
      productImageSibling: "[data-product-image-sibling]",
      productPrice: "[data-product-price]",
      siblingsInnerHolder: "[data-sibling-inner]",
      siblingCount: "[data-sibling-count]",
      siblingFieldset: "[data-sibling-fieldset]",
      siblingLink: "[data-sibling-link]",
      tooltip: "[data-tooltip]",
    },
    e7 = {
      visible: "is-visible",
      fade: "is-fade",
      stopEvents: "no-events",
      active: "is-active",
    },
    eQ = {
      siblingAddedImage: "data-sibling-added-image",
      siblingCutline: "data-sibling-cutline",
      siblingImage: "data-sibling-image",
      siblingLink: "data-sibling-link",
      siblingPrice: "data-sibling-price",
      siblingCompareAtPrice: "data-sibling-compare-at-price",
      productLink: "data-product-link",
    };
  class eY {
    constructor(t, e) {
      (this.swatches = t),
        (this.product = e),
        (this.productLinks = this.product.querySelectorAll(e4.productLink)),
        (this.productCutline = this.product.querySelector(e4.productCutline)),
        (this.productPrice = this.product.querySelector(e4.productPrice)),
        (this.productImage = this.product.querySelector(e4.productImage)),
        (this.productImageSibling = this.product.querySelector(
          e4.productImageSibling
        )),
        this.init();
    }
    init() {
      this.cacheDefaultValues(),
        this.product.addEventListener("mouseleave", () =>
          this.resetProductValues()
        ),
        this.product.addEventListener("focusout", () =>
          this.resetProductValues()
        ),
        this.swatches.forEach((t) => {
          t.addEventListener("mouseenter", (t) => this.showSibling(t)),
            t.addEventListener("focusin", (t) => this.showSibling(t));
        }),
        this.productLinks.length &&
          this.swatches.forEach((t) => {
            t.addEventListener("click", () => {
              this.productLinks[0].click();
            }),
              t.addEventListener("keyup", (t) => {
                "Enter" === t.code && this.productLinks[0].click();
              });
          });
    }
    cacheDefaultValues() {
      (this.productLinkValue = this.productLinks[0].hasAttribute(eQ.productLink)
        ? this.productLinks[0].getAttribute(eQ.productLink)
        : ""),
        (this.productPriceValue = this.productPrice.innerHTML),
        this.productCutline &&
          (this.productCutlineValue = this.productCutline.innerHTML);
    }
    resetProductValues() {
      this.product.classList.remove(e7.active),
        this.productLinkValue &&
          this.productLinks.forEach((t) => {
            t.href = this.productLinkValue;
          }),
        this.productPrice &&
          (this.productPrice.innerHTML = this.productPriceValue),
        this.productCutline &&
          this.productCutline &&
          ((this.productCutline.innerHTML = this.productCutlineValue),
          (this.productCutline.title = this.productCutlineValue)),
        this.hideSiblingImage();
    }
    showSibling(t) {
      let e = t.target,
        i = e.hasAttribute(eQ.siblingLink)
          ? e.getAttribute(eQ.siblingLink)
          : "",
        s = e.hasAttribute(eQ.siblingPrice)
          ? e.getAttribute(eQ.siblingPrice)
          : "",
        r = e.hasAttribute(eQ.siblingCompareAtPrice)
          ? e.getAttribute(eQ.siblingCompareAtPrice)
          : "",
        o = e.hasAttribute(eQ.siblingCutline)
          ? e.getAttribute(eQ.siblingCutline)
          : "",
        a = e.hasAttribute(eQ.siblingImage)
          ? e.getAttribute(eQ.siblingImage)
          : "";
      i &&
        this.productLinks.forEach((t) => {
          t.href = i;
        }),
        r
          ? (this.productPrice.innerHTML = `<span class="price sale"><span class="new-price">${s}</span> <span class="old-price">${r}</span></span>`)
          : (this.productPrice.innerHTML = `<span class="price">${s}</span>`),
        this.productCutline &&
          (o
            ? ((this.productCutline.innerHTML = o),
              (this.productCutline.title = o))
            : ((this.productCutline.innerHTML = ""),
              (this.productCutline.title = ""))),
        a && this.showSiblingImage(a);
    }
    showSiblingImage(t) {
      if (!this.productImageSibling) return;
      let e = window.devicePixelRatio || 1,
        i = this.productImage.offsetWidth * e,
        s = (function t(e, i) {
          if (null === i) return e;
          if ("master" === i) return e1(e);
          let s = e.match(
            /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
          );
          if (!s) return null;
          {
            let r = e.split(s[0]),
              o = s[0];
            return e1(`${r[0]}_${i}${o}`);
          }
        })(t, `${180 * Math.ceil(i / 180)}x`),
        r = this.productImageSibling.querySelector(`[src="${s}"]`),
        o = () => {
          this.productImageSibling.classList.add(e7.visible),
            this.productImageSibling
              .querySelector(`[src="${s}"]`)
              .classList.add(e7.fade);
        },
        a = () => {
          this.productImageSibling.querySelectorAll("img").forEach((t) => {
            t.classList.remove(e7.fade);
          }),
            requestAnimationFrame(o);
        };
      if (r) a();
      else {
        let n = document.createElement("img");
        (n.src = s),
          this.productCutline && (n.alt = this.productCutline.innerText),
          n.addEventListener("load", () => {
            this.productImageSibling.append(n), a();
          });
      }
    }
    hideSiblingImage() {
      this.productImageSibling &&
        (this.productImageSibling.classList.remove(e7.visible),
        this.productImageSibling.querySelectorAll("img").forEach((t) => {
          t.classList.remove(e7.fade);
        }));
    }
  }
  class e5 extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      (this.product = this.closest(e4.productGridItem)),
        (this.siblingScrollbar = this.querySelector(e4.siblingsInnerHolder)),
        (this.siblingCount = this.querySelector(e4.siblingCount)),
        (this.siblingFieldset = this.querySelector(e4.siblingFieldset)),
        (this.siblingLinks = this.querySelectorAll(e4.siblingLink)),
        (this.productInfo = this.closest(e4.productInfo)),
        (this.productLink = this.closest(e4.link)),
        (this.hideSwatchesTimer = 0),
        (this.swatchesStyle = theme.settings.collectionSwatchStyle),
        this.initScrollbar(),
        this.siblingFieldset &&
          this.productInfo &&
          (("grid" == this.swatchesStyle ||
            "slider" == this.swatchesStyle ||
            "limited" == this.swatchesStyle) &&
            this.siblingFieldset.classList.add(e7.visible),
          this.siblingCount &&
            (this.siblingCount.addEventListener("mouseenter", () =>
              this.showSiblings()
            ),
            this.productInfo.addEventListener("mouseleave", () =>
              this.hideSiblings()
            ))),
        this.siblingLinks.length && new eY(this.siblingLinks, this.product),
        this.querySelectorAll(e4.tooltip).forEach((t) => {
          new ee(t);
        });
    }
    showSiblings() {
      this.hideSwatchesTimer && clearTimeout(this.hideSwatchesTimer),
        this.productLink && this.productLink.classList.add(e7.stopEvents),
        "text" != this.swatchesStyle &&
          this.siblingFieldset.classList.add(e7.visible);
    }
    hideSiblings() {
      this.hideSwatchesTimer = setTimeout(() => {
        this.productLink && this.productLink.classList.remove(e7.stopEvents),
          this.siblingFieldset.classList.remove(e7.visible);
      }, 100);
    }
    initScrollbar() {
      this.siblingScrollbar && new ej(this.siblingScrollbar);
    }
  }
  let e6 = {
    slide: "[data-hover-slide]",
    slideTouch: "[data-hover-slide-touch]",
    slider: "[data-hover-slider]",
    productLink: "[data-product-link]",
    flickityButton: ".flickity-prev-next-button",
  };
  class eK extends HTMLElement {
    constructor() {
      super(),
        (this.flkty = null),
        (this.slider = this.querySelector(e6.slider)),
        (this.handleScroll = this.handleScroll.bind(this));
    }
    connectedCallback() {
      window.theme.touch ? this.initTouch() : this.initFlickity();
    }
    disconnectedCallback() {
      this.flkty && ((this.flkty.options.watchCSS = !1), this.flkty.destroy());
    }
    initTouch() {
      this.style.setProperty(
        "--slides-count",
        this.querySelectorAll(e6.slideTouch).length
      ),
        this.slider.addEventListener("scroll", this.handleScroll);
    }
    handleScroll() {
      let t = this.slider.scrollLeft / this.slider.clientWidth;
      this.style.setProperty("--slider-index", t);
    }
    initFlickity() {
      this.querySelectorAll(e6.slide).length < 2 ||
        ((this.flkty = new e(this.slider, {
          cellSelector: e6.slide,
          contain: !0,
          wrapAround: !0,
          watchCSS: !0,
          autoPlay: !1,
          draggable: !1,
          pageDots: !1,
          prevNextButtons: !0,
        })),
        this.flkty.pausePlayer(),
        this.addEventListener("mouseenter", () => {
          this.flkty.unpausePlayer();
        }),
        this.addEventListener("mouseleave", () => {
          this.flkty.pausePlayer();
        }),
        this.closest(e6.productLink).addEventListener("click", (t) => {
          t.target.matches(e6.flickityButton) && t.preventDefault();
        }));
    }
  }
  let eZ = {
      body: "body",
      dataRelatedSectionElem: "[data-related-section]",
      dataTabsHolder: "[data-tabs-holder]",
      dataTab: "data-tab",
      dataTabIndex: "data-tab-index",
      dataAos: "[data-aos]",
      blockId: "data-block-id",
      tabsLi: "[data-tab]",
      tabLink: ".tab-link",
      tabLinkRecent: ".tab-link__recent",
      tabContent: ".tab-content",
      scrollbarHolder: "[data-scrollbar]",
    },
    it = {
      current: "current",
      hidden: "hidden",
      aosAnimate: "aos-animate",
      aosNoTransition: "aos-no-transition",
      focused: "is-focused",
    },
    ie = {};
  class ii {
    constructor(t) {
      (this.container = t),
        (this.body = document.querySelector(eZ.body)),
        (this.a11y = window.a11y),
        this.container &&
          ((this.scrollbarHolder = this.container.querySelectorAll(
            eZ.scrollbarHolder
          )),
          this.init(),
          this.initNativeScrollbar());
    }
    init() {
      let t = this.container.querySelectorAll(eZ.tabsLi);
      this.container.addEventListener("theme:tab:check", () =>
        this.checkRecentTab()
      ),
        this.container.addEventListener("theme:tab:hide", () =>
          this.hideRelatedTab()
        ),
        t.length &&
          t.forEach((t) => {
            let e = parseInt(t.getAttribute(eZ.dataTab)),
              i = this.container.querySelector(`${eZ.tabContent}-${e}`);
            t.addEventListener("click", () => {
              this.tabChange(t, i);
            }),
              t.addEventListener("keyup", (e) => {
                ("Space" === e.code || "Enter" === e.code) &&
                  this.body.classList.contains(it.focused) &&
                  this.tabChange(t, i);
              });
          });
    }
    tabChange(t, e) {
      if (t.classList.contains(it.current)) return;
      let i = this.container.querySelector(`${eZ.tabsLi}.${it.current}`),
        s = this.container.querySelector(`${eZ.tabContent}.${it.current}`);
      i?.classList.remove(it.current),
        s?.classList.remove(it.current),
        t.classList.add(it.current),
        e.classList.add(it.current),
        t.classList.contains(it.hidden) && e.classList.add(it.hidden),
        this.a11y.a11y.removeTrapFocus(),
        this.container.dispatchEvent(
          new CustomEvent("theme:tab:change", { bubbles: !0 })
        ),
        t.dispatchEvent(
          new CustomEvent("theme:form:sticky", {
            bubbles: !0,
            detail: { element: "tab" },
          })
        ),
        this.animateItems(e);
    }
    animateItems(t, e = !0) {
      let i = t.querySelectorAll(eZ.dataAos);
      i.length &&
        i.forEach((t) => {
          t.classList.remove(it.aosAnimate),
            e &&
              (t.classList.add(it.aosNoTransition),
              requestAnimationFrame(() => {
                t.classList.remove(it.aosNoTransition),
                  t.classList.add(it.aosAnimate);
              }));
        });
    }
    initNativeScrollbar() {
      this.scrollbarHolder.length &&
        this.scrollbarHolder.forEach((t) => {
          new ej(t);
        });
    }
    checkRecentTab() {
      let t = this.container.querySelector(eZ.tabLinkRecent);
      if (t) {
        t.classList.remove(it.hidden);
        let e = parseInt(t.getAttribute(eZ.dataTab)),
          i = this.container.querySelector(
            `${eZ.tabContent}[${eZ.dataTabIndex}="${e}"]`
          );
        i && (i.classList.remove(it.hidden), this.animateItems(i, !1)),
          this.initNativeScrollbar();
      }
    }
    hideRelatedTab() {
      let t = this.container.querySelector(eZ.dataRelatedSectionElem);
      if (!t) return;
      let e = t.closest(`${eZ.tabContent}.${it.current}`);
      if (!e) return;
      let i = parseInt(e.getAttribute(eZ.dataTabIndex)),
        s = this.container.querySelectorAll(eZ.tabsLi);
      if (s.length > i) {
        let r = s[i].nextSibling;
        r &&
          (s[i].classList.add(it.hidden),
          r.dispatchEvent(new Event("click")),
          this.initNativeScrollbar());
      }
    }
    onBlockSelect(t) {
      let e = this.container.querySelector(
        `${eZ.tabLink}[${eZ.blockId}="${t.detail.blockId}"]`
      );
      e &&
        (e.dispatchEvent(new Event("click")),
        e.parentNode.scrollTo({
          top: 0,
          left: e.offsetLeft - e.clientWidth,
          behavior: "smooth",
        }));
    }
  }
  let is = {
    onLoad() {
      ie[this.id] = [];
      let t = this.container.querySelectorAll(eZ.dataTabsHolder);
      t.forEach((t) => {
        ie[this.id].push(new ii(t));
      });
    },
    onBlockSelect(t) {
      ie[this.id].forEach((e) => {
        "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
      });
    },
  };
  function ir() {
    let t = Boolean(
        document.querySelectorAll("dialog[open][data-scroll-lock-required]")
          .length
      ),
      e = Boolean(document.querySelectorAll(".drawer.is-open").length);
    return t || e;
  }
  let io = {
      added: "is-added",
      animated: "is-animated",
      disabled: "is-disabled",
      error: "has-error",
      loading: "is-loading",
      open: "is-open",
      overlayText: "product-item--overlay-text",
      visible: "is-visible",
      siblingLinkCurrent: "sibling__link--current",
    },
    ia = { errorDelay: 3e3 },
    il = {
      animation: "[data-animation]",
      apiContent: "[data-api-content]",
      buttonQuickAdd: "[data-quick-add-btn]",
      buttonAddToCart: "[data-add-to-cart]",
      cartDrawer: "cart-drawer",
      cartPage: "[data-cart-page]",
      cartLineItems: "[data-line-items]",
      dialog: "dialog",
      focusable:
        'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
      messageError: "[data-message-error]",
      modalButton: "[data-quick-add-modal-handle]",
      modalContainer: "[data-product-upsell-container]",
      modalContent: "[data-product-upsell-ajax]",
      modalClose: "[data-quick-add-modal-close]",
      productGridItem: "data-grid-item",
      productInformationHolder: "[data-product-information]",
      quickAddHolder: "[data-quick-add-holder]",
      quickAddModal: "[data-quick-add-modal]",
      quickAddModalTemplate: "[data-quick-add-modal-template]",
      tooltip: "[data-tooltip]",
    },
    ic = {
      closing: "closing",
      productId: "data-product-id",
      modalHandle: "data-quick-add-modal-handle",
      siblingSwapper: "data-sibling-swapper",
      quickAddHolder: "data-quick-add-holder",
    };
  class id extends HTMLElement {
    constructor() {
      super(),
        (this.container = this),
        (this.quickAddHolder = this.container.querySelector(il.quickAddHolder)),
        this.quickAddHolder &&
          ((this.modal = null),
          (this.currentModal = null),
          (this.productId = this.quickAddHolder.getAttribute(
            ic.quickAddHolder
          )),
          (this.modalButton = this.quickAddHolder.querySelector(
            il.modalButton
          )),
          (this.handle = this.modalButton?.getAttribute(ic.modalHandle)),
          (this.buttonQuickAdd = this.quickAddHolder.querySelector(
            il.buttonQuickAdd
          )),
          (this.buttonATC = this.quickAddHolder.querySelector(
            il.buttonAddToCart
          )),
          (this.button = this.modalButton || this.buttonATC),
          (this.modalClose = this.modalClose.bind(this)),
          (this.modalCloseOnProductAdded =
            this.modalCloseOnProductAdded.bind(this)),
          (this.a11y = M),
          (this.isAnimating = !1),
          (this.modalButtonClickEvent = this.modalButtonClickEvent.bind(this)),
          (this.quickAddLoadingToggle = this.quickAddLoadingToggle.bind(this)));
    }
    connectedCallback() {
      this.modalButton &&
        this.modalButton.addEventListener("click", this.modalButtonClickEvent),
        this.buttonATC &&
          this.buttonATC.addEventListener("click", (t) => {
            t.preventDefault(),
              (window.a11y.lastElement = this.buttonATC),
              document.dispatchEvent(
                new CustomEvent("theme:cart:add", {
                  detail: { button: this.buttonATC },
                })
              );
          }),
        this.quickAddHolder &&
          (this.quickAddHolder.addEventListener(
            "animationend",
            this.quickAddLoadingToggle
          ),
          this.errorHandler());
    }
    modalButtonClickEvent(t) {
      t.preventDefault();
      let e = this.modalButton.hasAttribute(ic.siblingSwapper),
        i = this.modalButton.classList.contains(io.siblingLinkCurrent);
      i ||
        (this.modalButton.classList.add(io.loading),
        (this.modalButton.disabled = !0),
        e &&
          !i &&
          ((this.currentModal = t.target.closest(il.quickAddModal)),
          this.currentModal.classList.add(io.loading)),
        this.renderModal());
    }
    modalCreate(t) {
      let e = document.querySelector(
        `${il.quickAddModal}[${ic.productId}="${this.productId}"]`
      );
      if (e) (this.modal = e), this.modalOpen();
      else {
        let i = this.quickAddHolder.querySelector(il.quickAddModalTemplate);
        if (!i) return;
        let s = document.createElement("div");
        (s.innerHTML = i.innerHTML),
          document.body.appendChild(s.querySelector(il.quickAddModal)),
          i.remove(),
          (this.modal = document.querySelector(
            `${il.quickAddModal}[${ic.productId}="${this.productId}"]`
          )),
          (this.modal.querySelector(il.modalContent).innerHTML = new DOMParser()
            .parseFromString(t, "text/html")
            .querySelector(il.apiContent).innerHTML),
          this.modal.querySelectorAll(il.tooltip).forEach((t) => {
            new ee(t);
          }),
          this.modalCreatedCallback();
      }
    }
    modalOpen() {
      this.currentModal &&
        this.currentModal.dispatchEvent(
          new CustomEvent("theme:modal:close", { bubbles: !1 })
        ),
        "function" == typeof this.modal.show && this.modal.show(),
        this.modal.setAttribute("open", !0),
        this.modal.removeAttribute("inert"),
        this.quickAddHolder.classList.add(io.disabled),
        this.modalButton &&
          (this.modalButton.classList.remove(io.loading),
          (this.modalButton.disabled = !1),
          (window.a11y.lastElement = this.modalButton)),
        requestAnimationFrame(() => {
          this.modal.querySelectorAll(il.animation).forEach((t) => {
            t.classList.add(io.animated);
          });
        }),
        document.dispatchEvent(
          new CustomEvent("theme:quick-add:open", { bubbles: !0 })
        ),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:lock", { bubbles: !0 })
        ),
        document.addEventListener(
          "theme:product:added",
          this.modalCloseOnProductAdded,
          { once: !0 }
        );
    }
    modalClose() {
      if (!this.isAnimating) {
        if (!this.modal.hasAttribute(ic.closing)) {
          this.modal.setAttribute(ic.closing, ""), (this.isAnimating = !0);
          return;
        }
        "function" == typeof this.modal.close
          ? this.modal.close()
          : this.modal.removeAttribute("open"),
          this.modal.removeAttribute(ic.closing),
          this.modal.setAttribute("inert", ""),
          this.modal.classList.remove(io.loading),
          this.modalButton && (this.modalButton.disabled = !1),
          this.quickAddHolder &&
            this.quickAddHolder.classList.contains(io.disabled) &&
            this.quickAddHolder.classList.remove(io.disabled),
          this.resetAnimatedItems(),
          ir() ||
            document.dispatchEvent(
              new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
            ),
          document.removeEventListener(
            "theme:product:added",
            this.modalCloseOnProductAdded
          ),
          this.a11y.removeTrapFocus(),
          this.a11y.autoFocusLastElement();
      }
    }
    modalEvents() {
      this.modal
        .querySelector(il.modalClose)
        ?.addEventListener("click", (t) => {
          t.preventDefault(), this.modalClose();
        }),
        this.modal.addEventListener("click", (t) => {
          "DIALOG" === t.target.nodeName &&
            "click" === t.type &&
            this.modalClose();
        }),
        this.modal.addEventListener("keydown", (t) => {
          "Escape" == t.code && (t.preventDefault(), this.modalClose());
        }),
        this.modal.addEventListener("theme:modal:close", () => {
          this.modalClose();
        }),
        this.modal.addEventListener("animationend", (t) => {
          t.target === this.modal &&
            ((this.isAnimating = !1),
            this.modal.hasAttribute(ic.closing)
              ? this.modalClose()
              : setTimeout(() => {
                  this.a11y.trapFocus(this.modal);
                  let t =
                    this.modal.querySelector("[autofocus]") ||
                    this.modal.querySelector(il.focusable);
                  t?.focus();
                }, 50));
        });
    }
    modalCloseOnProductAdded() {
      this.resetQuickAddButtons(),
        this.modal && this.modal.hasAttribute("open") && this.modalClose();
    }
    quickAddLoadingToggle(t) {
      t.target == this.quickAddHolder &&
        this.quickAddHolder.classList.remove(io.disabled);
    }
    errorHandler() {
      this.quickAddHolder.addEventListener("theme:cart:error", (t) => {
        let e = t.detail.holder,
          i = e.closest(`[${il.productGridItem}]`);
        if (!i) return;
        let s = e.querySelector(il.messageError),
          r = i.classList.contains(io.overlayText),
          o = i.querySelector(il.productInformationHolder),
          a = e.querySelector(il.buttonAddToCart);
        a &&
          (a.classList.remove(io.added, io.loading), e.classList.add(io.error)),
          s && (s.innerText = t.detail.description),
          r && o.classList.add(io.hidden),
          setTimeout(() => {
            this.resetQuickAddButtons(), r && o.classList.remove(io.hidden);
          }, ia.errorDelay);
      });
    }
    resetQuickAddButtons() {
      this.quickAddHolder &&
        this.quickAddHolder.classList.remove(io.visible, io.error),
        this.buttonQuickAdd &&
          (this.buttonQuickAdd.classList.remove(io.added),
          (this.buttonQuickAdd.disabled = !1));
    }
    renderModal() {
      this.modal
        ? this.modalOpen()
        : window
            .fetch(
              `${window.theme.routes.root}products/${this.handle}?section_id=api-product-upsell`
            )
            .then(this.upsellErrorsHandler)
            .then((t) => t.text())
            .then((t) => {
              this.modalCreate(t);
            });
    }
    modalCreatedCallback() {
      this.modalEvents(), this.modalOpen(), q(this.modal);
    }
    upsellErrorsHandler(t) {
      return t.ok
        ? t
        : t.json().then(function (e) {
            let i = new tx({
              status: t.statusText,
              headers: t.headers,
              json: e,
            });
            throw i;
          });
    }
    resetAnimatedItems() {
      this.modal?.querySelectorAll(il.animation).forEach((t) => {
        t.classList.remove(io.animated);
      });
    }
  }
  t4("product-grid", [is]),
    customElements.get("quick-add-product") ||
      customElements.define("quick-add-product", id),
    customElements.get("radio-swatch") ||
      customElements.define("radio-swatch", eJ),
    customElements.get("grid-swatch") ||
      customElements.define("grid-swatch", eX),
    customElements.get("product-siblings") ||
      customElements.define("product-siblings", e5),
    customElements.get("hover-images") ||
      customElements.define("hover-images", eK);
  let ih = {
      productPage: ".product__page",
      formWrapper: "[data-form-wrapper]",
      headerSticky: "[data-header-sticky]",
      productMediaList: "[data-product-media-list]",
    },
    iu = { sticky: "is-sticky" };
  window.theme.variables = { productPageSticky: !1 };
  let ip = {};
  class im {
    constructor(t) {
      (this.section = t),
        (this.container = t.container),
        (this.stickyEnabled =
          "true" === this.container.getAttribute("data-sticky-enabled")),
        (this.formWrapper = this.container.querySelector(ih.formWrapper)),
        (this.stickyScrollTop = 0),
        (this.scrollLastPosition = 0),
        (this.stickyDefaultTop = 0),
        (this.currentPoint = 0),
        (this.defaultTopBottomSpacings = 30),
        (this.scrollTop = window.scrollY),
        (this.scrollDirectionDown = !0),
        (this.requestAnimationSticky = null),
        (this.stickyFormLoad = !0),
        (this.stickyFormLastHeight = null),
        (this.onChangeCounter = 0),
        (this.scrollEvent = (t) => this.scrollEvents(t)),
        (this.resizeEvent = (t) => this.resizeEvents(t)),
        (this.stickyFormEvent = (t) => this.stickyFormEvents(t)),
        setTimeout(() => {
          this.init();
        }, 50);
    }
    init() {
      this.stickyEnabled &&
        (this.stickyScrollCheck(),
        document.addEventListener("theme:resize", this.resizeEvent)),
        this.initSticky();
    }
    initSticky() {
      theme.variables.productPageSticky &&
        ((this.requestAnimationSticky = requestAnimationFrame(() =>
          this.calculateStickyPosition()
        )),
        this.formWrapper.addEventListener(
          "theme:form:sticky",
          this.stickyFormEvent
        ),
        document.addEventListener("theme:scroll", this.scrollEvent));
    }
    stickyFormEvents(t) {
      this.removeAnimationFrameSticky(),
        (this.requestAnimationSticky = requestAnimationFrame(() =>
          this.calculateStickyPosition(t)
        ));
    }
    scrollEvents(t) {
      (this.scrollTop = t.detail.position),
        (this.scrollDirectionDown = t.detail.down),
        this.requestAnimationSticky ||
          (this.requestAnimationSticky = requestAnimationFrame(() =>
            this.calculateStickyPosition()
          ));
    }
    resizeEvents(t) {
      this.stickyScrollCheck(),
        document.removeEventListener("theme:scroll", this.scrollEvent),
        this.formWrapper.removeEventListener(
          "theme:form:sticky",
          this.stickyFormEvent
        ),
        this.initSticky();
    }
    stickyScrollCheck() {
      let t = this.container.querySelector(
        `${ih.productPage} ${ih.formWrapper}`
      );
      if (t) {
        if (g()) {
          let e = this.container.querySelector(ih.formWrapper),
            i = this.container.querySelector(ih.productMediaList);
          if (!e || !i) return;
          let s = e.offsetHeight,
            r = i.offsetHeight;
          s < r
            ? ((theme.variables.productPageSticky = !0),
              t.classList.add(iu.sticky))
            : ((theme.variables.productPageSticky = !1),
              t.classList.remove(iu.sticky));
        } else
          (theme.variables.productPageSticky = !1),
            t.classList.remove(iu.sticky);
      }
    }
    calculateStickyPosition(t = null) {
      let e = document.documentElement.hasAttribute("data-scroll-locked");
      if (e) {
        this.removeAnimationFrameSticky();
        return;
      }
      let i = Boolean(t && t.detail),
        s = Boolean(i && t.detail.element && "accordion" === t.detail.element),
        r = this.formWrapper.offsetHeight,
        o = window.innerHeight - r - this.defaultTopBottomSpacings,
        n = Math.abs(this.scrollTop - this.scrollLastPosition);
      if (
        (this.scrollDirectionDown
          ? (this.stickyScrollTop -= n)
          : (this.stickyScrollTop += n),
        this.stickyFormLoad)
      ) {
        if (document.querySelector(ih.headerSticky)) {
          let { headerHeight: l } = a();
          this.stickyDefaultTop = l;
        } else this.stickyDefaultTop = this.defaultTopBottomSpacings;
        this.stickyScrollTop = this.stickyDefaultTop;
      }
      this.stickyScrollTop = Math.min(
        Math.max(this.stickyScrollTop, o),
        this.stickyDefaultTop
      );
      let c = this.stickyScrollTop - this.currentPoint;
      (this.currentPoint = this.stickyFormLoad
        ? this.stickyScrollTop
        : this.currentPoint + 0.5 * c),
        this.formWrapper.style.setProperty(
          "--sticky-top",
          `${this.currentPoint}px`
        ),
        (this.scrollLastPosition = this.scrollTop),
        (this.stickyFormLoad = !1),
        (s && this.onChangeCounter <= 10) ||
        (s && this.stickyFormLastHeight !== r) ||
        (this.stickyScrollTop !== this.currentPoint &&
          this.requestAnimationSticky)
          ? (s && (this.onChangeCounter += 1),
            s && this.stickyFormLastHeight !== r && (this.onChangeCounter = 11),
            (this.requestAnimationSticky = requestAnimationFrame(() =>
              this.calculateStickyPosition(t)
            )))
          : this.requestAnimationSticky && this.removeAnimationFrameSticky(),
        (this.stickyFormLastHeight = r);
    }
    removeAnimationFrameSticky() {
      this.requestAnimationSticky &&
        (cancelAnimationFrame(this.requestAnimationSticky),
        (this.requestAnimationSticky = null),
        (this.onChangeCounter = 0));
    }
    onUnload() {
      this.stickyEnabled &&
        document.removeEventListener("theme:resize", this.resizeEvent),
        theme.variables.productPageSticky &&
          document.removeEventListener("theme:scroll", this.scrollEvent);
    }
  }
  let ig = {
      optionPosition: "data-option-position",
      optionInput: '[name^="options"], [data-popout-option]',
      optionInputCurrent:
        '[name^="options"]:checked, [name^="options"][type="hidden"]',
      selectOptionValue: "data-value",
      popout: "[data-popout]",
    },
    ib = { soldOut: "sold-out", unavailable: "unavailable", sale: "sale" };
  class iv {
    constructor(t, e) {
      (this.container = t),
        (this.productJSON = e),
        (this.optionElements = this.container.querySelectorAll(ig.optionInput)),
        this.productJSON && this.optionElements.length && this.init();
    }
    init() {
      this.update();
    }
    update() {
      this.getCurrentState(),
        this.optionElements.forEach((t) => {
          let e = t.closest(`[${ig.optionPosition}]`);
          if (!e) return;
          let i = t.value || t.getAttribute(ig.selectOptionValue),
            s = e.getAttribute(ig.optionPosition),
            r = parseInt(s, 10) - 1,
            o = t.closest(ig.popout),
            a = [...this.selections];
          a[r] = i;
          let n = this.productJSON.variants.find((t) => {
            let e = !0;
            for (let i = 0; i < a.length; i++)
              t.options[i] !== a[i] && (e = !1);
            return e;
          });
          t.classList.remove(ib.soldOut, ib.unavailable),
            t.parentNode.classList.remove(ib.sale),
            o && o.classList.remove(ib.soldOut, ib.unavailable, ib.sale),
            void 0 === n
              ? (t.classList.add(ib.unavailable),
                o && o.classList.add(ib.unavailable))
              : n &&
                !1 === n.available &&
                (t.classList.add(ib.soldOut), o && o.classList.add(ib.soldOut)),
            n &&
              n.compare_at_price > n.price &&
              theme.settings.variantOnSale &&
              t.parentNode.classList.add(ib.sale);
        });
    }
    getCurrentState() {
      this.selections = [];
      let t = this.container.querySelectorAll(ig.optionInputCurrent);
      t.length &&
        t.forEach((t) => {
          let e = t.value;
          e && "" !== e && this.selections.push(e);
        });
    }
  }
  let iy = {
      product: "[data-product]",
      productForm: "[data-product-form]",
      productNotification: "product-notification",
      variantTitle: "[data-variant-title]",
      notificationProduct: "[data-notification-product]",
      addToCart: "[data-add-to-cart]",
      addToCartText: "[data-add-to-cart-text]",
      cartPage: "[data-cart-page]",
      comparePrice: "[data-compare-price]",
      comparePriceText: "[data-compare-text]",
      finalSaleBadge: "[data-final-sale-badge]",
      formWrapper: "[data-form-wrapper]",
      originalSelectorId: "[data-product-select]",
      priceWrapper: "[data-price-wrapper]",
      productImages: "product-images",
      productImage: "[data-product-image]",
      productMediaList: "[data-product-media-list]",
      productJson: "[data-product-json]",
      productPrice: "[data-product-price]",
      unitPrice: "[data-product-unit-price]",
      unitBase: "[data-product-base]",
      unitWrapper: "[data-product-unit]",
      isPreOrder: "[data-product-preorder]",
      productSlide: ".product__slide",
      subPrices: "[data-subscription-watch-price]",
      subSelectors: "[data-subscription-selectors]",
      subsToggle: "[data-toggles-group]",
      subsChild: "data-group-toggle",
      subDescription: "[data-plan-description]",
      section: "[data-section-type]",
      variantSku: "[data-variant-sku]",
      variantFinalSaleMeta: "[data-variant-final-sale-metafield]",
      variantButtons: "[data-variant-buttons]",
      variantOptionImage: "[data-variant-option-image]",
      quickAddModal: "[data-quick-add-modal]",
      priceOffAmount: "[data-price-off-amount]",
      priceOffBadge: "[data-price-off-badge]",
      priceOffType: "[data-price-off-type]",
      priceOffWrap: "[data-price-off]",
      remainingCount: "[data-remaining-count]",
      remainingMax: "[data-remaining-max]",
      remainingWrapper: "[data-remaining-wrapper]",
      remainingJSON: "[data-product-remaining-json]",
      optionValue: "[data-option-value]",
      optionPosition: "[data-option-position]",
      installment: "[data-product-form-installment]",
      inputId: 'input[name="id"]',
    },
    iS = {
      hidden: "hidden",
      variantSoldOut: "variant--soldout",
      variantUnavailable: "variant--unavailable",
      productPriceSale: "product__price--sale",
      remainingLow: "count-is-low",
      remainingIn: "count-is-in",
      remainingOut: "count-is-out",
      remainingUnavailable: "count-is-unavailable",
    },
    iw = {
      remainingMaxAttr: "data-remaining-max",
      enableHistoryState: "data-enable-history-state",
      notificationPopup: "data-notification-popup",
      faderDesktop: "data-fader-desktop",
      faderMobile: "data-fader-mobile",
      optionPosition: "data-option-position",
      imageId: "data-image-id",
      mediaId: "data-media-id",
      quickAddButton: "data-quick-add-btn",
      finalSale: "data-final-sale",
      variantImageScroll: "data-variant-image-scroll",
    };
  class iL extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      if (
        (this.cartAddEvents(),
        (this.container =
          this.closest(iy.section) || this.closest(iy.quickAddModal)),
        !this.container)
      )
        return;
      if (
        ((this.sectionId = this.container.dataset.sectionId),
        (this.product = this.container.querySelector(iy.product)),
        (this.productForm = this.container.querySelector(iy.productForm)),
        (this.productNotification = this.container.querySelector(
          iy.productNotification
        )),
        (this.productImages = this.container.querySelector(iy.productImages)),
        (this.productMediaList = this.container.querySelector(
          iy.productMediaList
        )),
        (this.installmentForm = this.container.querySelector(iy.installment)),
        (this.skuWrapper = this.container.querySelector(iy.variantSku)),
        (this.sellout = null),
        (this.variantImageScroll =
          "true" === this.container.getAttribute(iw.variantImageScroll)),
        (this.priceOffWrap = this.container.querySelector(iy.priceOffWrap)),
        (this.priceOffAmount = this.container.querySelector(iy.priceOffAmount)),
        (this.priceOffType = this.container.querySelector(iy.priceOffType)),
        (this.planDescription = this.container.querySelector(
          iy.subDescription
        )),
        (this.remainingWrapper = this.container.querySelector(
          iy.remainingWrapper
        )),
        this.remainingWrapper)
      ) {
        let t = this.container.querySelector(iy.remainingMax);
        t &&
          ((this.remainingMaxInt = parseInt(
            t.getAttribute(iw.remainingMaxAttr),
            10
          )),
          (this.remainingCount = this.container.querySelector(
            iy.remainingCount
          )),
          (this.remainingJSONWrapper = this.container.querySelector(
            iy.remainingJSON
          )),
          (this.remainingJSON = null),
          this.remainingJSONWrapper &&
          "" !== this.remainingJSONWrapper.innerHTML
            ? (this.remainingJSON = JSON.parse(
                this.remainingJSONWrapper.innerHTML
              ))
            : console.warn("Missing product quantity JSON"));
      }
      (this.enableHistoryState =
        "true" === this.container.getAttribute(iw.enableHistoryState)),
        (this.hasUnitPricing = this.container.querySelector(iy.unitWrapper)),
        (this.subSelectors = this.container.querySelector(iy.subSelectors)),
        (this.subPrices = this.container.querySelector(iy.subPrices)),
        (this.isPreOrder = this.container.querySelector(iy.isPreOrder));
      let e = null,
        i = this.container.querySelector(iy.productJson);
      i && (e = i.innerHTML),
        e
          ? ((this.productJSON = JSON.parse(e)),
            this.linkForm(),
            (this.sellout = new iv(this.container, this.productJSON)))
          : console.error("Missing product JSON"),
        (this.variantOptionImages = this.container.querySelectorAll(
          iy.variantOptionImage
        )),
        (this.variantButtons = this.container.querySelectorAll(
          iy.variantButtons
        )),
        this.variantOptionImages.length > 1 && this.optionImagesWidth();
    }
    cartAddEvents() {
      (this.buttonATC = this.querySelector(iy.addToCart)),
        this.buttonATC.addEventListener("click", (t) => {
          t.preventDefault(),
            document.dispatchEvent(
              new CustomEvent("theme:cart:add", {
                detail: { button: this.buttonATC },
                bubbles: !1,
              })
            ),
            this.closest(iy.quickAddModal) ||
              (window.a11y.lastElement = this.buttonATC);
        });
    }
    destroy() {
      this.productForm.destroy();
    }
    linkForm() {
      (this.productForm = new eU(this.container, this.productJSON, {
        onOptionChange: this.onOptionChange.bind(this),
        onPlanChange: this.onPlanChange.bind(this),
      })),
        this.pushState(this.productForm.getFormState(), !0),
        this.subsToggleListeners();
    }
    onOptionChange(t) {
      this.pushState(t.dataset), this.updateProductImage(t);
    }
    onPlanChange(t) {
      this.subPrices && this.pushState(t.dataset);
    }
    pushState(t, e = !1) {
      (this.productState = this.setProductState(t)),
        this.updateAddToCartState(t),
        this.updateNotificationForm(t),
        this.updateProductPrices(t),
        this.updateSaleText(t),
        this.updateSku(t),
        this.updateSubscriptionText(t),
        this.updateRemaining(t),
        this.updateLegend(t),
        this.fireHookEvent(t),
        this.sellout?.update(t),
        this.enableHistoryState && !e && this.updateHistoryState(t);
    }
    updateAddToCartState(t) {
      let e = t.variant,
        i = theme.strings.addToCart,
        s = this.container.querySelectorAll(iy.priceWrapper),
        r = this.container.querySelectorAll(iy.addToCart),
        o = this.container.querySelectorAll(iy.addToCartText),
        a = this.container.querySelectorAll(iy.formWrapper);
      if (this.installmentForm && e) {
        let n = this.installmentForm.querySelector(iy.inputId);
        (n.value = e.id), n.dispatchEvent(new Event("change", { bubbles: !0 }));
      }
      this.isPreOrder && (i = theme.strings.preOrder),
        s.length &&
          e &&
          s.forEach((t) => {
            t.classList.remove(iS.hidden);
          }),
        r?.forEach((t) => {
          t.hasAttribute(iw.quickAddButton) ||
            (e && e.available ? (t.disabled = !1) : (t.disabled = !0));
        }),
        o?.forEach((t) => {
          let s = i;
          e
            ? e.available || (s = theme.strings.soldOut)
            : (s = theme.strings.unavailable),
            (t.textContent = s);
        }),
        a.length &&
          a.forEach((t) => {
            if (e) {
              e.available
                ? t.classList.remove(iS.variantSoldOut, iS.variantUnavailable)
                : (t.classList.add(iS.variantSoldOut),
                  t.classList.remove(iS.variantUnavailable));
              let i = t.querySelector(iy.originalSelectorId);
              i && (i.value = e.id);
              let s = t.querySelector(`${iy.inputId}[form]`);
              s && ((s.value = e.id), s.dispatchEvent(new Event("change")));
            } else
              t.classList.add(iS.variantUnavailable),
                t.classList.remove(iS.variantSoldOut);
          });
    }
    updateNotificationForm(t) {
      if (!this.productNotification) return;
      let e = this.productNotification.querySelector(iy.variantTitle),
        i = this.productNotification.querySelector(iy.notificationProduct);
      null != e &&
        ((e.textContent = t.variant.title), (i.value = t.variant.name));
    }
    updateHistoryState(t) {
      let e = t.variant,
        i = t.plan,
        s = window.location.href;
      if (e && s.includes("/product")) {
        let r = new window.URL(s),
          o = r.searchParams;
        o.set("variant", e.id),
          i && i.detail && i.detail.id && this.productState.hasPlan
            ? o.set("selling_plan", i.detail.id)
            : o.delete("selling_plan"),
          (r.search = o.toString());
        let a = r.toString();
        window.history.replaceState({ path: a }, "", a);
      }
    }
    updateRemaining(t) {
      let e = t.variant;
      if (
        (this.remainingWrapper?.classList.remove(
          iS.remainingIn,
          iS.remainingOut,
          iS.remainingUnavailable,
          iS.remainingLow
        ),
        e && this.remainingWrapper && this.remainingJSON)
      ) {
        let i = this.remainingJSON[e.id];
        ("out" === i || i < 1) &&
          this.remainingWrapper.classList.add(iS.remainingOut),
          ("in" === i || i >= this.remainingMaxInt) &&
            this.remainingWrapper.classList.add(iS.remainingIn),
          ("low" === i || (i > 0 && i < this.remainingMaxInt)) &&
            (this.remainingWrapper.classList.add(iS.remainingLow),
            this.remainingCount && (this.remainingCount.innerHTML = i));
      } else
        !e &&
          this.remainingWrapper &&
          this.remainingWrapper.classList.add(iS.remainingUnavailable);
    }
    optionImagesWidth() {
      if (!this.variantButtons) return;
      let t = 0;
      requestAnimationFrame(() => {
        this.variantOptionImages.forEach((e) => {
          let i = e.clientWidth;
          i > t && (t = i);
        }),
          this.variantButtons.forEach((e) => {
            e.style?.setProperty("--option-image-width", t + "px");
          });
      });
    }
    getBaseUnit(t) {
      return 1 === t.unit_price_measurement.reference_value
        ? t.unit_price_measurement.reference_unit
        : t.unit_price_measurement.reference_value +
            t.unit_price_measurement.reference_unit;
    }
    subsToggleListeners() {
      let t = this.container.querySelectorAll(iy.subsToggle);
      t.forEach((t) => {
        t.addEventListener(
          "change",
          function (t) {
            let e = t.target.value.toString(),
              i = this.container.querySelector(`[${iy.subsChild}="${e}"]`),
              s = this.container.querySelectorAll(`[${iy.subsChild}]`);
            if (i) {
              i.classList.remove(iS.hidden);
              let r = i.querySelector('[name="selling_plan"]');
              (r.checked = !0), r.dispatchEvent(new Event("change"));
            }
            s.forEach((t) => {
              if (t !== i) {
                t.classList.add(iS.hidden);
                let e = t.querySelectorAll('[name="selling_plan"]');
                e.forEach((t) => {
                  (t.checked = !1), t.dispatchEvent(new Event("change"));
                });
              }
            });
          }.bind(this)
        );
      });
    }
    updateSaleText(t) {
      this.productState.planSale
        ? this.updateSaleTextSubscription(t)
        : this.productState.onSale
        ? this.updateSaleTextStandard(t)
        : this.priceOffWrap && this.priceOffWrap.classList.add(iS.hidden);
    }
    isVariantFinalSale(t) {
      let e = document.querySelector(iy.variantFinalSaleMeta)?.textContent;
      if (!e) return;
      let i = JSON.parse(e),
        s = !1;
      return (
        i.forEach((e) => {
          Number(e.variant_id) === t.id && (s = "true" === e.metafield_value);
        }),
        s
      );
    }
    updateSaleTextStandard(t) {
      let e = t.variant,
        i = this.priceOffWrap?.querySelector(iy.finalSaleBadge),
        s = this.priceOffWrap?.querySelector(iy.priceOffBadge),
        r = e?.compare_at_price,
        o = e?.price;
      this.priceOffType &&
        (this.priceOffType.innerHTML = window.theme.strings.sale || "sale"),
        s && this.priceOffAmount && r && o && !(r <= o)
          ? ((this.priceOffAmount.innerHTML = `${Math.round(
              ((r - o) / r) * 100
            )}%`),
            s.classList.remove(iS.hidden))
          : s?.classList.add(iS.hidden);
      let a =
        this.priceOffWrap?.hasAttribute(iw.finalSale) ||
        this.isVariantFinalSale(e);
      i && i.classList.toggle(iS.hidden, !a),
        this.priceOffWrap.classList.remove(iS.hidden);
    }
    updateSubscriptionText(t) {
      t.plan && this.planDescription
        ? ((this.planDescription.innerHTML = t.plan.detail.description),
          this.planDescription.classList.remove(iS.hidden))
        : this.planDescription && this.planDescription.classList.add(iS.hidden);
    }
    updateSaleTextSubscription(t) {
      if (
        (this.priceOffType &&
          (this.priceOffType.innerHTML =
            window.theme.strings.subscription || "subscripton"),
        this.priceOffAmount && this.priceOffWrap)
      ) {
        let e = t.plan.detail.price_adjustments[0],
          i = e.value;
        e && "percentage" === e.value_type
          ? (this.priceOffAmount.innerHTML = `${i}%`)
          : (this.priceOffAmount.innerHTML = t$(i, theme.moneyFormat)),
          this.priceOffWrap.classList.remove(iS.hidden);
      }
    }
    updateProductPrices(t) {
      let e = t.variant,
        i = t.plan,
        s = this.container.querySelectorAll(iy.priceWrapper);
      s.forEach((t) => {
        let s = t.querySelector(iy.comparePrice),
          r = t.querySelector(iy.productPrice),
          o = t.querySelector(iy.comparePriceText),
          a = "",
          n = "";
        this.productState.available &&
          ((a = e.compare_at_price), (n = e.price)),
          this.productState.hasPlan && (n = i.allocation.price),
          this.productState.planSale &&
            ((a = i.allocation.compare_at_price), (n = i.allocation.price)),
          s &&
            (this.productState.onSale || this.productState.planSale
              ? (s.classList.remove(iS.hidden),
                o.classList.remove(iS.hidden),
                r.classList.add(iS.productPriceSale))
              : (s.classList.add(iS.hidden),
                o.classList.add(iS.hidden),
                r.classList.remove(iS.productPriceSale)),
            (s.innerHTML = t$(a, theme.moneyFormat))),
          r &&
            (r.innerHTML =
              0 === n ? window.theme.strings.free : t$(n, theme.moneyFormat));
      }),
        this.hasUnitPricing && this.updateProductUnits(t);
    }
    updateProductUnits(t) {
      let e = t.variant,
        i = t.plan,
        s = null;
      if (
        (e && e.unit_price && (s = e.unit_price),
        i &&
          i.allocation &&
          i.allocation.unit_price &&
          (s = i.allocation.unit_price),
        s)
      ) {
        let r = this.getBaseUnit(e),
          o = t$(s, theme.moneyFormat);
        (this.container.querySelector(iy.unitPrice).innerHTML = o),
          (this.container.querySelector(iy.unitBase).innerHTML = r),
          this.container
            .querySelector(iy.unitWrapper)
            .classList.remove(iS.hidden);
      } else
        this.container.querySelector(iy.unitWrapper).classList.add(iS.hidden);
    }
    updateSku(t) {
      this.skuWrapper &&
        (this.skuWrapper.innerHTML = `${theme.strings.sku}: ${t.variant.sku}`);
    }
    fireHookEvent(t) {
      let e = t.variant;
      this.container.dispatchEvent(
        new CustomEvent("theme:variant:change", {
          detail: { variant: e },
          bubbles: !0,
        })
      );
    }
    setProductState(t) {
      let e = t.variant,
        i = t.plan,
        s = {
          available: !0,
          soldOut: !1,
          onSale: !1,
          showUnitPrice: !1,
          requiresPlan: !1,
          hasPlan: !1,
          planPerDelivery: !1,
          planSale: !1,
        };
      return (
        e && (!e.requires_selling_plan || i)
          ? (e.available || (s.soldOut = !0),
            e.compare_at_price > e.price && (s.onSale = !0),
            e.unit_price && (s.showUnitPrice = !0),
            this.product &&
              this.product.requires_selling_plan &&
              (s.requiresPlan = !0),
            i &&
              this.subPrices &&
              ((s.hasPlan = !0),
              i.allocation.per_delivery_price !== i.allocation.price &&
                (s.planPerDelivery = !0),
              e.price > i.allocation.price && (s.planSale = !0)))
          : (s.available = !1),
        s
      );
    }
    updateProductImage(t) {
      let e = t.dataset.variant;
      if (e && e.featured_media) {
        let i = this.container.querySelector(
          `[${iw.imageId}="${e.featured_media.id}"]`
        );
        if (i) {
          let s = i.getAttribute(iw.mediaId),
            r = g();
          if (
            (i.dispatchEvent(
              new CustomEvent("theme:media:select", {
                bubbles: !0,
                detail: { id: s },
              })
            ),
            r &&
              !this.productImages.hasAttribute(iw.faderDesktop) &&
              this.variantImageScroll)
          ) {
            let o = i.getBoundingClientRect().top;
            document.dispatchEvent(
              new CustomEvent("theme:tooltip:close", {
                bubbles: !1,
                detail: { hideTransition: !1 },
              })
            ),
              ec(o);
          }
          r ||
            this.productImages.hasAttribute(iw.faderMobile) ||
            this.productMediaList.scrollTo({ left: i.offsetLeft });
        }
      }
    }
    updateLegend(t) {
      let e = t.variant;
      if (e) {
        let i = this.container.querySelectorAll(iy.optionValue);
        i.length &&
          i.forEach((t) => {
            let i = t.closest(iy.optionPosition);
            if (i) {
              let s = i.getAttribute(iw.optionPosition),
                r = parseInt(s, 10) - 1,
                o = e.options[r];
              t.innerHTML = o;
            }
          });
      }
    }
  }
  let iE = {
      open: "[data-popup-open]",
      close: "[data-popup-close]",
      focusable:
        'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
    },
    ik = { closing: "closing" };
  class iA {
    constructor(t, e, i = !0, s = !0) {
      (this.popup = t),
        (this.holder = e),
        (this.a11y = M),
        (this.isAnimating = !1),
        (this.showModal = i),
        (this.enableScrollLock = s),
        (this.buttonPopupOpen = this.holder?.querySelector(iE.open)),
        this.popupEvents();
    }
    popupOpen() {
      this.popup &&
        ((this.isAnimating = !0),
        this.showModal && "function" == typeof this.popup.showModal
          ? this.popup.showModal()
          : this.showModal || "function" != typeof this.popup.show
          ? this.popup.setAttribute("open", "")
          : this.popup.show(),
        this.popup.removeAttribute("inert"),
        this.popup.setAttribute("aria-hidden", !1),
        this.popup.focus(),
        this.enableScrollLock &&
          document.dispatchEvent(
            new CustomEvent("theme:scroll:lock", { bubbles: !0 })
          ),
        D(this.popup).then(() => {
          (this.isAnimating = !1),
            this.enableScrollLock && this.a11y.trapFocus(this.popup);
          let t =
            this.popup.querySelector("[autofocus]") ||
            this.popup.querySelector(iE.focusable);
          t?.focus();
        }));
    }
    popupClose() {
      if (
        !(this.isAnimating || !this.popup || this.popup.hasAttribute("inert"))
      ) {
        if (!this.popup.hasAttribute(ik.closing)) {
          this.popup.setAttribute(ik.closing, ""),
            (this.isAnimating = !0),
            D(this.popup).then(() => {
              (this.isAnimating = !1), this.popupClose();
            });
          return;
        }
        "function" == typeof this.popup.close
          ? this.popup.close()
          : (this.popup.removeAttribute("open"),
            this.popup.setAttribute("aria-hidden", !0)),
          this.popupCloseActions();
      }
    }
    popupCloseActions() {
      !this.popup.hasAttribute("inert") &&
        (this.popup.setAttribute("inert", ""),
        this.popup.setAttribute("aria-hidden", !0),
        this.popup.removeAttribute(ik.closing),
        !ir() &&
          this.enableScrollLock &&
          document.dispatchEvent(
            new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
          ),
        this.popup.dispatchEvent(
          new CustomEvent("theme:popup:onclose", { bubbles: !1 })
        ),
        this.enableScrollLock &&
          (this.a11y.removeTrapFocus(), this.a11y.autoFocusLastElement()));
    }
    popupEvents() {
      if (!this.popup) return;
      this.buttonPopupOpen?.addEventListener("click", (t) => {
        t.preventDefault(),
          this.popupOpen(),
          (window.a11y.lastElement = this.buttonPopupOpen);
      });
      let t = this.popup.querySelectorAll(iE.close);
      t.length &&
        t.forEach((t) => {
          t.addEventListener("click", (t) => {
            t.preventDefault(), this.popupClose();
          });
        }),
        this.showModal &&
          this.popup.addEventListener("click", (t) => {
            "DIALOG" === t.target.nodeName &&
              "click" === t.type &&
              this.popupClose();
          }),
        this.popup.addEventListener("keydown", (t) => {
          "Escape" === t.code && (t.preventDefault(), this.popupClose());
        }),
        this.popup.addEventListener("close", () => this.popupCloseActions());
    }
  }
  let iC = { dialog: "dialog" };
  class iq extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      new iA(this.querySelector(iC.dialog), this, !0, !0);
    }
  }
  (window.ProductModel = {
    loadShopifyXR() {
      Shopify.loadFeatures([
        {
          name: "shopify-xr",
          version: "1.0",
          onLoad: this.setupShopifyXR.bind(this),
        },
      ]);
    },
    setupShopifyXR(t) {
      if (!t) {
        if (!window.ShopifyXR) {
          document.addEventListener("shopify_xr_initialized", () =>
            this.setupShopifyXR()
          );
          return;
        }
        document.querySelectorAll('[id^="ModelJSON-"]').forEach((t) => {
          window.ShopifyXR.addModels(JSON.parse(t.textContent)), t.remove();
        }),
          window.ShopifyXR.setupXRElements();
      }
    },
  }),
    window.addEventListener("DOMContentLoaded", () => {
      window.ProductModel && window.ProductModel.loadShopifyXR();
    });
  let i$ = {
      addToCart: "[data-add-to-cart]",
      productImage: "[data-product-image]",
      productJson: "[data-product-json]",
      form: "[data-product-form]",
      cartBar: "#cart-bar",
      productNotificationPopupButton: "[data-popup-open]",
      productSubmitAdd: ".product__submit__add",
      formWrapper: "[data-form-wrapper]",
      productVariants: "[data-product-variants]",
      slider: "[data-slider]",
    },
    iT = {
      expanded: "is-expanded",
      visible: "is-visible",
      loading: "is-loading",
      added: "is-added",
    },
    ix = {
      cartBarEnabled: "data-cart-bar-enabled",
      cartBarAdd: "data-add-to-cart-bar",
      cartBarScroll: "data-cart-bar-scroll",
      cartBarProductNotification: "data-cart-bar-product-notification",
      sectionId: "data-section-id",
      sliderIndex: "data-slider-index",
    },
    iP = {};
  class iI {
    constructor(t) {
      (this.section = t),
        (this.container = t.container),
        (this.id = this.container.getAttribute(ix.sectionId)),
        (this.sliders = this.container.querySelectorAll(i$.slider)),
        (this.slider = []),
        (this.formWrapper = this.container.querySelector(i$.formWrapper)),
        (this.cartBarEnabled = this.container.hasAttribute(ix.cartBarEnabled)),
        (this.cartBar = this.container.querySelector(i$.cartBar)),
        (this.setCartBarHeight = this.setCartBarHeight.bind(this)),
        (this.scrollToTop = this.scrollToTop.bind(this)),
        (this.toggleCartBarOnScroll = this.toggleCartBarOnScroll.bind(this)),
        (this.unlockTimer = 0),
        (this.accessibility = M);
      let e = this.container.querySelector(i$.productJson);
      if ((e && !e.innerHTML) || !e) return;
      let i = JSON.parse(e.innerHTML).handle,
        s = {};
      i && (s = { handle: i }),
        Shopify.Products.recordRecentlyViewed(s),
        (this.form = this.container.querySelector(i$.form)),
        this.sliders.length &&
          this.sliders.forEach((t, e) => {
            t.setAttribute(ix.sliderIndex, e),
              this.slider.push(new en(this.container, t));
          }),
        this.cartBarEnabled &&
          (this.initCartBar(),
          this.setCartBarHeight(),
          document.addEventListener("theme:scroll", this.toggleCartBarOnScroll),
          document.addEventListener("theme:resize", this.setCartBarHeight));
    }
    initCartBar() {
      (this.cartBarBtns = this.cartBar.querySelectorAll(i$.productSubmitAdd)),
        this.cartBarBtns.length > 0 &&
          this.cartBarBtns.forEach((t) => {
            t.addEventListener("click", (t) => {
              t.preventDefault(),
                t.currentTarget.hasAttribute(ix.cartBarAdd)
                  ? (this.cartBarEnabled &&
                      (t.currentTarget.classList.add(iT.loading),
                      t.currentTarget.setAttribute("disabled", "disabled")),
                    this.form
                      .querySelector(i$.addToCart)
                      .dispatchEvent(new Event("click", { bubbles: !0 })))
                  : t.currentTarget.hasAttribute(ix.cartBarScroll)
                  ? this.scrollToTop()
                  : t.currentTarget.hasAttribute(
                      ix.cartBarProductNotification
                    ) &&
                    this.form
                      .querySelector(i$.productNotificationPopupButton)
                      ?.dispatchEvent(new Event("click"));
            }),
              t.hasAttribute(ix.cartBarAdd) &&
                document.addEventListener(
                  "theme:product:add-error",
                  this.scrollToTop
                );
          }),
        this.setCartBarHeight();
    }
    scrollToTop() {
      let t = this.container.querySelector(i$.productVariants),
        e = g() ? this.container : t || this.form,
        i = e.getBoundingClientRect().top;
      ec(g() ? i : i - 10);
    }
    toggleCartBarOnScroll() {
      let t = window.scrollY,
        e =
          theme.variables.productPageSticky && this.formWrapper
            ? this.formWrapper
            : this.form;
      if (e && this.cartBar) {
        let i = e.offsetTop,
          s = e.offsetHeight;
        this.cartBar.classList.toggle(iT.visible, t > i + s);
      }
    }
    setCartBarHeight() {
      let t = this.cartBar.offsetHeight;
      document.documentElement.style.setProperty("--cart-bar-height", `${t}px`);
    }
    onUnload() {
      document.removeEventListener("theme:product:add-error", this.scrollToTop),
        this.cartBarEnabled &&
          (document.removeEventListener(
            "theme:scroll",
            this.toggleCartBarOnScroll
          ),
          document.removeEventListener("theme:resize", this.setCartBarHeight));
    }
    onBlockSelect(t) {
      let e = t.srcElement.closest(i$.slider);
      if (e && this.slider.length) {
        let i = e.hasAttribute(ix.sliderIndex)
          ? e.getAttribute(ix.sliderIndex)
          : 0;
        if (!this.slider[i]) return;
        this.slider[i].onBlockSelect(t);
      }
    }
    onBlockDeselect(t) {
      let e = t.srcElement.closest(i$.slider);
      if (e && this.slider.length) {
        let i = e.hasAttribute(ix.sliderIndex)
          ? e.getAttribute(ix.sliderIndex)
          : 0;
        if (!this.slider[i]) return;
        this.slider[i].onBlockDeselect(t);
      }
    }
  }
  t4("product", [
    {
      onLoad() {
        iP[this.id] = new iI(this);
      },
      onUnload(t) {
        iP[this.id].onUnload(t);
      },
      onBlockSelect(t) {
        iP[this.id].onBlockSelect(t);
      },
      onBlockDeselect(t) {
        iP[this.id].onBlockDeselect(t);
      },
    },
    ei,
    is,
    {
      onLoad() {
        ip[this.id] = new im(this);
      },
      onUnload() {
        ip[this.id].onUnload();
      },
    },
  ]),
    customElements.get("product-form") ||
      customElements.define("product-form", iL),
    customElements.get("product-modal") ||
      customElements.define("product-modal", iq),
    customElements.get("product-model") ||
      customElements.define(
        "product-model",
        class t extends ta {
          constructor() {
            super();
          }
          loadContent() {
            super.loadContent(),
              Shopify.loadFeatures([
                {
                  name: "model-viewer-ui",
                  version: "1.0",
                  onLoad: this.setupModelViewerUI.bind(this),
                },
              ]);
          }
          setupModelViewerUI(t) {
            t ||
              (this.modelViewerUI = new Shopify.ModelViewerUI(
                this.querySelector("model-viewer")
              ));
          }
        }
      ),
    customElements.get("product-siblings") ||
      customElements.define("product-siblings", e5),
    customElements.get("radio-swatch") ||
      customElements.define("radio-swatch", eJ);
  let i_ = {
      apiRelatedProductsTemplate: "[data-api-related-template]",
      relatedSection: "[data-related-section]",
      relatedProduct: "[data-grid-item]",
      recentlyViewed: "[data-recent-wrapper]",
      recentlyViewedWrapper: "[data-recently-viewed-wrapper]",
      section: "[data-section-type]",
      productItem: ".product-item",
      slider: "grid-slider",
    },
    iH = {
      limit: "data-limit",
      minimum: "data-minimum",
      productId: "data-product-id",
    },
    iB = { isHidden: "is-hidden", gridMobileSlider: "grid--mobile-slider" },
    iO = {};
  class iM {
    constructor(t) {
      (this.section = t),
        (this.sectionId = t.id),
        (this.container = t.container),
        (this.relatedItems = 0),
        this.init();
    }
    init() {
      this.loadRelatedProducts(), this.loadRecentlyViewedProducts();
    }
    loadRelatedProducts() {
      let t = this.container.querySelector(i_.relatedSection);
      if (!t) return;
      let e = t.getAttribute(iH.productId),
        i = t.getAttribute(iH.limit),
        s = `${window.theme.routes.product_recommendations_url}?section_id=api-product-recommendation&limit=${i}&product_id=${e}&intent=related`;
      fetch(s)
        .then((t) => t.text())
        .then((e) => this.handleRelatedProductsResponse(e, t))
        .catch(() => this.hideSection(t));
    }
    handleRelatedProductsResponse(t, e) {
      let i = document.createElement("div");
      i.innerHTML = new DOMParser()
        .parseFromString(t, "text/html")
        .querySelector(i_.apiRelatedProductsTemplate).innerHTML;
      let s = i.querySelectorAll(i_.relatedProduct).length;
      if (s > 0) {
        (e.innerHTML = i.innerHTML), (this.relatedItems = s);
        let r = parseInt(e.style.getPropertyValue("--COLUMNS-MOBILE"));
        if (0 === r) {
          let o = e.querySelector(i_.relatedProduct);
          o.parentElement.classList.add(iB.gridMobileSlider);
        }
      } else this.hideSection(e);
      this.updateVisibility();
    }
    loadRecentlyViewedProducts() {
      let t = this.container.querySelector(i_.recentlyViewed),
        e = parseInt(t.getAttribute(iH.limit)) || 4,
        i = parseInt(t.getAttribute(iH.minimum)) || 4;
      Shopify.Products.showRecentlyViewed({
        howManyToShow: e,
        wrapperId: `recently-viewed-products-${this.sectionId}`,
        section: this.section,
        target: "api-product-grid-item",
        onComplete: (e, s) => this.handleRecentlyViewedResponse(e, s, t, i),
      });
    }
    handleRecentlyViewedResponse(t, e, i, s) {
      let r = e.container;
      if (!r) return;
      let o = r.querySelector(i_.recentlyViewedWrapper),
        a = t.querySelectorAll(i_.productItem),
        n = i.querySelector(i_.slider),
        l = !o && a.length > 0,
        c = o && a.length >= s;
      (l || c) &&
        (c && o.classList.remove(iB.isHidden),
        i.classList.remove(iB.isHidden),
        i.dispatchEvent(new CustomEvent("theme:tab:check", { bubbles: !0 })),
        n &&
          n.dispatchEvent(
            new CustomEvent("theme:grid-slider:init", { bubbles: !0 })
          )),
        this.updateVisibility();
    }
    hideSection(t) {
      t.dispatchEvent(new CustomEvent("theme:tab:hide", { bubbles: !0 }));
    }
    updateVisibility() {
      let t = Shopify.Products.getConfig().howManyToShow,
        e = t < 1 && this.relatedItems < 1;
      this.container.classList.toggle(iB.isHidden, e);
    }
  }
  t4("related", [
    {
      onLoad() {
        iO[this.id] = new iM(this);
      },
    },
    is,
  ]),
    t4("reviews", [el]);
  let iD = {},
    i8 = {
      sliderLogos: "[data-slider-logos]",
      sliderText: "[data-slider-text]",
      slide: "[data-slide]",
    },
    i9 = {
      isSelected: "is-selected",
      isInitialized: "is-initialized",
      flickityEnabled: "flickity-enabled",
    },
    iF = { slideData: "data-slide", slideIndex: "data-slide-index" };
  class iN {
    constructor(t) {
      (this.container = t.container),
        (this.slideshowNav = this.container.querySelector(i8.sliderLogos)),
        (this.slideshowText = this.container.querySelector(i8.sliderText)),
        (this.setSlideshowNavStateOnResize = () => this.setSlideshowNavState()),
        (this.flkty = null),
        (this.flktyNav = null),
        (this.logoSlides = this.slideshowNav.querySelectorAll(i8.slide)),
        (this.logoSlidesWidth = this.getSlidesWidth()),
        this.initSlideshowText(),
        this.initSlideshowNav();
    }
    getSlidesWidth() {
      let t = this.logoSlides.length;
      return 200 * t;
    }
    initSlideshowText() {
      this.slideshowText &&
        (this.flkty = new i(this.slideshowText, {
          fade: !0,
          autoPlay: !1,
          prevNextButtons: !1,
          cellAlign: "left",
          contain: !0,
          pageDots: !1,
          wrapAround: !1,
          selectedAttraction: 0.2,
          friction: 0.6,
          draggable: !1,
          accessibility: !1,
          on: {
            ready: () => this.sliderAccessibility(),
            change: () => this.sliderAccessibility(),
          },
        }));
    }
    sliderAccessibility() {
      let t = this.slideshowText.querySelectorAll(
        `${i8.slide} a, ${i8.slide} button`
      );
      t.length &&
        t.forEach((t) => {
          let e = t.closest(i8.slide);
          if (e) {
            let i = e.classList.contains(i9.isSelected) ? 0 : -1;
            t.setAttribute("tabindex", i);
          }
        });
    }
    initSlideshowNav() {
      this.slideshowNav &&
        (this.logoSlides.length &&
          this.logoSlides.forEach((t) => {
            t.addEventListener("click", () => {
              let e = parseInt(t.getAttribute(iF.slideIndex)),
                i = this.slideshowNav.classList.contains(i9.flickityEnabled);
              if ((this.flkty && this.flkty.select(e), i))
                this.flktyNav.select(e),
                  this.slideshowNav.classList.contains(i9.isSelected) ||
                    this.flktyNav.playPlayer();
              else {
                let s = this.slideshowNav.querySelector(`.${i9.isSelected}`);
                s && s.classList.remove(i9.isSelected),
                  t.classList.add(i9.isSelected);
              }
            });
          }),
        this.setSlideshowNavState(),
        document.addEventListener(
          "theme:resize",
          this.setSlideshowNavStateOnResize
        ));
    }
    setSlideshowNavState() {
      let t = this.slideshowNav.classList.contains(i9.flickityEnabled);
      if (this.logoSlidesWidth > p()) {
        if (!t) {
          this.slideshowNav.classList.add(i9.isInitialized);
          let i = this.slideshowNav.querySelector(`.${i9.isSelected}`);
          i && i.classList.remove(i9.isSelected),
            this.logoSlides[0].classList.add(i9.isSelected),
            !this.flktyNav &&
              ((this.flktyNav = new e(this.slideshowNav, {
                autoPlay: 4e3,
                prevNextButtons: !1,
                contain: !1,
                pageDots: !1,
                wrapAround: !0,
                watchCSS: !0,
                selectedAttraction: 0.05,
                friction: 0.8,
                initialIndex: 0,
              })),
              this.flktyNav.on("deactivate", () => {
                this.slideshowNav
                  .querySelector(i8.slide)
                  .classList.add(i9.isSelected),
                  this.flkty && this.flkty.select(0);
              }),
              this.flkty &&
                (this.flkty.select(0),
                this.flktyNav.on("change", (t) => this.flkty.select(t))));
        }
      } else t && this.slideshowNav.classList.remove(i9.isInitialized);
    }
    onBlockSelect(t) {
      if (!this.slideshowNav) return;
      let e = this.slideshowNav.querySelector(
          `[${iF.slideData}="${t.detail.blockId}"]`
        ),
        i = parseInt(e.getAttribute(iF.slideIndex));
      this.slideshowNav.classList.contains(i9.flickityEnabled)
        ? (this.flktyNav.select(i),
          this.flktyNav.stopPlayer(),
          this.slideshowNav.classList.add(i9.isSelected))
        : e.dispatchEvent(new Event("click"));
    }
    onBlockDeselect() {
      this.slideshowNav &&
        this.slideshowNav.classList.contains(i9.flickityEnabled) &&
        (this.flktyNav.playPlayer(),
        this.slideshowNav.classList.remove(i9.isSelected));
    }
    onUnload() {
      document.removeEventListener(
        "theme:resize",
        this.setSlideshowNavStateOnResize
      );
    }
  }
  t4("logos", [
    {
      onLoad() {
        iD[this.id] = new iN(this);
      },
      onUnload(t) {
        iD[this.id].onUnload(t);
      },
      onBlockSelect(t) {
        iD[this.id].onBlockSelect(t);
      },
      onBlockDeselect(t) {
        iD[this.id].onBlockDeselect(t);
      },
    },
  ]),
    t4("slideshow", [el]),
    t4("custom-content", [el, eg]);
  let iW = {
      largePromo: "[data-large-promo]",
      largePromoInner: "[data-large-promo-inner]",
      cartBar: "cart-bar",
      newsletterPopup: "[data-newsletter]",
      newsletterPopupHolder: "[data-newsletter-holder]",
      newsletterHeading: "[data-newsletter-heading]",
      newsletterField: "[data-newsletter-field]",
      promoPopup: "[data-promo-text]",
      newsletterForm: "[data-newsletter-form]",
      delayAttribite: "data-popup-delay",
      cookieNameAttribute: "data-cookie-name",
      dataTargetReferrer: "data-target-referrer",
    },
    iR = {
      hidden: "hidden",
      hasValue: "has-value",
      cartBarVisible: "cart-bar-visible",
      isVisible: "is-visible",
      success: "has-success",
      selected: "selected",
      hasBlockSelected: "has-block-selected",
      mobile: "mobile",
      desktop: "desktop",
      bottom: "bottom",
    },
    iV = {};
  class iU {
    constructor(t, e, i) {
      if (
        ((this.element = e),
        (this.delay = t.getAttribute(iW.delayAttribite)),
        (this.isSubmitted =
          -1 !== window.location.href.indexOf("accepts_marketing") ||
          -1 !== window.location.href.indexOf("customer_posted=true")),
        (this.popupActions = i),
        (this.showPopupOnScrollEvent = () => this.showPopupOnScroll()),
        ("always" === this.delay || this.isSubmitted) && this.always(),
        this.delay && this.delay.includes("delayed") && !this.isSubmitted)
      ) {
        let s = this.delay.includes("_")
          ? parseInt(this.delay.split("_")[1])
          : 10;
        this.delayed(s);
      }
      "bottom" !== this.delay || this.isSubmitted || this.bottom(),
        "idle" !== this.delay || this.isSubmitted || this.idle();
    }
    always() {
      this.popupActions.popupOpen();
    }
    delayed(t = 10) {
      setTimeout(() => {
        this.popupActions.popupOpen();
      }, 1e3 * t);
    }
    idle() {
      let t = 0,
        e = [
          "mousemove",
          "mousedown",
          "click",
          "touchmove",
          "touchstart",
          "touchend",
          "keydown",
          "keypress",
        ],
        i = ["load", "resize", "scroll"],
        s = () => {
          (t = setTimeout(() => {
            (t = 0), this.popupActions.popupOpen();
          }, 6e4)),
            e.forEach((t) => {
              document.addEventListener(t, r);
            }),
            i.forEach((t) => {
              window.addEventListener(t, r);
            });
        },
        r = () => {
          t && clearTimeout(t),
            e.forEach((t) => {
              document.removeEventListener(t, r);
            }),
            i.forEach((t) => {
              window.removeEventListener(t, r);
            }),
            s();
        };
      s();
    }
    bottom() {
      document.addEventListener("theme:scroll", this.showPopupOnScrollEvent);
    }
    showPopupOnScroll() {
      window.scrollY + window.innerHeight >= document.body.clientHeight &&
        (this.popupActions.popupOpen(),
        document.removeEventListener(
          "theme:scroll",
          this.showPopupOnScrollEvent
        ));
    }
    onUnload() {
      document.removeEventListener("theme:scroll", this.showPopupOnScrollEvent);
    }
  }
  class iz {
    constructor(t) {
      if (
        ((this.el = t),
        (this.locationPath = location.href),
        !this.el.hasAttribute(iW.dataTargetReferrer))
      )
        return !1;
      this.init();
    }
    init() {
      -1 !==
        this.locationPath.indexOf(
          this.el.getAttribute(iW.dataTargetReferrer)
        ) ||
        window.Shopify.designMode ||
        this.el.parentNode.removeChild(this.el);
    }
  }
  class i0 {
    constructor(t) {
      (this.popup = t),
        (this.modal = this.popup.querySelector(iW.largePromoInner)),
        (this.form = this.popup.querySelector(iW.newsletterForm)),
        (this.cookie = new ed(
          this.popup.getAttribute(iW.cookieNameAttribute),
          "user_has_closed"
        )),
        (this.isTargeted = new iz(this.popup)),
        (this.popupActions = new iA(this.modal, this.modal, !0, !0)),
        (this.a11y = M),
        this.init();
    }
    init() {
      let t = !1 !== this.cookie.read(),
        e = this.popup.classList.contains(iR.mobile),
        i = this.popup.classList.contains(iR.desktop),
        s = !g(),
        r = !0;
      if ((((e && !s) || (i && s)) && (r = !1), !r)) {
        this.a11y.removeTrapFocus(),
          document.dispatchEvent(
            new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
          );
        return;
      }
      (!t || window.Shopify.designMode) &&
        (window.Shopify.designMode ||
          window.location.pathname.endsWith("/challenge") ||
          new iU(this.popup, this.modal, this.popupActions),
        this.form &&
          this.form.classList.contains(iR.success) &&
          this.checkForSuccess(),
        this.modal.addEventListener("theme:popup:onclose", () =>
          this.cookie.write()
        ));
    }
    checkForSuccess() {
      this.popupActions.popupOpen(), this.cookie.write();
    }
    onBlockSelect(t) {
      this.popup.contains(t.target) &&
        (this.popupActions.popupOpen(),
        this.popup.classList.add(iR.selected),
        this.popup.parentNode.classList.add(iR.hasBlockSelected));
    }
    onBlockDeselect(t) {
      this.popup.contains(t.target) &&
        (this.popupActions.popupClose(),
        this.popup.classList.remove(iR.selected),
        this.popup.parentNode.classList.remove(iR.hasBlockSelected));
    }
  }
  class ij {
    constructor(t) {
      (this.popup = t),
        (this.cookie = new ed(
          this.popup.getAttribute(iW.cookieNameAttribute),
          "user_has_closed"
        )),
        (this.isTargeted = new iz(this.popup)),
        (this.popupActions = new iA(this.popup, this.popup, !1, !1)),
        this.init();
    }
    init() {
      let t = !1 !== this.cookie.read();
      (!t || window.Shopify.designMode) &&
        (window.Shopify.designMode
          ? this.popupActions.popupOpen()
          : new iU(this.popup, this.popup, this.popupActions),
        this.popup.addEventListener("theme:popup:onclose", () =>
          this.cookie.write()
        ));
    }
    onSelect() {
      this.popupActions.popupOpen(),
        this.popup.classList.add(iR.selected),
        this.popup.parentNode.classList.add(iR.hasBlockSelected);
    }
    onDeselect() {
      this.popupActions.popupClose(),
        this.popup.classList.remove(iR.selected),
        this.popup.parentNode.classList.remove(iR.hasBlockSelected);
    }
  }
  class i3 {
    constructor(t) {
      (this.popup = t),
        (this.holder = this.popup.querySelector(iW.newsletterPopupHolder)),
        (this.heading = this.popup.querySelector(iW.newsletterHeading)),
        (this.newsletterField = this.popup.querySelector(iW.newsletterField)),
        (this.cookie = new ed(
          this.popup.getAttribute(iW.cookieNameAttribute),
          "newsletter_is_closed"
        )),
        (this.form = this.popup.querySelector(iW.newsletterForm)),
        (this.isTargeted = new iz(this.popup)),
        (this.popupActions = new iA(this.holder, this.holder, !1, !1)),
        (this.resetClassTimer = 0),
        this.init();
    }
    init() {
      let t = !1 !== this.cookie.read(),
        e = -1 !== window.location.search.indexOf("?customer_posted=true"),
        i = [...this.holder.classList].toString(),
        s = i.includes(iR.bottom);
      e && (this.delay = 0),
        (!t || window.Shopify.designMode) &&
          (this.show(),
          this.form.classList.contains(iR.success) && this.checkForSuccess()),
        s && this.observeCartBar();
    }
    show() {
      window.location.pathname.endsWith("/challenge") ||
        (window.Shopify.designMode
          ? this.popupActions.popupOpen()
          : new iU(this.popup, this.holder, this.popupActions)),
        this.showForm(),
        this.inputField(),
        this.holder.addEventListener("theme:popup:onclose", () =>
          this.cookie.write()
        );
    }
    checkForSuccess() {
      this.popupActions.popupOpen(), this.cookie.write();
    }
    observeCartBar() {
      if (((this.cartBar = document.getElementById(iW.cartBar)), !this.cartBar))
        return;
      let t = this.cartBar.classList.contains(iR.isVisible);
      document.body.classList.toggle(iR.cartBarVisible, t);
      let e = (e) => {
        for (let i of e)
          "attributes" === i.type &&
            ((t = i.target.classList.contains(iR.isVisible)),
            document.body.classList.toggle(iR.cartBarVisible, t));
      };
      (this.observer = new MutationObserver(e)),
        this.observer.observe(this.cartBar, {
          attributes: !0,
          childList: !1,
          subtree: !1,
        });
    }
    showForm() {
      this.heading.addEventListener("click", (t) => {
        t.preventDefault(),
          this.heading.classList.add(iR.hidden),
          this.form.classList.remove(iR.hidden),
          this.newsletterField.focus();
      }),
        this.heading.addEventListener("keyup", (t) => {
          "Enter" === t.code && this.heading.dispatchEvent(new Event("click"));
        });
    }
    inputField() {
      let t = () => {
          this.resetClassTimer && clearTimeout(this.resetClassTimer),
            "" !== this.newsletterField.value &&
              this.holder.classList.add(iR.hasValue);
        },
        e = () => {
          this.resetClassTimer && clearTimeout(this.resetClassTimer),
            (this.resetClassTimer = setTimeout(() => {
              this.holder.classList.remove(iR.hasValue);
            }, 2e3));
        };
      this.newsletterField.addEventListener("input", t),
        this.newsletterField.addEventListener("focus", t),
        this.newsletterField.addEventListener("focusout", e);
    }
    onBlockSelect(t) {
      this.popup.contains(t.target) &&
        (this.popupActions.popupOpen(),
        this.popup.classList.add(iR.selected),
        this.popup.parentNode.classList.add(iR.hasBlockSelected));
    }
    onBlockDeselect(t) {
      this.popup.contains(t.target) &&
        (this.popupActions.popupClose(),
        this.popup.classList.remove(iR.selected),
        this.popup.parentNode.classList.remove(iR.hasBlockSelected));
    }
    onUnload() {
      this.observer && this.observer.disconnect();
    }
  }
  t4("popups", [
    {
      onLoad() {
        iV[this.id] = [];
        let t = this.container.querySelectorAll(iW.largePromo);
        t.forEach((t) => {
          iV[this.id].push(new i0(t));
        });
        let e = this.container.querySelectorAll(iW.newsletterPopup);
        e.forEach((t) => {
          iV[this.id].push(new i3(t));
        });
        let i = this.container.querySelectorAll(iW.promoPopup);
        i.forEach((t) => {
          iV[this.id].push(new ij(t));
        });
      },
      onBlockSelect(t) {
        iV[this.id].forEach((e) => {
          "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
        });
      },
      onBlockDeselect(t) {
        iV[this.id].forEach((e) => {
          "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
        });
      },
      onSelect() {
        iV[this.id].forEach((t) => {
          "function" == typeof t.onSelect && t.onSelect();
        });
      },
      onDeselect() {
        iV[this.id].forEach((t) => {
          "function" == typeof t.onDeselect && t.onDeselect();
        });
      },
      onUnload() {
        iV[this.id].forEach((t) => {
          "function" == typeof t.onUnload && t.onUnload();
        });
      },
    },
    eg,
  ]);
  let i2 = {
    modal: "[data-password-modal]",
    loginErrors: "#login_form .errors",
  };
  class iG {
    constructor(t) {
      (this.container = t.container),
        (this.popupActions = new iA(
          this.container.querySelector(i2.modal),
          this.container,
          !0,
          !0
        )),
        this.container.querySelector(i2.loginErrors) &&
          this.popupActions.popupOpen();
    }
  }
  t4("password-template", {
    onLoad() {
      new iG(this);
    },
  }),
    t4("list-collections", [el]),
    t4("columns", [el]),
    t4("newsletter", eg);
  let iJ = {
      scrollToElement: "[data-scroll-to]",
      tooltip: "[data-tooltip]",
      collapsibleTrigger: "[data-collapsible-trigger]",
    },
    iX = {
      open: "open",
      dataScrollTo: "data-scroll-to",
      tooltipStopMousenterValue: "data-tooltip-stop-mouseenter",
    },
    i1 = {};
  class i4 {
    constructor(t) {
      (this.section = t),
        (this.container = t.container),
        (this.scrollToButtons = this.container.querySelectorAll(
          iJ.scrollToElement
        )),
        this.scrollToButtons.length && this.init();
    }
    init() {
      this.scrollToButtons.forEach((t) => {
        t.addEventListener("click", () => {
          let e = this.container.querySelector(t.getAttribute(iX.dataScrollTo));
          e && "A" !== t.tagName && this.scrollToElement(e);
        });
      });
    }
    scrollToElement(t) {
      ec(t.getBoundingClientRect().top + 1);
      let e = t.nextElementSibling.matches("details")
        ? t.nextElementSibling
        : null;
      if (e) {
        let i = e?.querySelector(iJ.collapsibleTrigger),
          s = e.hasAttribute(iX.open);
        s || i?.dispatchEvent(new Event("click"));
      }
      let r = document.querySelectorAll(
        `${iJ.tooltip}:not([${iX.tooltipStopMousenterValue}])`
      );
      r.length &&
        r.forEach((t) => {
          t.setAttribute(iX.tooltipStopMousenterValue, ""),
            setTimeout(() => {
              t.removeAttribute(iX.tooltipStopMousenterValue);
            }, 1e3);
        });
    }
  }
  let i7 = { scrollSpy: "[data-scroll-spy]" },
    iQ = { selected: "is-selected" },
    iY = {
      scrollSpy: "data-scroll-spy",
      mobile: "data-scroll-spy-mobile",
      desktop: "data-scroll-spy-desktop",
      triggerPoint: "data-scroll-trigger-point",
    },
    i5 = {};
  class i6 {
    constructor(t, e) {
      if (
        ((this.container = t),
        (this.elementToSpy = e),
        (this.anchorSelector = `[${iY.scrollSpy}="#${this.elementToSpy.id}"]`),
        (this.anchor = this.container.querySelector(this.anchorSelector)),
        (this.anchorSiblings = this.container.querySelectorAll(
          `[${iY.scrollSpy}]`
        )),
        (this.initialized = !1),
        !this.anchor)
      )
        return;
      (this.triggerPoint = this.anchor.getAttribute(iY.triggerPoint)),
        (this.scrollCallback = () => this.onScroll()),
        (this.toggleScrollObserver = this.toggleScrollObserver.bind(this)),
        this.init();
    }
    init() {
      this.toggleScrollObserver(),
        document.addEventListener(
          "theme:resize:width",
          this.toggleScrollObserver
        );
    }
    toggleScrollObserver() {
      this.isEligible()
        ? this.initialized ||
          (document.addEventListener("theme:scroll", this.scrollCallback),
          (this.initialized = !0))
        : (document.removeEventListener("theme:scroll", this.scrollCallback),
          (this.initialized = !1));
    }
    isEligible() {
      let t = g();
      return (
        (!t && this.anchor.hasAttribute(iY.mobile)) ||
        (t && this.anchor.hasAttribute(iY.desktop)) ||
        (!this.anchor.hasAttribute(iY.desktop) &&
          !this.anchor.hasAttribute(iY.mobile))
      );
    }
    onScroll() {
      this.top = this.elementToSpy.getBoundingClientRect().top;
      let t = Math.round(window.innerHeight),
        e = Math.round(window.scrollY),
        i = Math.round(this.top + e),
        s = this.elementToSpy.offsetHeight;
      i < e + t &&
        !(i + s < e) &&
        this.triggerPointReached() &&
        (this.anchorSiblings.forEach((t) => {
          t.matches(this.anchorSelector) || t.classList.remove(iQ.selected);
        }),
        this.anchor.classList.add(iQ.selected));
    }
    triggerPointReached() {
      let t = !1;
      switch (this.triggerPoint) {
        case "top":
        default:
          t = this.top <= 0;
          break;
        case "middle":
          t = this.top <= window.innerHeight / 2;
          break;
        case "bottom":
          t = this.top <= window.innerHeight;
      }
      return t;
    }
    onUnload() {
      document.removeEventListener(
        "theme:resize:width",
        this.toggleScrollObserver
      ),
        document.removeEventListener("theme:scroll", this.scrollCallback);
    }
  }
  let iK = {
    onLoad() {
      (i5[this.id] = []),
        this.container.querySelectorAll(i7.scrollSpy)?.forEach((t) => {
          let e = this.container.querySelector(t.getAttribute(iY.scrollSpy));
          i5[this.id].push(new i6(this.container, e));
        });
    },
    onUnload() {
      i5[this.id].forEach((t) => {
        "function" == typeof t.onUnload && t.onUnload();
      });
    },
  };
  t4("sidebar", [
    {
      onLoad() {
        i1[this.id] = new i4(this);
      },
    },
    iK,
  ]);
  let iZ = { button: "[data-hover-target]", image: "[data-collection-image]" },
    st = { target: "data-hover-target" },
    se = { visible: "is-visible", selected: "is-selected" },
    si = {};
  class ss {
    constructor(t) {
      (this.container = t.container),
        (this.buttons = this.container.querySelectorAll(iZ.button)),
        this.init();
    }
    init() {
      this.buttons.length &&
        this.buttons.forEach((t) => {
          t.addEventListener("mouseenter", (t) => {
            let e = t.currentTarget.getAttribute(st.target);
            this.updateState(e);
          });
        });
    }
    updateState(t) {
      let e = this.container.querySelector(`[${st.target}="${t}"]`),
        i = this.container.querySelector(`#${t}:not(.${se.visible})`),
        s = this.container.querySelector(`${iZ.button}.${se.selected}`),
        r = this.container.querySelector(`${iZ.image}.${se.visible}`);
      i &&
        g() &&
        (r?.classList.remove(se.visible),
        s?.classList.remove(se.selected),
        i.classList.add(se.visible),
        e.classList.add(se.selected));
    }
    onBlockSelect(t) {
      this.updateState(t.target.id);
    }
  }
  t4("collections-hover", [
    {
      onLoad() {
        si[this.id] = new ss(this);
      },
      onBlockSelect(t) {
        si[this.id].onBlockSelect(t);
      },
    },
    iK,
  ]);
  let sr = {
      image: "[data-featured-image]",
      imagesHolder: "[data-featured-aside]",
      contentHolder: "[data-featured-content]",
      wrapper: "[data-featured-wrapper]",
    },
    so = {
      horizontalScroll: "data-horizontal-scroll",
      horizontalScrollReversed: "data-horizontal-scroll-reversed",
    },
    sa = {};
  class sn {
    constructor(t) {
      (this.container = t.container),
        (this.horizontalScroll = this.container.hasAttribute(
          so.horizontalScroll
        )),
        (this.horizontalScrollReversed = this.container.hasAttribute(
          so.horizontalScrollReversed
        )),
        (this.images = this.container.querySelectorAll(sr.image)),
        (this.imagesHolder = this.container.querySelector(sr.imagesHolder)),
        (this.contentHolder = this.container.querySelector(sr.contentHolder)),
        (this.wrapper = this.container.querySelector(sr.wrapper)),
        (this.requestAnimationSticky = null),
        (this.lastPercent = 0),
        (this.scrollEvent = () => this.scrollEvents()),
        (this.calculateHorizontalPositionEvent = () =>
          this.calculateHorizontalPosition()),
        (this.calculateHeightEvent = () => this.calculateHeight()),
        this.init();
    }
    init() {
      this.horizontalScroll &&
        this.imagesHolder &&
        ((this.requestAnimationSticky = requestAnimationFrame(
          this.calculateHorizontalPositionEvent
        )),
        document.addEventListener("theme:scroll", this.scrollEvent)),
        this.wrapper &&
          this.contentHolder &&
          this.images.length &&
          (this.calculateHeight(),
          document.addEventListener(
            "theme:resize:width",
            this.calculateHeightEvent
          ));
    }
    scrollEvents() {
      this.requestAnimationSticky ||
        (this.requestAnimationSticky = requestAnimationFrame(
          this.calculateHorizontalPositionEvent
        ));
    }
    removeAnimationFrame() {
      this.requestAnimationSticky &&
        (cancelAnimationFrame(this.requestAnimationSticky),
        (this.requestAnimationSticky = null));
    }
    calculateHorizontalPosition() {
      let t = window.scrollY + this.headerHeight,
        e = t + window.innerHeight,
        i = this.imagesHolder.offsetTop,
        s = this.imagesHolder.offsetHeight,
        r = i + s + this.headerHeight,
        o = s - (window.innerHeight - this.headerHeight),
        a = this.horizontalScrollReversed ? 1 : -1,
        n = 0;
      (n = t >= i && e <= r ? ((t - i) / o) * 100 : t < i ? 0 : 100),
        (n *= this.images.length - 1),
        this.container.style.setProperty("--translateX", `${n * a}%`),
        this.lastPercent !== n
          ? (this.requestAnimationSticky = requestAnimationFrame(
              this.calculateHorizontalPositionEvent
            ))
          : this.requestAnimationSticky && this.removeAnimationFrame(),
        (this.lastPercent = n);
    }
    calculateHeight() {
      let { stickyHeaderHeight: t } = a();
      this.container.style.removeProperty("--min-height"),
        this.container.style.setProperty(
          "--min-height",
          `${this.wrapper.offsetHeight + this.contentHolder.offsetHeight}px`
        ),
        (this.headerHeight = t);
    }
    onUnload() {
      this.horizontalScroll &&
        this.imagesHolder &&
        document.removeEventListener(
          "theme:scroll",
          this.calculateHorizontalPositionEvent
        ),
        this.wrapper &&
          this.contentHolder &&
          this.images.length &&
          document.removeEventListener(
            "theme:resize:width",
            this.calculateHeightEvent
          );
    }
  }
  t4("featured-product", [
    {
      onLoad() {
        sa[this.id] = new sn(this);
      },
      onUnload(t) {
        sa[this.id].onUnload(t);
      },
    },
  ]);
  let sl = {};
  document.addEventListener("DOMContentLoaded", function () {
    t7("*");
    let t = document.querySelector("[data-scroll-top-button]");
    t &&
      (t.addEventListener("click", () => {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      }),
      document.addEventListener("theme:scroll", () => {
        t.classList.toggle("is-visible", window.scrollY > window.innerHeight);
      })),
      window.self !== window.top &&
        document.querySelector("html").classList.add("iframe");
    "scrollBehavior" in document.documentElement.style ||
      (function t(e = {}) {
        if ((e.type || (e.type = "json"), e.url))
          return sl[e.url]
            ? sl[e.url]
            : (function t(e, i) {
                let s = new Promise((t, s) => {
                  if ("text" === i)
                    fetch(e)
                      .then((t) => t.text())
                      .then((e) => {
                        t(e);
                      })
                      .catch((t) => {
                        s(t);
                      });
                  else {
                    var r, o, a;
                    let n, l, c;
                    (r = e),
                      (o = function () {
                        t();
                      }),
                      (a = function () {
                        s();
                      }),
                      (n = document.getElementsByTagName("head")[0]),
                      (l = !1),
                      ((c = document.createElement("script")).src = r),
                      (c.onload = c.onreadystatechange =
                        function () {
                          l ||
                          (this.readyState &&
                            "loaded" != this.readyState &&
                            "complete" != this.readyState)
                            ? a()
                            : ((l = !0), o());
                        }),
                      n.appendChild(c);
                  }
                });
                return (sl[e] = s), s;
              })(e.url, e.type);
        if (e.json)
          return sl[e.json]
            ? Promise.resolve(sl[e.json])
            : window
                .fetch(e.json)
                .then((t) => t.json())
                .then((t) => ((sl[e.json] = t), t));
        if (!e.name) return Promise.reject();
        {
          let i = "".concat(e.name, e.version);
          return sl[i]
            ? sl[i]
            : (function t(e) {
                let i = "".concat(e.name, e.version),
                  s = new Promise((t, i) => {
                    try {
                      window.Shopify.loadFeatures([
                        {
                          name: e.name,
                          version: e.version,
                          onLoad(e) {
                            var s, r, o;
                            (s = t), (r = i), (o = e), o ? r(o) : s();
                          },
                        },
                      ]);
                    } catch (s) {
                      i(s);
                    }
                  });
                return (sl[i] = s), s;
              })(e);
        }
      })({ url: window.theme.assets.smoothscroll });
  }),
    window.navigator.cookieEnabled &&
      (document.documentElement.className =
        document.documentElement.className.replace(
          "supports-no-cookies",
          "supports-cookies"
        ));
})(themeVendor.ScrollLock, themeVendor.Flickity, themeVendor.FlickityFade);
